{
  "schemaVersion": 1,
  "generated": "2026-09-02T01:06:49.936Z",
  "about": {
    "name": "Zoned Energy Estimator for Labs",
    "summary": "Zone energy intensities for a 115,000 sf STEM laboratory prototype, simulated in IES:VE in 2019 and allocated to zones by flow share. For early planning and proposal work: the output conveys ideas, it does not predict savings.",
    "study": "Quantifying Zoned Energy Approaches for Academic Science Buildings, I2SL 2019",
    "authors": [
      "Rishi Nandi, Perkins & Will",
      "Patrick Pease, Arup"
    ]
  },
  "units": {
    "energy": "MBtu/yr",
    "intensity": "kBtu/sf/yr",
    "area": "sf",
    "carbon": "MT/yr",
    "cost": "USD/yr"
  },
  "zones": [
    {
      "id": "auditorium",
      "label": "Auditorium"
    },
    {
      "id": "atrium",
      "label": "Atrium"
    },
    {
      "id": "boh",
      "label": "Back of house"
    },
    {
      "id": "cafe-kitchen",
      "label": "Café kitchen"
    },
    {
      "id": "computational",
      "label": "Computational"
    },
    {
      "id": "office",
      "label": "Office"
    },
    {
      "id": "restroom",
      "label": "Restroom"
    },
    {
      "id": "classroom",
      "label": "Classroom"
    },
    {
      "id": "corridor",
      "label": "Corridor"
    },
    {
      "id": "mri-lab",
      "label": "MRI lab"
    },
    {
      "id": "nmr-lab",
      "label": "NMR lab"
    },
    {
      "id": "core-lab",
      "label": "Core lab"
    },
    {
      "id": "instruction-lab",
      "label": "Instruction lab"
    },
    {
      "id": "open-lab-bio",
      "label": "Open lab — biology"
    },
    {
      "id": "open-lab-chem",
      "label": "Open lab — chemistry"
    },
    {
      "id": "open-lab-general",
      "label": "Open lab — general"
    },
    {
      "id": "support-lab-bio",
      "label": "Support lab — biology"
    },
    {
      "id": "support-lab-chem",
      "label": "Support lab — chemistry"
    },
    {
      "id": "support-lab-general",
      "label": "Support lab — general"
    },
    {
      "id": "write-up",
      "label": "Write-up"
    },
    {
      "id": "vivarium",
      "label": "Vivarium"
    }
  ],
  "fanGroups": [
    {
      "id": "auditorium",
      "label": "Auditorium"
    },
    {
      "id": "general",
      "label": "General / low energy"
    },
    {
      "id": "lab",
      "label": "Lab / high energy"
    },
    {
      "id": "special-lab",
      "label": "Special lab"
    },
    {
      "id": "vivarium",
      "label": "Vivarium"
    }
  ],
  "endUses": [
    {
      "id": "plug",
      "label": "Plug & process",
      "column": "roomElectricity",
      "fuel": "electricity",
      "service": "process"
    },
    {
      "id": "fans",
      "label": "Fans",
      "column": "fanElectricity",
      "fuel": "electricity",
      "service": "air"
    },
    {
      "id": "chillers",
      "label": "Chillers",
      "column": "chillerElectricity",
      "fuel": "electricity",
      "service": "cooling"
    },
    {
      "id": "chw-pumps",
      "label": "CHW pumps",
      "column": "chwPumpElectricity",
      "fuel": "electricity",
      "service": "cooling"
    },
    {
      "id": "heating-electric",
      "label": "Heat recovery & HHW pumps",
      "column": "heatingElectricity",
      "fuel": "electricity",
      "service": "heating"
    },
    {
      "id": "boilers",
      "label": "Boilers",
      "column": "heatingGas",
      "fuel": "gas",
      "service": "heating"
    }
  ],
  "plantItems": [
    {
      "id": "chillers",
      "label": "Chillers + Heat Rejection",
      "service": "cooling",
      "fuel": "electricity"
    },
    {
      "id": "chwPumps",
      "label": "CHW Pumps",
      "service": "cooling",
      "fuel": "electricity"
    },
    {
      "id": "hhwPumps",
      "label": "HHW Pumps",
      "service": "heating",
      "fuel": "electricity"
    },
    {
      "id": "labFans",
      "label": "Lab/High Energy Fans",
      "service": "air",
      "fuel": "electricity"
    },
    {
      "id": "hrcHeating",
      "label": "HRC Heating",
      "service": "heating",
      "fuel": "electricity"
    },
    {
      "id": "generalFans",
      "label": "General/Low Energy Fans",
      "service": "air",
      "fuel": "electricity"
    },
    {
      "id": "vivariumFans",
      "label": "Vivarium Elec",
      "service": "air",
      "fuel": "electricity"
    },
    {
      "id": "specialLabFans",
      "label": "Special Lab Elec",
      "service": "air",
      "fuel": "electricity"
    },
    {
      "id": "auditoriumFans",
      "label": "Auditorium Elec",
      "service": "air",
      "fuel": "electricity"
    },
    {
      "id": "dhwBoilers",
      "label": "DHW Boilers",
      "service": "dhw",
      "fuel": "gas"
    },
    {
      "id": "hhwBoilers",
      "label": "HHW Boilers",
      "service": "heating",
      "fuel": "gas"
    }
  ],
  "zoneColumns": [
    {
      "key": "area",
      "header": "Area",
      "unit": "sf"
    },
    {
      "key": "roomElectricity",
      "header": "Room Elec",
      "unit": "MBtu"
    },
    {
      "key": "airFlow",
      "header": "Air Flow",
      "unit": "cfm-hours"
    },
    {
      "key": "fanShare",
      "header": "Fan %",
      "unit": "fraction"
    },
    {
      "key": "fanElectricity",
      "header": "Fan Elec",
      "aliases": [
        "Fan Energy"
      ],
      "unit": "MBtu"
    },
    {
      "key": "reheatFlow",
      "header": "Reheat HHW Flow",
      "unit": "k-cuft"
    },
    {
      "key": "mainHeatCoilFlow",
      "header": "Main Heat Coil Flow",
      "unit": "k-cuft"
    },
    {
      "key": "heatingShare",
      "header": "Heating %",
      "unit": "fraction"
    },
    {
      "key": "chwFlow",
      "header": "CHW Flow",
      "unit": "k-cuft"
    },
    {
      "key": "mainCoolCoilFlow",
      "header": "Main Cool Coil Flow",
      "unit": "k-cuft"
    },
    {
      "key": "coolingShare",
      "header": "Cooling %",
      "unit": "fraction"
    },
    {
      "key": "dhwDemand",
      "header": "DHW Demand",
      "unit": "MBtu"
    },
    {
      "key": "dhwShare",
      "header": "DHW %",
      "unit": "fraction"
    },
    {
      "key": "heatingElectricity",
      "header": "HHW Electric",
      "unit": "MBtu"
    },
    {
      "key": "heatingGas",
      "header": "HHW Boiler",
      "unit": "MBtu"
    },
    {
      "key": "chwPumpElectricity",
      "header": "CHW Pump",
      "unit": "MBtu"
    },
    {
      "key": "chillerElectricity",
      "header": "Chiller",
      "unit": "MBtu"
    },
    {
      "key": "totalElectricity",
      "header": "Total Elec",
      "unit": "MBtu"
    },
    {
      "key": "totalGas",
      "header": "Total Nat Gas",
      "aliases": [
        "Total Fossil Fuel"
      ],
      "unit": "MBtu"
    },
    {
      "key": "eui",
      "header": "EUI",
      "unit": "kBtu/sf/yr"
    }
  ],
  "locations": [
    {
      "id": "boston-5a",
      "label": "Boston, MA",
      "state": "Massachusetts",
      "climateZone": "5A",
      "rates": {
        "vintage": {
          "year": 2017,
          "source": "U.S. Energy Information Administration"
        },
        "gridCarbonLbPerMwh": 846,
        "electricityPricePerKwh": 0.17120000000000002,
        "gasPricePer1000Cuft": 10.16,
        "electricityCarbonMtPerMbtu": 0.1123488,
        "gasCarbonMtPerMbtu": 0.053085,
        "electricityCostPerMbtu": 54.485159802720005,
        "gasCostPerMbtu": 10.16
      }
    },
    {
      "id": "minneapolis-6a",
      "label": "Minneapolis, MN",
      "state": "Minnesota",
      "climateZone": "6A",
      "rates": {
        "vintage": {
          "year": 2017,
          "source": "U.S. Energy Information Administration"
        },
        "gridCarbonLbPerMwh": 1061,
        "electricityPricePerKwh": 0.1027,
        "gasPricePer1000Cuft": 6.8,
        "electricityCarbonMtPerMbtu": 0.1409008,
        "gasCarbonMtPerMbtu": 0.053085,
        "electricityCostPerMbtu": 32.68473079287,
        "gasCostPerMbtu": 6.8
      }
    },
    {
      "id": "washington-4a",
      "label": "Washington, DC",
      "state": "District of Columbia",
      "climateZone": "4A",
      "rates": {
        "vintage": {
          "year": 2017,
          "source": "U.S. Energy Information Administration"
        },
        "gridCarbonLbPerMwh": 1216,
        "electricityPricePerKwh": 0.11800000000000001,
        "gasPricePer1000Cuft": 10.87,
        "electricityCarbonMtPerMbtu": 0.1614848,
        "gasCarbonMtPerMbtu": 0.053085,
        "electricityCostPerMbtu": 37.554023695800005,
        "gasCostPerMbtu": 10.87
      }
    },
    {
      "id": "atlanta-3a",
      "label": "Atlanta, GA",
      "state": "Georgia",
      "climateZone": "3A",
      "rates": {
        "vintage": {
          "year": 2017,
          "source": "U.S. Energy Information Administration"
        },
        "gridCarbonLbPerMwh": 946,
        "electricityPricePerKwh": 0.0983,
        "gasPricePer1000Cuft": 8.78,
        "electricityCarbonMtPerMbtu": 0.1256288,
        "gasCarbonMtPerMbtu": 0.053085,
        "electricityCostPerMbtu": 31.284411265230002,
        "gasCostPerMbtu": 8.78
      }
    },
    {
      "id": "denver-5b",
      "label": "Denver, CO",
      "state": "Colorado",
      "climateZone": "5B",
      "rates": {
        "vintage": {
          "year": 2017,
          "source": "U.S. Energy Information Administration"
        },
        "gridCarbonLbPerMwh": 1459,
        "electricityPricePerKwh": 0.0999,
        "gasPricePer1000Cuft": 7.17,
        "electricityCarbonMtPerMbtu": 0.19375520000000002,
        "gasCarbonMtPerMbtu": 0.053085,
        "electricityCostPerMbtu": 31.793618366190003,
        "gasCostPerMbtu": 7.17
      }
    }
  ],
  "studies": [
    {
      "id": "climate",
      "label": "Climate comparison",
      "description": "The baseline building in five climate zones.",
      "caseIds": [
        "baseline",
        "climate-6a",
        "climate-4a",
        "climate-3a",
        "climate-5b"
      ]
    },
    {
      "id": "measure",
      "label": "Measure study",
      "description": "Six energy conservation measures and one reverse measure, all at 5A Boston. Measures were not simulated in the other climate zones and are never interpolated across them.",
      "caseIds": [
        "baseline",
        "ecm-1-plugs",
        "ecm-2-ach",
        "ecm-3-writeup",
        "ecm-4-glazing",
        "ecm-5-cascade",
        "ecm-6-shading",
        "recm-1-no-turndown"
      ]
    }
  ],
  "cases": [
    {
      "id": "baseline",
      "kind": "baseline",
      "label": "Baseline",
      "locationId": "boston-5a",
      "description": "60% window-to-wall, labs at 6 ACH day and 2 ACH night, open-lab receptacles at 8 W/sf, night turndown to one third flow.",
      "provenance": {
        "kind": "simulated",
        "tool": "IES:VE",
        "completed": "2019-08-30",
        "workbook": "STEM Lab Zoned EUI Tool_Climate Zones_SHARED.xlsx",
        "sheet": "5A - Boston",
        "crossCheckedAgainst": "Baseline"
      },
      "prototype": {
        "totalArea": 115000,
        "totalElectricity": 13971.136000000002,
        "totalGas": 1323.9920000000002,
        "blendedEui": 133.00111304347826
      },
      "plant": {
        "chillers": 2471.261,
        "chwPumps": 48.057,
        "hhwPumps": 169.427,
        "labFans": 1699.512,
        "hrcHeating": 1489.525,
        "generalFans": 336.289,
        "vivariumFans": 1552.567,
        "specialLabFans": 216.839,
        "auditoriumFans": 59.803,
        "dhwBoilers": 496.345,
        "hhwBoilers": 827.647
      },
      "zones": {
        "auditorium": {
          "fanGroup": "auditorium",
          "area": 1600,
          "roomElectricity": 40.143,
          "airFlow": 1129476.6,
          "fanShare": 1,
          "fanElectricity": 59.803,
          "reheatFlow": 489.4,
          "mainHeatCoilFlow": 54.1,
          "heatingShare": 0.010615151444129344,
          "chwFlow": 0,
          "mainCoolCoilFlow": 2365.1,
          "coolingShare": 0.023825953980075695,
          "dhwDemand": 77,
          "dhwShare": 0.15981735159817353,
          "heatingElectricity": 17.610026718541263,
          "heatingGas": 88.11014162627477,
          "chwPumpElectricity": 1.1450038704204977,
          "chillerElectricity": 58.88015085875584,
          "totalElectricity": 177.5811814477176,
          "totalGas": 88.11014162627477,
          "eui": 166.0570769212452
        },
        "atrium": {
          "fanGroup": "general",
          "area": 4770,
          "roomElectricity": 46.411,
          "airFlow": 5979312,
          "fanShare": 0.30033577535586087,
          "fanElectricity": 100.99961755864709,
          "reheatFlow": 307.1,
          "mainHeatCoilFlow": 75.80474969981928,
          "heatingShare": 0.007478549966402985,
          "chwFlow": 355.9,
          "mainCoolCoilFlow": 1994.6500184484144,
          "coolingShare": 0.02367937785608135,
          "dhwDemand": 74.6,
          "dhwShare": 0.15483603154836031,
          "heatingElectricity": 12.406555423864164,
          "heatingGas": 83.04168952291444,
          "chwPumpElectricity": 1.1379598616297015,
          "chillerElectricity": 58.51792299999745,
          "totalElectricity": 219.4730558441384,
          "totalGas": 83.04168952291444,
          "eui": 63.420282047600175
        },
        "boh": {
          "fanGroup": "general",
          "area": 23040,
          "roomElectricity": 248.587,
          "airFlow": 768163,
          "fanShare": 0.0385841766083931,
          "fanElectricity": 12.975434167459905,
          "reheatFlow": 176.7,
          "mainHeatCoilFlow": 9.738646175958419,
          "heatingShare": 0.0036413513600666875,
          "chwFlow": 67.1,
          "mainCoolCoilFlow": 256.2529505269819,
          "coolingShare": 0.0032574489529311927,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 6.040827121485352,
          "heatingGas": 3.013753529105114,
          "chwPumpElectricity": 0.15654322433101434,
          "chillerElectricity": 8.050006556869691,
          "totalElectricity": 275.80981107014594,
          "totalGas": 3.013753529105114,
          "eui": 12.10171721350916
        },
        "cafe-kitchen": {
          "fanGroup": "general",
          "area": 300,
          "roomElectricity": 18.226,
          "airFlow": 944730.3,
          "fanShare": 0.04745300247798995,
          "fanElectricity": 15.95792275032076,
          "reheatFlow": 904.4,
          "mainHeatCoilFlow": 11.977137825444663,
          "heatingShare": 0.01789785114619114,
          "chwFlow": 0,
          "mainCoolCoilFlow": 315.15437065732243,
          "coolingShare": 0.0031748566791683576,
          "dhwDemand": 9.7,
          "dhwShare": 0.02013283520132835,
          "heatingElectricity": 29.691675954676082,
          "heatingGas": 24.80593489559498,
          "chwPumpElectricity": 0.15257408743079376,
          "chillerElectricity": 7.845899491818274,
          "totalElectricity": 71.87407228424591,
          "totalGas": 24.80593489559498,
          "eui": 322.26669059946965
        },
        "computational": {
          "fanGroup": "general",
          "area": 6720,
          "roomElectricity": 101.855,
          "airFlow": 1949431.4,
          "fanShare": 0.09791828742538627,
          "fanElectricity": 32.92884295999573,
          "reheatFlow": 765,
          "mainHeatCoilFlow": 24.714575746167498,
          "heatingShare": 0.015423992307602432,
          "chwFlow": 987.2,
          "mainCoolCoilFlow": 650.3145141069604,
          "coolingShare": 0.016496277305322587,
          "dhwDemand": 5.1,
          "dhwShare": 0.010585305105853052,
          "heatingElectricity": 25.58766288668167,
          "heatingGas": 18.019584224174864,
          "chwPumpElectricity": 0.7927615984618875,
          "chillerElectricity": 40.7666067498288,
          "totalElectricity": 201.9308741949681,
          "totalGas": 18.019584224174864,
          "eui": 32.730722979039136
        },
        "office": {
          "fanGroup": "general",
          "area": 10420,
          "roomElectricity": 157.935,
          "airFlow": 4130862.8,
          "fanShare": 0.20748973827200892,
          "fanElectricity": 69.7765165937556,
          "reheatFlow": 1891.7,
          "mainHeatCoilFlow": 52.37040993985505,
          "heatingShare": 0.03796982855485222,
          "chwFlow": 1363.7,
          "mainCoolCoilFlow": 1378.0223477597199,
          "coolingShare": 0.027620037412315834,
          "dhwDemand": 7.9,
          "dhwShare": 0.016396845163968454,
          "heatingElectricity": 62.99012302072919,
          "heatingGas": 39.5641068068477,
          "chwPumpElectricity": 1.3273361379236621,
          "chillerElectricity": 68.25632127559705,
          "totalElectricity": 360.2852970280055,
          "totalGas": 39.5641068068477,
          "eui": 38.37326332388226
        },
        "restroom": {
          "fanGroup": "general",
          "area": 1000,
          "roomElectricity": 6.042,
          "airFlow": 400322.8,
          "fanShare": 0.020107875041581576,
          "fanElectricity": 6.762057189858426,
          "reheatFlow": 368.7,
          "mainHeatCoilFlow": 5.07522766049519,
          "heatingShare": 0.007300240382116062,
          "chwFlow": 0,
          "mainCoolCoilFlow": 133.54444130115988,
          "coolingShare": 0.001345323120686802,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 12.110748382392206,
          "heatingGas": 6.042022051537213,
          "chwPumpElectricity": 0.06465219321084564,
          "chillerElectricity": 3.324644560551587,
          "totalElectricity": 28.304102326013066,
          "totalGas": 6.042022051537213,
          "eui": 34.34612437755028
        },
        "classroom": {
          "fanGroup": "general",
          "area": 7500,
          "roomElectricity": 133.669,
          "airFlow": 4894858,
          "fanShare": 0.24586456981787175,
          "fanElectricity": 82.68155031948227,
          "reheatFlow": 405.9,
          "mainHeatCoilFlow": 62.056217422030834,
          "heatingShare": 0.009139698467629763,
          "chwFlow": 205.1,
          "mainCoolCoilFlow": 1632.8849539884134,
          "coolingShare": 0.01851581114109318,
          "dhwDemand": 28.2,
          "dhwShare": 0.05853051058530511,
          "heatingElectricity": 15.16232105227133,
          "heatingGas": 36.61577029410164,
          "chwPumpElectricity": 0.8898143360075149,
          "chillerElectricity": 45.75740195634907,
          "totalElectricity": 278.16008766411016,
          "totalGas": 36.61577029410164,
          "eui": 41.970114394428236
        },
        "corridor": {
          "fanGroup": "general",
          "area": 5790,
          "roomElectricity": 49.653,
          "airFlow": 841076.8,
          "fanShare": 0.04224657500090751,
          "fanElectricity": 14.207058460480186,
          "reheatFlow": 240.7,
          "mainHeatCoilFlow": 10.663035530229056,
          "heatingShare": 0.00490939593304406,
          "chwFlow": 13.5,
          "mainCoolCoilFlow": 280.5764032110271,
          "coolingShare": 0.0029625178003180063,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 8.144452201915309,
          "heatingGas": 4.063246815796117,
          "chwPumpElectricity": 0.14236971792988243,
          "chillerElectricity": 7.321154701731676,
          "totalElectricity": 79.46803508205704,
          "totalGas": 4.063246815796117,
          "eui": 14.426818980630943
        },
        "mri-lab": {
          "fanGroup": "special-lab",
          "area": 2550,
          "roomElectricity": 184.56,
          "airFlow": 1942383,
          "fanShare": 0.4576821827955375,
          "fanElectricity": 99.24334683520156,
          "reheatFlow": 475.9,
          "mainHeatCoilFlow": 88.74457524405473,
          "heatingShare": 0.01102812820298386,
          "chwFlow": 16.3,
          "mainCoolCoilFlow": 1598.7754009413716,
          "coolingShare": 0.016270226280995063,
          "dhwDemand": 9.6,
          "dhwShare": 0.019925280199252802,
          "heatingElectricity": 18.29513533859648,
          "heatingGas": 19.017210423313117,
          "chwPumpElectricity": 0.7818982643857798,
          "chillerElectricity": 40.20797566939814,
          "totalElectricity": 343.08835610758194,
          "totalGas": 19.017210423313117,
          "eui": 142.0021829532922
        },
        "nmr-lab": {
          "fanGroup": "special-lab",
          "area": 1800,
          "roomElectricity": 313.741,
          "airFlow": 2301572.9,
          "fanShare": 0.5423178172044624,
          "fanElectricity": 117.59565316479842,
          "reheatFlow": 37.2,
          "mainHeatCoilFlow": 105.15542475594526,
          "heatingShare": 0.002780357668220273,
          "chwFlow": 1095.7,
          "mainCoolCoilFlow": 1894.4245990586278,
          "coolingShare": 0.03012243503101905,
          "dhwDemand": 6.7,
          "dhwShare": 0.013906185139061854,
          "heatingElectricity": 4.6124799144093585,
          "heatingGas": 9.20342014587716,
          "chwPumpElectricity": 1.4475938602856826,
          "chillerElectricity": 74.44039891719117,
          "totalElectricity": 511.8371258566846,
          "totalGas": 9.20342014587716,
          "eui": 289.4669700014232
        },
        "core-lab": {
          "fanGroup": "lab",
          "area": 2750,
          "roomElectricity": 443.434,
          "airFlow": 6962861.5,
          "fanShare": 0.06928676277332178,
          "fanElectricity": 117.75368477441364,
          "reheatFlow": 2018.7,
          "mainHeatCoilFlow": 84.46056382067925,
          "heatingShare": 0.04107703384779571,
          "chwFlow": 4766.8,
          "mainCoolCoilFlow": 2293.6274227903805,
          "coolingShare": 0.07112655653252212,
          "dhwDemand": 10.3,
          "dhwShare": 0.021378165213781657,
          "heatingElectricity": 68.14482745586838,
          "heatingGas": 44.608229246061036,
          "chwPumpElectricity": 3.4181289272834157,
          "chillerElectricity": 175.77228522311714,
          "totalElectricity": 808.5229263806825,
          "totalGas": 44.608229246061036,
          "eui": 310.22951113699764
        },
        "instruction-lab": {
          "fanGroup": "lab",
          "area": 7140,
          "roomElectricity": 217.925,
          "airFlow": 18119160,
          "fanShare": 0.18030201240852786,
          "fanElectricity": 306.425433712442,
          "reheatFlow": 6443.6,
          "mainHeatCoilFlow": 219.78815312599545,
          "heatingShare": 0.13014328312134274,
          "chwFlow": 5753.7,
          "mainCoolCoilFlow": 5968.609637564461,
          "coolingShare": 0.1180902329562423,
          "dhwDemand": 35.7,
          "dhwShare": 0.07409713574097138,
          "heatingElectricity": 215.90145982071778,
          "heatingGas": 144.4904406848824,
          "chwPumpElectricity": 5.6750623251781365,
          "chillerElectricity": 291.8317871856763,
          "totalElectricity": 1037.7587430440142,
          "totalGas": 144.4904406848824,
          "eui": 165.58111816931327
        },
        "open-lab-bio": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 11473723,
          "fanShare": 0.11417391019881781,
          "fanElectricity": 194.03993046981324,
          "reheatFlow": 3254,
          "mainHeatCoilFlow": 139.17799653235892,
          "heatingShare": 0.0662724899909446,
          "chwFlow": 5156.9,
          "mainCoolCoilFlow": 3779.544618875546,
          "coolingShare": 0.09002550346066715,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 109.94287981545752,
          "heatingGas": 78.02947721220282,
          "chwPumpElectricity": 4.326355619809282,
          "chillerElectricity": 222.47651570771177,
          "totalElectricity": 925.8496816127918,
          "totalGas": 78.02947721220282,
          "eui": 223.08425751666547
        },
        "open-lab-chem": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 13202200,
          "fanShare": 0.13137381800369702,
          "fanElectricity": 223.27138018309913,
          "reheatFlow": 3601,
          "mainHeatCoilFlow": 160.14468414650668,
          "heatingShare": 0.07345928321158637,
          "chwFlow": 4985.5,
          "mainCoolCoilFlow": 4348.920046903584,
          "coolingShare": 0.09403469725094957,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 121.86542480242764,
          "heatingGas": 83.97760506088733,
          "chwPumpElectricity": 4.519025445788883,
          "chillerElectricity": 232.38427996307888,
          "totalElectricity": 977.1041103943946,
          "totalGas": 83.97760506088733,
          "eui": 235.79593676784046
        },
        "open-lab-general": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 11514977,
          "fanShare": 0.11458442477123183,
          "fanElectricity": 194.73760491180576,
          "reheatFlow": 3495.5,
          "mainHeatCoilFlow": 139.6784137961316,
          "heatingShare": 0.07099902371458293,
          "chwFlow": 5192,
          "mainCoolCoilFlow": 3793.134046971996,
          "coolingShare": 0.09051599945370854,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 117.78397238935477,
          "heatingGas": 81.94137866897093,
          "chwPumpElectricity": 4.349927385746872,
          "chillerElectricity": 223.68865932597123,
          "totalElectricity": 935.6241640128787,
          "totalGas": 81.94137866897093,
          "eui": 226.12567615152216
        },
        "support-lab-bio": {
          "fanGroup": "lab",
          "area": 3000,
          "roomElectricity": 483.746,
          "airFlow": 7608274,
          "fanShare": 0.07570920026952022,
          "fanElectricity": 128.66869436845283,
          "reheatFlow": 2264.5,
          "mainHeatCoilFlow": 92.28951512854515,
          "heatingShare": 0.046030685602623134,
          "chwFlow": 5079,
          "mainCoolCoilFlow": 2506.2319402020357,
          "coolingShare": 0.07641342316834553,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 76.36269794184285,
          "heatingGas": 61.27640853562173,
          "chwPumpElectricity": 3.672199877201181,
          "chillerElectricity": 188.83751255242873,
          "totalElectricity": 881.2871047399256,
          "totalGas": 61.27640853562173,
          "eui": 314.18783775851574
        },
        "support-lab-chem": {
          "fanGroup": "lab",
          "area": 3000,
          "roomElectricity": 483.746,
          "airFlow": 8936739,
          "fanShare": 0.0889286272691325,
          "fanElectricity": 151.13526918741792,
          "reheatFlow": 2596.5,
          "mainHeatCoilFlow": 108.40399664107252,
          "heatingShare": 0.05282974345202523,
          "chwFlow": 5137,
          "mainCoolCoilFlow": 2943.839919941001,
          "coolingShare": 0.08140616466655654,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 87.64200855922415,
          "heatingGas": 66.90362836750583,
          "chwPumpElectricity": 3.9121360553807074,
          "chillerElectricity": 201.17587990003918,
          "totalElectricity": 927.6112937020619,
          "totalGas": 66.90362836750583,
          "eui": 331.5049740231892
        },
        "support-lab-general": {
          "fanGroup": "lab",
          "area": 6500,
          "roomElectricity": 1048.116,
          "airFlow": 17569310,
          "fanShare": 0.1748305081267163,
          "fanElectricity": 297.12654652745186,
          "reheatFlow": 4940.6,
          "mainHeatCoilFlow": 213.11838940646717,
          "heatingShare": 0.10065777590422083,
          "chwFlow": 11023.5,
          "mainCoolCoilFlow": 5787.484242721941,
          "coolingShare": 0.1693534044762888,
          "dhwDemand": 48.7,
          "dhwShare": 0.10107928601079287,
          "heatingElectricity": 166.98641865185894,
          "heatingGas": 133.47930446882765,
          "chwPumpElectricity": 8.138616558917011,
          "chillerElectricity": 418.5164636994779,
          "totalElectricity": 1938.8840454377057,
          "totalGas": 133.47930446882765,
          "eui": 318.82513075485133
        },
        "write-up": {
          "fanGroup": "lab",
          "area": 9000,
          "roomElectricity": 152.293,
          "airFlow": 5106143,
          "fanShare": 0.050810736179034664,
          "fanElectricity": 86.35345586510356,
          "reheatFlow": 700.1,
          "mainHeatCoilFlow": 61.938287402243255,
          "heatingShare": 0.01488344402391863,
          "chwFlow": 2279.8,
          "mainCoolCoilFlow": 1682.0081240290563,
          "coolingShare": 0.039911148805972824,
          "dhwDemand": 27,
          "dhwShare": 0.05603985056039851,
          "heatingElectricity": 24.69091923036786,
          "heatingGas": 40.13333742246518,
          "chwPumpElectricity": 1.918010078168636,
          "chillerElectricity": 98.63086550939721,
          "totalElectricity": 363.88625068303725,
          "totalGas": 40.13333742246518,
          "eui": 44.89106534505582
        },
        "vivarium": {
          "fanGroup": "vivarium",
          "area": 4620,
          "roomElectricity": 612.582,
          "airFlow": 6070680,
          "fanShare": 1,
          "fanElectricity": 1552.567,
          "reheatFlow": 4177,
          "mainHeatCoilFlow": 9926.8,
          "heatingShare": 0.27546269169772114,
          "chwFlow": 0,
          "mainCoolCoilFlow": 183.9,
          "coolingShare": 0.0018526036687395546,
          "dhwDemand": 28.8,
          "dhwShare": 0.059775840597758416,
          "heatingElectricity": 456.97938331731785,
          "heatingGas": 257.6553099970382,
          "chwPumpElectricity": 0.08903057450861677,
          "chillerElectricity": 4.57826719501298,
          "totalElectricity": 2626.7956810868395,
          "totalGas": 257.6553099970382,
          "eui": 624.3400413601466
        }
      },
      "repairs": [],
      "dataQuality": []
    },
    {
      "id": "climate-6a",
      "kind": "climate",
      "label": "Minneapolis, 6A",
      "locationId": "minneapolis-6a",
      "provenance": {
        "kind": "simulated",
        "tool": "IES:VE",
        "completed": "2019-08-30",
        "workbook": "STEM Lab Zoned EUI Tool_Climate Zones_SHARED.xlsx",
        "sheet": "6A - Minneapolis"
      },
      "prototype": {
        "totalArea": 115000,
        "totalElectricity": 0,
        "totalGas": 0,
        "blendedEui": 140.23765217391303
      },
      "plant": {
        "chillers": 2528.343,
        "chwPumps": 47.471,
        "hhwPumps": 201.712,
        "labFans": 1707.324,
        "hrcHeating": 1605.749,
        "generalFans": 384.704,
        "vivariumFans": 1764.539,
        "specialLabFans": 208.464,
        "auditoriumFans": 60.352,
        "dhwBoilers": 496.345,
        "hhwBoilers": 1194.471
      },
      "zones": {
        "auditorium": {
          "fanGroup": "auditorium",
          "area": 1600,
          "roomElectricity": 40.143,
          "airFlow": 1132992.1,
          "fanShare": 1,
          "fanElectricity": 60.352,
          "reheatFlow": 446.8,
          "mainHeatCoilFlow": 54.7,
          "heatingShare": 0.011937829971499175,
          "chwFlow": 0,
          "mainCoolCoilFlow": 1888.3,
          "coolingShare": 0.0179045859937837,
          "dhwDemand": 77,
          "dhwShare": 0.15981735159817353,
          "heatingElectricity": 21.57716209811587,
          "heatingGas": 93.58393508288204,
          "chwPumpElectricity": 0.8499486017109059,
          "chillerElectricity": 45.26893466528105,
          "totalElectricity": 168.19104536510784,
          "totalGas": 93.58393508288204,
          "eui": 163.6093627799937
        },
        "atrium": {
          "fanGroup": "general",
          "area": 4770,
          "roomElectricity": 46.411,
          "airFlow": 6305076.5,
          "fanShare": 0.27894316181967177,
          "fanElectricity": 107.310550124675,
          "reheatFlow": 439.11,
          "mainHeatCoilFlow": 75.59359685313105,
          "heatingShare": 0.012252131654938658,
          "chwFlow": 309.1,
          "mainCoolCoilFlow": 1757.2861308315682,
          "coolingShare": 0.019593172788135244,
          "dhwDemand": 74.6,
          "dhwShare": 0.15483603154836031,
          "heatingElectricity": 22.14525013316708,
          "heatingGas": 91.48690602887713,
          "chwPumpElectricity": 0.9301075054255681,
          "chillerElectricity": 49.53826126667222,
          "totalElectricity": 226.3351690299399,
          "totalGas": 91.48690602887713,
          "eui": 66.62936584042285
        },
        "boh": {
          "fanGroup": "general",
          "area": 23040,
          "roomElectricity": 248.587,
          "airFlow": 1209090.5,
          "fanShare": 0.05349142504395115,
          "fanElectricity": 20.578365180108182,
          "reheatFlow": 381.9,
          "mainHeatCoilFlow": 14.496176186910763,
          "heatingShare": 0.00943591256764062,
          "chwFlow": 36.3,
          "mainCoolCoilFlow": 336.9852794918835,
          "coolingShare": 0.003539436735092946,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 17.055043965420282,
          "heatingGas": 11.27092392058226,
          "chwPumpElectricity": 0.16802060125159723,
          "chillerElectricity": 8.948910093115105,
          "totalElectricity": 295.33733983989515,
          "totalGas": 11.27092392058226,
          "eui": 13.307650336826278
        },
        "cafe-kitchen": {
          "fanGroup": "general",
          "area": 300,
          "roomElectricity": 18.226,
          "airFlow": 962813.8,
          "fanShare": 0.04259588691994667,
          "fanElectricity": 16.386808081651164,
          "reheatFlow": 877.8,
          "mainHeatCoilFlow": 11.543485355305547,
          "heatingShare": 0.021170152172347165,
          "chwFlow": 0,
          "mainCoolCoilFlow": 268.34556841828004,
          "coolingShare": 0.0025444136555610136,
          "dhwDemand": 9.7,
          "dhwShare": 0.02013283520132835,
          "heatingElectricity": 38.26422441558278,
          "heatingGas": 35.27996492345901,
          "chwPumpElectricity": 0.12078586064313687,
          "chillerElectricity": 6.4331504551420995,
          "totalElectricity": 79.43096881301918,
          "totalGas": 35.27996492345901,
          "eui": 382.3697791215939
        },
        "computational": {
          "fanGroup": "general",
          "area": 6720,
          "roomElectricity": 101.855,
          "airFlow": 2209525,
          "fanShare": 0.09775169097783513,
          "fanElectricity": 37.60546652593709,
          "reheatFlow": 921.8,
          "mainHeatCoilFlow": 26.490708254993322,
          "heatingShare": 0.02257334643808702,
          "chwFlow": 886.6,
          "mainCoolCoilFlow": 615.8161028221658,
          "coolingShare": 0.014245690997947804,
          "dhwDemand": 5.1,
          "dhwShare": 0.010585305105853052,
          "heatingElectricity": 40.800443326331205,
          "heatingGas": 32.21717095601287,
          "chwPumpElectricity": 0.6762571973635801,
          "chillerElectricity": 36.01799311482434,
          "totalElectricity": 216.95516016445623,
          "totalGas": 32.21717095601287,
          "eui": 37.07921594054599
        },
        "office": {
          "fanGroup": "general",
          "area": 10420,
          "roomElectricity": 157.935,
          "airFlow": 5106867,
          "fanShare": 0.22593312356678652,
          "fanElectricity": 86.91737636863704,
          "reheatFlow": 2382.6,
          "mainHeatCoilFlow": 61.22787648659914,
          "heatingShare": 0.05817348288954518,
          "chwFlow": 1213.8,
          "mainCoolCoilFlow": 1423.3334918460419,
          "coolingShare": 0.025004916264282438,
          "dhwDemand": 7.9,
          "dhwShare": 0.016396845163968454,
          "heatingElectricity": 105.14630155702022,
          "heatingGas": 77.62503039346785,
          "chwPumpElectricity": 1.1870083799817515,
          "chillerElectricity": 63.22100500238465,
          "totalElectricity": 414.40669130802365,
          "totalGas": 77.62503039346785,
          "eui": 47.21993490417385
        },
        "restroom": {
          "fanGroup": "general",
          "area": 1000,
          "roomElectricity": 6.042,
          "airFlow": 412951.7,
          "fanShare": 0.01826941399946671,
          "fanElectricity": 7.028316643250841,
          "reheatFlow": 380.2,
          "mainHeatCoilFlow": 4.951011193855478,
          "heatingShare": 0.009168229880325469,
          "chwFlow": 0,
          "mainCoolCoilFlow": 115.09365431384037,
          "coolingShare": 0.0010913012926976483,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 16.571217947722953,
          "heatingGas": 10.951184713382244,
          "chwPumpElectricity": 0.05180516366565006,
          "chillerElectricity": 2.75918398428305,
          "totalElectricity": 32.452523738922494,
          "totalGas": 10.951184713382244,
          "eui": 43.40370845230474
        },
        "classroom": {
          "fanGroup": "general",
          "area": 7500,
          "roomElectricity": 133.669,
          "airFlow": 5401367,
          "fanShare": 0.23896211078936713,
          "fanElectricity": 91.92967986911269,
          "reheatFlow": 520,
          "mainHeatCoilFlow": 64.7587320239185,
          "heatingShare": 0.013919741410271164,
          "chwFlow": 176.2,
          "mainCoolCoilFlow": 1505.413505550855,
          "coolingShare": 0.015944814710821025,
          "dhwDemand": 28.2,
          "dhwShare": 0.05853051058530511,
          "heatingElectricity": 25.159389729150128,
          "heatingGas": 45.678053718531274,
          "chwPumpElectricity": 0.7569162991373848,
          "chillerElectricity": 40.313960660401364,
          "totalElectricity": 291.8289465578016,
          "totalGas": 45.678053718531274,
          "eui": 45.00093337017771
        },
        "corridor": {
          "fanGroup": "general",
          "area": 5790,
          "roomElectricity": 49.653,
          "airFlow": 995753.8,
          "fanShare": 0.044053186882974875,
          "fanElectricity": 16.947437206627967,
          "reheatFlow": 313.3,
          "mainHeatCoilFlow": 11.938413645286191,
          "heatingShare": 0.007742055597801683,
          "chwFlow": 10.5,
          "mainCoolCoilFlow": 277.52626672536513,
          "coolingShare": 0.002731023174841275,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 13.993463552858227,
          "heatingGas": 9.247660891961774,
          "chwPumpElectricity": 0.12964440113289016,
          "chillerElectricity": 6.904963326947714,
          "totalElectricity": 87.62850848756679,
          "totalGas": 9.247660891961774,
          "eui": 16.731635471421168
        },
        "mri-lab": {
          "fanGroup": "special-lab",
          "area": 2550,
          "roomElectricity": 184.56,
          "airFlow": 1646341,
          "fanShare": 0.39647886026545337,
          "fanElectricity": 82.65156912637747,
          "reheatFlow": 300.1,
          "mainHeatCoilFlow": 34.57295661514753,
          "heatingShare": 0.007966637790888438,
          "chwFlow": 424.3,
          "mainCoolCoilFlow": 844.4999723654157,
          "coolingShare": 0.012030576822606028,
          "dhwDemand": 9.6,
          "dhwShare": 0.019925280199252802,
          "heatingElectricity": 14.399387108157008,
          "heatingGas": 19.405731009218435,
          "chwPumpElectricity": 0.5711035123459307,
          "chillerElectricity": 30.41742469539819,
          "totalElectricity": 312.5994844422786,
          "totalGas": 19.405731009218435,
          "eui": 130.1981237064694
        },
        "nmr-lab": {
          "fanGroup": "special-lab",
          "area": 1800,
          "roomElectricity": 313.741,
          "airFlow": 2506064.5,
          "fanShare": 0.6035211397345467,
          "fanElectricity": 125.81243087362255,
          "reheatFlow": 159.7,
          "mainHeatCoilFlow": 52.62704338485247,
          "heatingShare": 0.005054285428274173,
          "chwFlow": 1716,
          "mainCoolCoilFlow": 1285.5000276345845,
          "coolingShare": 0.028459786768589505,
          "dhwDemand": 6.7,
          "dhwShare": 0.013906185139061854,
          "heatingElectricity": 9.135423794473864,
          "heatingGas": 12.939462832643734,
          "chwPumpElectricity": 1.3510145376917122,
          "chillerElectricity": 71.9561026578559,
          "totalElectricity": 521.995971863644,
          "totalGas": 12.939462832643734,
          "eui": 297.1863526090487
        },
        "core-lab": {
          "fanGroup": "lab",
          "area": 2750,
          "roomElectricity": 443.434,
          "airFlow": 6929541,
          "fanShare": 0.06888481003494495,
          "fanElectricity": 117.60868940810236,
          "reheatFlow": 1985.1,
          "mainHeatCoilFlow": 82.43445216881862,
          "heatingShare": 0.04921610119682562,
          "chwFlow": 4753.9,
          "mainCoolCoilFlow": 2135.8148660194893,
          "coolingShare": 0.06532727442212354,
          "dhwDemand": 10.3,
          "dhwShare": 0.021378165213781657,
          "heatingElectricity": 88.95618348531563,
          "heatingGas": 69.39815102570796,
          "chwPumpElectricity": 3.101151044092626,
          "chillerElectricity": 165.16975699425507,
          "totalElectricity": 818.2697809317657,
          "totalGas": 69.39815102570796,
          "eui": 322.78833889362676
        },
        "instruction-lab": {
          "fanGroup": "lab",
          "area": 7140,
          "roomElectricity": 217.925,
          "airFlow": 18168162,
          "fanShare": 0.18060509174476427,
          "fanElectricity": 308.35140765803794,
          "reheatFlow": 6352.7,
          "mainHeatCoilFlow": 216.1301132909594,
          "heatingShare": 0.15636605584074006,
          "chwFlow": 5794.3,
          "mainCoolCoilFlow": 5599.769232601463,
          "coolingShare": 0.10803690747986969,
          "dhwDemand": 35.7,
          "dhwShare": 0.07409713574097138,
          "heatingElectricity": 282.6255476559599,
          "heatingGas": 223.55246192549706,
          "chwPumpElectricity": 5.128620034976893,
          "chillerElectricity": 273.15435876837614,
          "totalElectricity": 1087.1849341173508,
          "totalGas": 223.55246192549706,
          "eui": 183.57666611244366
        },
        "open-lab-bio": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 11491458,
          "fanShare": 0.11423367021777467,
          "fanElectricity": 195.03388677089194,
          "reheatFlow": 3128.7,
          "mainHeatCoilFlow": 136.70343314961096,
          "heatingShare": 0.07773047053497453,
          "chwFlow": 5236.3,
          "mainCoolCoilFlow": 3541.883485304234,
          "coolingShare": 0.08323345923944371,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 140.4947940036156,
          "heatingGas": 116.02604255904906,
          "chwPumpElectricity": 3.951175543555632,
          "chillerElectricity": 210.4427340338328,
          "totalElectricity": 944.986590351896,
          "totalGas": 116.02604255904906,
          "eui": 235.78058509132111
        },
        "open-lab-chem": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 13241118,
          "fanShare": 0.13162659663609613,
          "fanElectricity": 224.72924747512621,
          "reheatFlow": 3421,
          "mainHeatCoilFlow": 157.51754819441624,
          "heatingShare": 0.08518391633174685,
          "chwFlow": 5002.9,
          "mainCoolCoilFlow": 4081.161604660142,
          "coolingShare": 0.08613375108482034,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 153.9666065968955,
          "heatingGas": 124.92896741336548,
          "chwPumpElectricity": 4.088855297747506,
          "chillerElectricity": 217.7756666190479,
          "totalElectricity": 995.6243759888173,
          "totalGas": 124.92896741336548,
          "eui": 249.01185408937394
        },
        "open-lab-general": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 11529675,
          "fanShare": 0.11461357572451826,
          "fanElectricity": 195.68250856028743,
          "reheatFlow": 3211,
          "mainHeatCoilFlow": 137.158066069531,
          "heatingShare": 0.07970038227406094,
          "chwFlow": 5132.5,
          "mainCoolCoilFlow": 3553.662683484123,
          "coolingShare": 0.08236093137871972,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 144.05533264545647,
          "heatingGas": 118.37904500394734,
          "chwPumpElectricity": 3.9097557734792034,
          "chillerElectricity": 208.23668432486633,
          "totalElectricity": 946.9482813040895,
          "totalGas": 118.37904500394734,
          "eui": 236.73940584623043
        },
        "support-lab-bio": {
          "fanGroup": "lab",
          "area": 3000,
          "roomElectricity": 483.746,
          "airFlow": 7517072,
          "fanShare": 0.07472530673229348,
          "fanElectricity": 127.58030959140623,
          "reheatFlow": 2421.3,
          "mainHeatCoilFlow": 89.42377456653561,
          "heatingShare": 0.05976588938419926,
          "chwFlow": 5292.6,
          "mainCoolCoilFlow": 2316.9029704187988,
          "coolingShare": 0.07215220055278074,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 108.02451419225417,
          "heatingGas": 94.56787134730136,
          "chwPumpElectricity": 3.425137112441054,
          "chillerElectricity": 182.4255112022193,
          "totalElectricity": 905.2014720983208,
          "totalGas": 94.56787134730136,
          "eui": 333.25644781520737
        },
        "support-lab-chem": {
          "fanGroup": "lab",
          "area": 3000,
          "roomElectricity": 483.746,
          "airFlow": 8947702,
          "fanShare": 0.08894683681347683,
          "fanElectricity": 151.86106921573253,
          "reheatFlow": 2812.3,
          "mainHeatCoilFlow": 106.44267961468772,
          "heatingShare": 0.06947847226280765,
          "chwFlow": 5457,
          "mainCoolCoilFlow": 2757.850043503937,
          "coolingShare": 0.07789201346711538,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 125.57962895460658,
          "heatingGas": 106.16926993089561,
          "chwPumpElectricity": 3.697611771297434,
          "chillerElectricity": 196.9377270054869,
          "totalElectricity": 961.8220369471235,
          "totalGas": 106.16926993089561,
          "eui": 355.99710229267305
        },
        "support-lab-general": {
          "fanGroup": "lab",
          "area": 6500,
          "roomElectricity": 1048.116,
          "airFlow": 17436952,
          "fanShare": 0.17333631853948964,
          "fanElectricity": 295.94125671411564,
          "reheatFlow": 5208.9,
          "mainHeatCoilFlow": 207.43157239620726,
          "heatingShare": 0.12893169567403528,
          "chwFlow": 11620.8,
          "mainCoolCoilFlow": 5374.396558107999,
          "coolingShare": 0.16114598223582133,
          "dhwDemand": 48.7,
          "dhwShare": 0.10107928601079287,
          "heatingElectricity": 233.03901159468748,
          "heatingGas": 204.1753696784876,
          "chwPumpElectricity": 7.649760922716673,
          "chillerElectricity": 407.4323161640632,
          "totalElectricity": 1992.178345395583,
          "totalGas": 204.1753696784876,
          "eui": 337.900571549857
        },
        "write-up": {
          "fanGroup": "lab",
          "area": 9000,
          "roomElectricity": 152.293,
          "airFlow": 5334387.5,
          "fanShare": 0.053027793556641764,
          "fanElectricity": 90.53562460629985,
          "reheatFlow": 832,
          "mainHeatCoilFlow": 63.4583605492332,
          "heatingShare": 0.021315712173069094,
          "chwFlow": 2402.9,
          "mainCoolCoilFlow": 1644.1585558998117,
          "coolingShare": 0.038373620683146877,
          "dhwDemand": 27,
          "dhwShare": 0.05603985056039851,
          "heatingElectricity": 38.52731844004764,
          "heatingGas": 53.276099661479016,
          "chwPumpElectricity": 1.8216341474496653,
          "chillerElectricity": 97.02167523888961,
          "totalElectricity": 380.19925243268676,
          "totalGas": 53.276099661479016,
          "eui": 48.16392801046286
        },
        "vivarium": {
          "fanGroup": "vivarium",
          "area": 4620,
          "roomElectricity": 612.582,
          "airFlow": 6070680,
          "fanShare": 1,
          "fanElectricity": 1764.539,
          "reheatFlow": 3745.5,
          "mainHeatCoilFlow": 157.9,
          "heatingShare": 0.092917498525922,
          "chwFlow": 0,
          "mainCoolCoilFlow": 8674.9,
          "coolingShare": 0.08225414025180014,
          "dhwDemand": 28.8,
          "dhwShare": 0.059775840597758416,
          "heatingElectricity": 167.94475480316152,
          "heatingGas": 140.65669698325098,
          "chwPumpElectricity": 3.904686291893204,
          "chillerElectricity": 207.9666797266571,
          "totalElectricity": 2756.9371208217117,
          "totalGas": 140.65669698325098,
          "eui": 627.1848090486933
        }
      },
      "repairs": [],
      "dataQuality": []
    },
    {
      "id": "climate-4a",
      "kind": "climate",
      "label": "Washington DC, 4A",
      "locationId": "washington-4a",
      "provenance": {
        "kind": "simulated",
        "tool": "IES:VE",
        "completed": "2019-08-30",
        "workbook": "STEM Lab Zoned EUI Tool_Climate Zones_SHARED.xlsx",
        "sheet": "4A - Washington DC"
      },
      "prototype": {
        "totalArea": 115000,
        "totalElectricity": 0,
        "totalGas": 0,
        "blendedEui": 134.6595408695652
      },
      "plant": {
        "chillers": 3176.2252,
        "chwPumps": 59.044,
        "hhwPumps": 133.09,
        "labFans": 1671.059,
        "hrcHeating": 1496.924,
        "generalFans": 328.829,
        "vivariumFans": 1303.197,
        "specialLabFans": 224.801,
        "auditoriumFans": 59.389,
        "dhwBoilers": 496.245,
        "hhwBoilers": 609.188
      },
      "zones": {
        "auditorium": {
          "fanGroup": "auditorium",
          "area": 1600,
          "roomElectricity": 40.143,
          "airFlow": 1131322.8,
          "fanShare": 1,
          "fanElectricity": 59.389,
          "reheatFlow": 495.7,
          "mainHeatCoilFlow": 76,
          "heatingShare": 0.013464690809059052,
          "chwFlow": 0,
          "mainCoolCoilFlow": 3001.6,
          "coolingShare": 0.020472219683504506,
          "dhwDemand": 77,
          "dhwShare": 0.15981735159817353,
          "heatingElectricity": 21.94763452443758,
          "heatingGas": 87.51108970842469,
          "chwPumpElectricity": 1.20876173899284,
          "chillerElectricity": 65.02438005868304,
          "totalElectricity": 187.71277632211346,
          "totalGas": 87.51108970842469,
          "eui": 172.01491626908634
        },
        "atrium": {
          "fanGroup": "general",
          "area": 4770,
          "roomElectricity": 46.411,
          "airFlow": 5800134,
          "fanShare": 0.30828271678391594,
          "fanElectricity": 101.3722974773383,
          "reheatFlow": 245.2,
          "mainHeatCoilFlow": 112.6156764411645,
          "heatingShare": 0.00842728257812593,
          "chwFlow": 426.4,
          "mainCoolCoilFlow": 3561.374429102832,
          "coolingShare": 0.027198358928856258,
          "dhwDemand": 74.6,
          "dhwShare": 0.15483603154836031,
          "heatingElectricity": 13.736588584301359,
          "heatingGas": 81.97040589491945,
          "chwPumpElectricity": 1.6058999045953888,
          "chillerElectricity": 86.38811302847824,
          "totalElectricity": 249.5138989947133,
          "totalGas": 81.97040589491945,
          "eui": 69.49356496638003
        },
        "boh": {
          "fanGroup": "general",
          "area": 23040,
          "roomElectricity": 248.587,
          "airFlow": 679825.5,
          "fanShare": 0.03613338106998632,
          "fanElectricity": 11.881703563862532,
          "reheatFlow": 77.3,
          "mainHeatCoilFlow": 13.199524104866004,
          "heatingShare": 0.0021314467560591345,
          "chwFlow": 299.6,
          "mainCoolCoilFlow": 417.42365813480296,
          "coolingShare": 0.004890413728546682,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 3.474288052630974,
          "heatingGas": 1.298451786430152,
          "chwPumpElectricity": 0.28874958818831026,
          "chillerElectricity": 15.53305532303593,
          "totalElectricity": 279.76479652771775,
          "totalGas": 1.298451786430152,
          "eui": 12.198925708079337
        },
        "cafe-kitchen": {
          "fanGroup": "general",
          "area": 300,
          "roomElectricity": 18.226,
          "airFlow": 929311.3,
          "fanShare": 0.049393791988597634,
          "fanElectricity": 16.242111225818572,
          "reheatFlow": 851.6,
          "mainHeatCoilFlow": 18.043552213434715,
          "heatingShare": 0.020481863817816512,
          "chwFlow": 0,
          "mainCoolCoilFlow": 570.6119031898764,
          "coolingShare": 0.0038918217737625785,
          "dhwDemand": 9.7,
          "dhwShare": 0.02013283520132835,
          "heatingElectricity": 33.38572476913436,
          "heatingGas": 22.468124459931193,
          "chwPumpElectricity": 0.22978872481003768,
          "chillerElectricity": 12.3613023917334,
          "totalElectricity": 80.44492711149637,
          "totalGas": 22.468124459931193,
          "eui": 343.0435052380918
        },
        "computational": {
          "fanGroup": "general",
          "area": 6720,
          "roomElectricity": 101.855,
          "airFlow": 1872654.1,
          "fanShare": 0.09953337173667695,
          "fanElectricity": 32.72945909479974,
          "reheatFlow": 618.6,
          "mainHeatCoilFlow": 36.35954069540809,
          "heatingShare": 0.01542562131871086,
          "chwFlow": 1387.1,
          "mainCoolCoilFlow": 1149.839370313613,
          "coolingShare": 0.01730303175399516,
          "dhwDemand": 5.1,
          "dhwShare": 0.010585305105853052,
          "heatingElectricity": 25.143978708197164,
          "heatingGas": 14.65000813215688,
          "chwPumpElectricity": 1.0216402068828903,
          "chillerElectricity": 54.95832549343963,
          "totalElectricity": 215.70840350331946,
          "totalGas": 14.65000813215688,
          "eui": 34.279525540993504
        },
        "office": {
          "fanGroup": "general",
          "area": 10420,
          "roomElectricity": 157.935,
          "airFlow": 3693512.5,
          "fanShare": 0.19631375205734097,
          "fanElectricity": 64.55365477526338,
          "reheatFlow": 1408.9,
          "mainHeatCoilFlow": 71.71341362654665,
          "heatingShare": 0.03487143925525085,
          "chwFlow": 2045.8,
          "mainCoolCoilFlow": 2267.87535789202,
          "coolingShare": 0.029421145245897305,
          "dhwDemand": 7.9,
          "dhwShare": 0.016396845163968454,
          "heatingElectricity": 56.84093418620846,
          "heatingGas": 29.380114765421283,
          "chwPumpElectricity": 1.7371420998987603,
          "chillerElectricity": 93.44818294287921,
          "totalElectricity": 374.5149140042498,
          "totalGas": 29.380114765421283,
          "eui": 38.76151907578417
        },
        "restroom": {
          "fanGroup": "general",
          "area": 1000,
          "roomElectricity": 6.042,
          "airFlow": 377661.7,
          "fanShare": 0.02007308363931458,
          "fanElectricity": 6.600612020032174,
          "reheatFlow": 342.4,
          "mainHeatCoilFlow": 7.332697453441616,
          "heatingShare": 0.008236912081561631,
          "chwFlow": 0,
          "mainCoolCoilFlow": 231.8902841264538,
          "coolingShare": 0.0015815927635617804,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 13.426282009714601,
          "heatingGas": 5.017827997142367,
          "chwPumpElectricity": 0.09338356313174176,
          "chillerElectricity": 5.023494791762569,
          "totalElectricity": 31.185772384641083,
          "totalGas": 5.017827997142367,
          "eui": 36.20360038178345
        },
        "classroom": {
          "fanGroup": "general",
          "area": 7500,
          "roomElectricity": 133.669,
          "airFlow": 4650681,
          "fanShare": 0.2471881810963917,
          "fanElectricity": 81.28264240174539,
          "reheatFlow": 333.4,
          "mainHeatCoilFlow": 90.29784255451189,
          "heatingShare": 0.00997894078443569,
          "chwFlow": 253.3,
          "mainCoolCoilFlow": 2855.592024479846,
          "coolingShare": 0.021203998033530944,
          "dhwDemand": 28.2,
          "dhwShare": 0.05853051058530511,
          "heatingElectricity": 16.265813183801157,
          "heatingGas": 35.124524203993545,
          "chwPumpElectricity": 1.251968859891801,
          "chillerElectricity": 67.34867289485142,
          "totalElectricity": 299.8180973402898,
          "totalGas": 35.124524203993545,
          "eui": 44.65901620590444
        },
        "corridor": {
          "fanGroup": "general",
          "area": 5790,
          "roomElectricity": 49.653,
          "airFlow": 810553.9,
          "fanShare": 0.04308172162777593,
          "fanElectricity": 14.166519441139933,
          "reheatFlow": 188.3,
          "mainHeatCoilFlow": 15.737752910626549,
          "heatingShare": 0.004805501585301338,
          "chwFlow": 34,
          "mainCoolCoilFlow": 497.69297276055585,
          "coolingShare": 0.00362637771272977,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 7.833034861063375,
          "heatingGas": 2.9274538997465513,
          "chwPumpElectricity": 0.21411584567041653,
          "chillerElectricity": 11.518192275890655,
          "totalElectricity": 83.38486242376439,
          "totalGas": 2.9274538997465513,
          "eui": 14.90713580716942
        },
        "mri-lab": {
          "fanGroup": "special-lab",
          "area": 2550,
          "roomElectricity": 184.56,
          "airFlow": 1888453.9,
          "fanShare": 0.42808302733018133,
          "fanElectricity": 96.23349262685208,
          "reheatFlow": 745.8,
          "mainHeatCoilFlow": 41.73809516469268,
          "heatingShare": 0.018548114311260994,
          "chwFlow": 135.7,
          "mainCoolCoilFlow": 1665.1573597089393,
          "coolingShare": 0.01228263175860118,
          "dhwDemand": 9.6,
          "dhwShare": 0.019925280199252802,
          "heatingElectricity": 30.233686000955775,
          "heatingGas": 21.18710933352667,
          "chwPumpElectricity": 0.725215709554848,
          "chillerElectricity": 39.01240451398939,
          "totalElectricity": 350.7647988513521,
          "totalGas": 21.18710933352667,
          "eui": 145.86349340583482
        },
        "nmr-lab": {
          "fanGroup": "special-lab",
          "area": 1800,
          "roomElectricity": 313.741,
          "airFlow": 2522965.8,
          "fanShare": 0.5719169726698188,
          "fanElectricity": 128.56750737314792,
          "reheatFlow": 152.4,
          "mainHeatCoilFlow": 55.761904835307334,
          "heatingShare": 0.0049026337009483775,
          "chwFlow": 1996.7,
          "mainCoolCoilFlow": 2224.642640291061,
          "coolingShare": 0.02879139588598865,
          "dhwDemand": 6.7,
          "dhwShare": 0.013906185139061854,
          "heatingElectricity": 7.991361569417668,
          "heatingGas": 9.88750046334709,
          "chwPumpElectricity": 1.6999591786923138,
          "chillerElectricity": 91.44795715625348,
          "totalElectricity": 543.4477852775113,
          "totalGas": 9.88750046334709,
          "eui": 307.40849207825465
        },
        "core-lab": {
          "fanGroup": "lab",
          "area": 2750,
          "roomElectricity": 443.434,
          "airFlow": 6877348.5,
          "fanShare": 0.06926892405239234,
          "fanElectricity": 115.75245895806668,
          "reheatFlow": 2172.9,
          "mainHeatCoilFlow": 124.22688839556042,
          "heatingShare": 0.054101982335879165,
          "chwFlow": 4838.6,
          "mainCoolCoilFlow": 3760.4852027410852,
          "coolingShare": 0.05864950737862753,
          "dhwDemand": 10.3,
          "dhwShare": 0.021378165213781657,
          "heatingElectricity": 88.18698863523574,
          "heatingGas": 43.56708601174263,
          "chwPumpElectricity": 3.4629015136636836,
          "chillerElectricity": 186.28404330358268,
          "totalElectricity": 837.1203924105489,
          "totalGas": 43.56708601174263,
          "eui": 320.2499921535606
        },
        "instruction-lab": {
          "fanGroup": "lab",
          "area": 7140,
          "roomElectricity": 217.925,
          "airFlow": 17780086,
          "fanShare": 0.1790817241236218,
          "fanElectricity": 299.2561268322953,
          "reheatFlow": 6161.3,
          "mainHeatCoilFlow": 321.1651640433034,
          "heatingShare": 0.1526751602489756,
          "chwFlow": 5210.4,
          "mainCoolCoilFlow": 9722.024455568006,
          "coolingShare": 0.10184564027909228,
          "dhwDemand": 35.7,
          "dhwShare": 0.07409713574097138,
          "heatingElectricity": 248.86264865807368,
          "heatingGas": 129.77820864753127,
          "chwPumpElectricity": 6.013373984638724,
          "chillerElectricity": 323.4846891645879,
          "totalElectricity": 1095.5418386395957,
          "totalGas": 129.77820864753127,
          "eui": 171.61345200099817
        },
        "open-lab-bio": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 11397996,
          "fanShare": 0.1148010631238873,
          "fanElectricity": 191.83934974273998,
          "reheatFlow": 3308.9,
          "mainHeatCoilFlow": 205.88422660637949,
          "heatingShare": 0.08278027439533434,
          "chwFlow": 5056.8,
          "mainCoolCoilFlow": 6232.343075082218,
          "coolingShare": 0.07699687402438592,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 134.9330061882365,
          "heatingGas": 73.60332949946573,
          "chwPumpElectricity": 4.546203429895842,
          "chillerElectricity": 244.55941159747996,
          "totalElectricity": 970.9419709583524,
          "totalGas": 73.60332949946573,
          "eui": 232.12117787951513
        },
        "open-lab-chem": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 13099130,
          "fanShare": 0.13193495154744797,
          "fanElectricity": 220.47108819792686,
          "reheatFlow": 3852.8,
          "mainHeatCoilFlow": 236.61214210519321,
          "heatingShare": 0.09631392353377345,
          "chwFlow": 5036.2,
          "mainCoolCoilFlow": 7162.5110365981645,
          "coolingShare": 0.08320052378625686,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 156.9930437549802,
          "heatingGas": 81.84786615081319,
          "chwPumpElectricity": 4.91249172643575,
          "chillerElectricity": 264.26360030310843,
          "totalElectricity": 1041.7042239824514,
          "totalGas": 81.84786615081319,
          "eui": 249.67824225183654
        },
        "open-lab-general": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 11479039,
          "fanShare": 0.11561733140111333,
          "fanElectricity": 193.20338219381304,
          "reheatFlow": 3773,
          "mainHeatCoilFlow": 207.34812213475666,
          "heatingShare": 0.09374524536813593,
          "chwFlow": 5112.2,
          "mainCoolCoilFlow": 6276.65681056992,
          "coolingShare": 0.07767696514191226,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 152.8060623834967,
          "heatingGas": 80.28305823644479,
          "chwPumpElectricity": 4.586358729839067,
          "chillerElectricity": 246.71953414326327,
          "totalElectricity": 992.3793374504121,
          "totalGas": 80.28305823644479,
          "eui": 238.36942126374598
        },
        "support-lab-bio": {
          "fanGroup": "lab",
          "area": 3000,
          "roomElectricity": 483.746,
          "airFlow": 7518232,
          "fanShare": 0.07572392782134942,
          "fanElectricity": 126.53915110121633,
          "reheatFlow": 2180.3,
          "mainHeatCoilFlow": 135.80329215480805,
          "heatingShare": 0.05454891500911012,
          "chwFlow": 5099.9,
          "mainCoolCoilFlow": 4110.915738350981,
          "coolingShare": 0.06282177613932637,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 88.91549514965962,
          "heatingGas": 56.40512413769058,
          "chwPumpElectricity": 3.7092489503703856,
          "chillerElectricity": 199.5361084824871,
          "totalElectricity": 902.4460036837335,
          "totalGas": 56.40512413769058,
          "eui": 319.61704260714134
        },
        "support-lab-chem": {
          "fanGroup": "lab",
          "area": 3000,
          "roomElectricity": 483.746,
          "airFlow": 8880756,
          "fanShare": 0.08944732303326311,
          "fanElectricity": 149.47175418064162,
          "reheatFlow": 2513.7,
          "mainHeatCoilFlow": 160.41482912785406,
          "heatingShare": 0.06298081049873416,
          "chwFlow": 5169.5,
          "mainCoolCoilFlow": 4855.934162294394,
          "coolingShare": 0.06837782868903311,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 102.65960284428367,
          "heatingGas": 61.54173368722367,
          "chwPumpElectricity": 4.037300517115271,
          "chillerElectricity": 217.18338260338993,
          "totalElectricity": 957.0980401454304,
          "totalGas": 61.54173368722367,
          "eui": 339.5465912775514
        },
        "support-lab-general": {
          "fanGroup": "lab",
          "area": 6500,
          "roomElectricity": 1048.116,
          "airFlow": 17360014,
          "fanShare": 0.17485074245030155,
          "fanElectricity": 292.18590682825845,
          "reheatFlow": 5233.2,
          "mainHeatCoilFlow": 313.57732151037084,
          "heatingShare": 0.13063781987202705,
          "chwFlow": 11672.5,
          "mainCoolCoilFlow": 9492.33207629046,
          "coolingShare": 0.14435337547651292,
          "dhwDemand": 48.7,
          "dhwShare": 0.10107928601079287,
          "heatingElectricity": 212.9414753208823,
          "heatingGas": 129.7430824986263,
          "chwPumpElectricity": 8.52320070163523,
          "chillerElectricity": 458.49882889356235,
          "totalElectricity": 2020.2654117443383,
          "totalGas": 129.7430824986263,
          "eui": 330.77053757584065
        },
        "write-up": {
          "fanGroup": "lab",
          "area": 9000,
          "roomElectricity": 152.293,
          "airFlow": 4892158.5,
          "fanShare": 0.04927401244662323,
          "fanElectricity": 82.33978196504177,
          "reheatFlow": 562.7,
          "mainHeatCoilFlow": 88.36801392177411,
          "heatingShare": 0.015333967995670533,
          "chwFlow": 2168.6,
          "mainCoolCoilFlow": 2674.9974425047712,
          "coolingShare": 0.03303544472995012,
          "dhwDemand": 27,
          "dhwShare": 0.05603985056039851,
          "heatingElectricity": 24.994582508494904,
          "heatingGas": 37.150764936691495,
          "chwPumpElectricity": 1.9505447986351747,
          "chillerElectricity": 104.92801204447476,
          "totalElectricity": 366.5059213166466,
          "totalGas": 37.150764936691495,
          "eui": 44.850742917037564
        },
        "vivarium": {
          "fanGroup": "vivarium",
          "area": 4620,
          "roomElectricity": 612.582,
          "airFlow": 6070680,
          "fanShare": 1,
          "fanElectricity": 1303.197,
          "reheatFlow": 4600.4,
          "mainHeatCoilFlow": 308.2,
          "heatingShare": 0.11560745374382937,
          "chwFlow": 0,
          "mainCoolCoilFlow": 17943,
          "coolingShare": 0.12237907708592796,
          "dhwDemand": 28.8,
          "dhwShare": 0.059775840597758416,
          "heatingElectricity": 188.44176810679429,
          "heatingGas": 100.09013554873056,
          "chwPumpElectricity": 7.22575022746153,
          "chillerElectricity": 388.70350859306694,
          "totalElectricity": 2500.1500269273224,
          "totalGas": 100.09013554873056,
          "eui": 562.8225459904877
        }
      },
      "repairs": [],
      "dataQuality": []
    },
    {
      "id": "climate-3a",
      "kind": "climate",
      "label": "Atlanta, 3A",
      "locationId": "atlanta-3a",
      "provenance": {
        "kind": "simulated",
        "tool": "IES:VE",
        "completed": "2019-08-30",
        "workbook": "STEM Lab Zoned EUI Tool_Climate Zones_SHARED.xlsx",
        "sheet": "3A - Atlanta"
      },
      "prototype": {
        "totalArea": 115000,
        "totalElectricity": 0,
        "totalGas": 0,
        "blendedEui": 131.28179130434785
      },
      "plant": {
        "chillers": 3547.526,
        "chwPumps": 63.841,
        "hhwPumps": 111.275,
        "labFans": 1650.776,
        "hrcHeating": 1510.957,
        "generalFans": 304.197,
        "vivariumFans": 1148.939,
        "specialLabFans": 220.784,
        "auditoriumFans": 57.466,
        "dhwBoilers": 496.345,
        "hhwBoilers": 57.444
      },
      "zones": {
        "auditorium": {
          "fanGroup": "auditorium",
          "area": 1600,
          "roomElectricity": 40.143,
          "airFlow": 1108752.5,
          "fanShare": 1,
          "fanElectricity": 57.466,
          "reheatFlow": 430.3,
          "mainHeatCoilFlow": 78.4,
          "heatingShare": 0.012130052083577562,
          "chwFlow": 0,
          "mainCoolCoilFlow": 3320.6,
          "coolingShare": 0.01943852734201955,
          "dhwDemand": 77,
          "dhwShare": 0.15981735159817353,
          "heatingElectricity": 19.677758651646197,
          "heatingGas": 80.02134209088447,
          "chwPumpElectricity": 1.24097502404187,
          "chillerElectricity": 68.95868114752524,
          "totalElectricity": 187.48641482321332,
          "totalGas": 80.02134209088447,
          "eui": 167.19234807131113
        },
        "atrium": {
          "fanGroup": "general",
          "area": 4770,
          "roomElectricity": 46.411,
          "airFlow": 5593955,
          "fanShare": 0.31735966390558323,
          "fanElectricity": 96.5398576810867,
          "reheatFlow": 190.5,
          "mainHeatCoilFlow": 119.68617719230663,
          "heatingShare": 0.007396450727242968,
          "chwFlow": 457.6,
          "mainCoolCoilFlow": 3708.2754758309275,
          "coolingShare": 0.024386702505688185,
          "dhwDemand": 74.6,
          "dhwShare": 0.15483603154836031,
          "heatingElectricity": 11.998759056156816,
          "heatingGas": 77.27697179444665,
          "chwPumpElectricity": 1.5568714746656396,
          "chillerElectricity": 86.51246119319399,
          "totalElectricity": 243.01894940510311,
          "totalGas": 77.27697179444665,
          "eui": 67.1479918657337
        },
        "boh": {
          "fanGroup": "general",
          "area": 23040,
          "roomElectricity": 248.587,
          "airFlow": 593540.8,
          "fanShare": 0.03367311835762909,
          "fanElectricity": 10.243261585035695,
          "reheatFlow": 31.9,
          "mainHeatCoilFlow": 12.699177837444784,
          "heatingShare": 0.0010634762139825895,
          "chwFlow": 346.5,
          "mainCoolCoilFlow": 393.4627276309998,
          "coolingShare": 0.004331682742013658,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 1.7252051455614044,
          "heatingGas": 0.06109032763601587,
          "chwPumpElectricity": 0.27653895793289396,
          "chillerElectricity": 15.366757151044743,
          "totalElectricity": 276.19876283957467,
          "totalGas": 0.06109032763601587,
          "eui": 11.990445015937965
        },
        "cafe-kitchen": {
          "fanGroup": "general",
          "area": 300,
          "roomElectricity": 18.226,
          "airFlow": 933075.4,
          "fanShare": 0.05293580219050165,
          "fanElectricity": 16.10291221894403,
          "reheatFlow": 852.2,
          "mainHeatCoilFlow": 19.9637336478721,
          "heatingShare": 0.020796916678899463,
          "chwFlow": 0,
          "mainCoolCoilFlow": 618.5428061042917,
          "coolingShare": 0.0036209002134155784,
          "dhwDemand": 9.7,
          "dhwShare": 0.02013283520132835,
          "heatingElectricity": 33.73742373784444,
          "heatingGas": 11.187490169706022,
          "chwPumpElectricity": 0.23116189052466396,
          "chillerElectricity": 12.845237650497312,
          "totalElectricity": 81.14273549781043,
          "totalGas": 11.187490169706022,
          "eui": 307.7674188917215
        },
        "computational": {
          "fanGroup": "general",
          "area": 6720,
          "roomElectricity": 101.855,
          "airFlow": 1837417,
          "fanShare": 0.10424146092959366,
          "fanElectricity": 31.709939690399604,
          "reheatFlow": 520,
          "mainHeatCoilFlow": 39.312689615514685,
          "heatingShare": 0.01333692167494013,
          "chwFlow": 1663.5,
          "mainCoolCoilFlow": 1218.0377568240779,
          "coolingShare": 0.016868292017432545,
          "dhwDemand": 5.1,
          "dhwShare": 0.010585305105853052,
          "heatingElectricity": 21.635581122581478,
          "heatingGas": 6.020089391459893,
          "chwPumpElectricity": 1.076888630684911,
          "chillerElectricity": 59.8407045074344,
          "totalElectricity": 216.11811395110038,
          "totalGas": 6.020089391459893,
          "eui": 33.05628025930957
        },
        "office": {
          "fanGroup": "general",
          "area": 10420,
          "roomElectricity": 157.935,
          "airFlow": 3200666.5,
          "fanShare": 0.1815821623008872,
          "fanElectricity": 55.23674902544298,
          "reheatFlow": 1030.2,
          "mainHeatCoilFlow": 68.48026804872043,
          "heatingShare": 0.026198248230056884,
          "chwFlow": 2343.8,
          "mainCoolCoilFlow": 2121.7462579272824,
          "coolingShare": 0.026140951343664565,
          "dhwDemand": 7.9,
          "dhwShare": 0.016396845163968454,
          "heatingElectricity": 42.49963662274164,
          "heatingGas": 9.64342428423731,
          "chwPumpElectricity": 1.6688644747308894,
          "chillerElectricity": 92.73570455638497,
          "totalElectricity": 350.0759546793005,
          "totalGas": 9.64342428423731,
          "eui": 34.522013336232035
        },
        "restroom": {
          "fanGroup": "general",
          "area": 1000,
          "roomElectricity": 6.042,
          "airFlow": 367102.2,
          "fanShare": 0.02082666571522299,
          "fanElectricity": 6.3354092305736875,
          "reheatFlow": 333.8,
          "mainHeatCoilFlow": 7.854381909916256,
          "heatingShare": 0.008146816290838969,
          "chwFlow": 0,
          "mainCoolCoilFlow": 243.35485097459318,
          "coolingShare": 0.0014245798724576047,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 13.216026085120284,
          "heatingGas": 0.46798571501095376,
          "chwPumpElectricity": 0.09094660363756595,
          "chillerElectricity": 5.053734136620037,
          "totalElectricity": 30.738116055951572,
          "totalGas": 0.46798571501095376,
          "eui": 31.206101770962526
        },
        "classroom": {
          "fanGroup": "general",
          "area": 7500,
          "roomElectricity": 133.669,
          "airFlow": 4339784.5,
          "fanShare": 0.2462072988328758,
          "fanElectricity": 74.89552168306432,
          "reheatFlow": 272.5,
          "mainHeatCoilFlow": 92.85241240650413,
          "heatingShare": 0.008711900513763719,
          "chwFlow": 276.6,
          "mainCoolCoilFlow": 2876.876276577338,
          "coolingShare": 0.01846019840530584,
          "dhwDemand": 28.2,
          "dhwShare": 0.05853051058530511,
          "heatingElectricity": 14.132723794243947,
          "heatingGas": 29.551772689575913,
          "chwPumpElectricity": 1.1785175263931302,
          "chillerElectricity": 65.48803380798101,
          "totalElectricity": 289.36379681168245,
          "totalGas": 29.551772689575913,
          "eui": 42.522075933501114
        },
        "corridor": {
          "fanGroup": "general",
          "area": 5790,
          "roomElectricity": 49.653,
          "airFlow": 761005.5,
          "fanShare": 0.04317382776770645,
          "fanElectricity": 13.133348885453,
          "reheatFlow": 119.6,
          "mainHeatCoilFlow": 16.28219017087551,
          "heatingShare": 0.003240137692162986,
          "chwFlow": 40.1,
          "mainCoolCoilFlow": 504.47635574874175,
          "coolingShare": 0.003187906517207517,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 5.256255048632946,
          "heatingGas": 0.18612646958861057,
          "chwPumpElectricity": 0.20351913996504511,
          "chillerElectricity": 11.309181255363114,
          "totalElectricity": 79.5553043294141,
          "totalGas": 0.18612646958861057,
          "eui": 13.772267840933111
        },
        "mri-lab": {
          "fanGroup": "special-lab",
          "area": 2550,
          "roomElectricity": 184.56,
          "airFlow": 1851994.8,
          "fanShare": 0.42353850675637295,
          "fanElectricity": 93.51052567569904,
          "reheatFlow": 646.9,
          "mainHeatCoilFlow": 31.680680305376693,
          "heatingShare": 0.016180890495407337,
          "chwFlow": 151.1,
          "mainCoolCoilFlow": 1919.8153434252874,
          "coolingShare": 0.012122973115153965,
          "dhwDemand": 9.6,
          "dhwShare": 0.019925280199252802,
          "heatingElectricity": 26.24915835014564,
          "heatingGas": 10.819308274116311,
          "chwPumpElectricity": 0.7739427266445443,
          "chillerElectricity": 43.00656232330968,
          "totalElectricity": 348.1001890757989,
          "totalGas": 10.819308274116311,
          "eui": 140.75274405879028
        },
        "nmr-lab": {
          "fanGroup": "special-lab",
          "area": 1800,
          "roomElectricity": 313.741,
          "airFlow": 2520676.8,
          "fanShare": 0.576461493243627,
          "fanElectricity": 127.27347432430095,
          "reheatFlow": 132.3,
          "mainHeatCoilFlow": 43.1193196946233,
          "heatingShare": 0.00418290836320331,
          "chwFlow": 2379.9,
          "mainCoolCoilFlow": 2612.984656574713,
          "coolingShare": 0.029227948235974657,
          "dhwDemand": 6.7,
          "dhwShare": 0.013906185139061854,
          "heatingElectricity": 6.785647799856033,
          "heatingGas": 7.142548450863507,
          "chwPumpElectricity": 1.865941443332858,
          "chillerElectricity": 103.68690629377423,
          "totalElectricity": 553.352969861264,
          "totalGas": 7.142548450863507,
          "eui": 311.38639906229304
        },
        "core-lab": {
          "fanGroup": "lab",
          "area": 2750,
          "roomElectricity": 443.434,
          "airFlow": 6802880.5,
          "fanShare": 0.06912186183406646,
          "fanElectricity": 114.10471059099291,
          "reheatFlow": 1800.9,
          "mainHeatCoilFlow": 160.5448088819866,
          "heatingShare": 0.046771039297820595,
          "chwFlow": 4248.8,
          "mainCoolCoilFlow": 5017.419464295815,
          "coolingShare": 0.054243709092895234,
          "dhwDemand": 10.3,
          "dhwShare": 0.021378165213781657,
          "heatingElectricity": 75.87347662218211,
          "heatingGas": 13.297660994458465,
          "chwPumpElectricity": 3.462972632199525,
          "chillerElectricity": 192.43096834348225,
          "totalElectricity": 829.3061281888569,
          "totalGas": 13.297660994458465,
          "eui": 306.40137788484196
        },
        "instruction-lab": {
          "fanGroup": "lab",
          "area": 7140,
          "roomElectricity": 217.925,
          "airFlow": 17558330,
          "fanShare": 0.17840449502191671,
          "fanElectricity": 294.5058586742996,
          "reheatFlow": 5950.7,
          "mainHeatCoilFlow": 414.3684038161264,
          "heatingShare": 0.15177631463303226,
          "chwFlow": 4901.9,
          "mainCoolCoilFlow": 12950.030020743292,
          "coolingShare": 0.10450377335904296,
          "dhwDemand": 35.7,
          "dhwShare": 0.07409713574097138,
          "heatingElectricity": 246.2163944397732,
          "heatingGas": 45.496381457132344,
          "chwPumpElectricity": 6.671625395014662,
          "chillerElectricity": 370.7298530893122,
          "totalElectricity": 1136.0487315983996,
          "totalGas": 45.496381457132344,
          "eui": 165.48250883130703
        },
        "open-lab-bio": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 11179930,
          "fanShare": 0.11359564184238348,
          "fanElectricity": 187.52095925800245,
          "reheatFlow": 3538.3,
          "mainHeatCoilFlow": 263.84113687782525,
          "heatingShare": 0.09066280719371107,
          "chwFlow": 5330.6,
          "mainCoolCoilFlow": 8245.683338324803,
          "coolingShare": 0.07947447897218307,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 147.07610703946833,
          "heatingGas": 28.38728398510304,
          "chwPumpElectricity": 5.07373021206314,
          "chillerElectricity": 281.9377804902727,
          "totalElectricity": 1016.6725769998066,
          "totalGas": 28.38728398510304,
          "eui": 232.23552466331324
        },
        "open-lab-chem": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 13184017,
          "fanShare": 0.13395851970235012,
          "fanElectricity": 221.13550932016673,
          "reheatFlow": 3846.4,
          "mainHeatCoilFlow": 311.1366559447667,
          "heatingShare": 0.09913728361704915,
          "chwFlow": 4881.8,
          "mainCoolCoilFlow": 9723.78443416828,
          "coolingShare": 0.08549992542605409,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 160.8236738766529,
          "heatingGas": 28.87409180876527,
          "chwPumpElectricity": 5.458400739124719,
          "chillerElectricity": 303.3132084469879,
          "totalElectricity": 1085.7947923829324,
          "totalGas": 28.87409180876527,
          "eui": 247.70419648704393
        },
        "open-lab-general": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 11367617,
          "fanShare": 0.11550266856173427,
          "fanElectricity": 190.66903319766547,
          "reheatFlow": 3598.2,
          "mainHeatCoilFlow": 268.2704625942822,
          "heatingShare": 0.09219675268504594,
          "chwFlow": 4916,
          "mainCoolCoilFlow": 8384.110642316882,
          "coolingShare": 0.07785778605449674,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 149.56452250176747,
          "heatingGas": 28.475399949907278,
          "chwPumpElectricity": 4.9705189195051265,
          "chillerElectricity": 276.20252033076457,
          "totalElectricity": 1016.4705949497027,
          "totalGas": 28.475399949907278,
          "eui": 232.21022108880223
        },
        "support-lab-bio": {
          "fanGroup": "lab",
          "area": 3000,
          "roomElectricity": 483.746,
          "airFlow": 7468173,
          "fanShare": 0.07588168309863824,
          "fanElectricity": 125.26366129883765,
          "reheatFlow": 2424.7,
          "mainHeatCoilFlow": 176.2454017798214,
          "heatingShare": 0.06202005738181796,
          "chwFlow": 5503,
          "mainCoolCoilFlow": 5508.101542122998,
          "coolingShare": 0.06445810949596804,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 100.61092172662133,
          "heatingGas": 26.741929864908652,
          "chwPumpElectricity": 4.115070168332096,
          "chillerElectricity": 228.66681934779353,
          "totalElectricity": 942.4024725415845,
          "totalGas": 26.741929864908652,
          "eui": 323.0481341354977
        },
        "support-lab-chem": {
          "fanGroup": "lab",
          "area": 3000,
          "roomElectricity": 483.746,
          "airFlow": 8825301,
          "fanShare": 0.08967102043995166,
          "fanElectricity": 148.02676843778164,
          "reheatFlow": 2562.9,
          "mainHeatCoilFlow": 208.2729900034265,
          "heatingShare": 0.06607916788155087,
          "chwFlow": 5424.6,
          "mainCoolCoilFlow": 6509.04231166038,
          "coolingShare": 0.06985858952149962,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 107.19574067082404,
          "heatingGas": 26.97510140845531,
          "chwPumpElectricity": 4.459842213642057,
          "chillerElectricity": 247.82516265084746,
          "totalElectricity": 991.2535139730953,
          "totalGas": 26.97510140845531,
          "eui": 339.4095384605169
        },
        "support-lab-general": {
          "fanGroup": "lab",
          "area": 6500,
          "roomElectricity": 1048.116,
          "airFlow": 17238482,
          "fanShare": 0.17515462325599307,
          "fanElectricity": 289.1410483600352,
          "reheatFlow": 5190.3,
          "mainHeatCoilFlow": 406.8201401017651,
          "heatingShare": 0.1334644364408794,
          "chwFlow": 11648.7,
          "mainCoolCoilFlow": 12714.128246367556,
          "coolingShare": 0.14261805185687584,
          "dhwDemand": 48.7,
          "dhwShare": 0.10107928601079287,
          "heatingElectricity": 216.51027965636072,
          "heatingGas": 57.83692930193687,
          "chwPumpElectricity": 9.10487904859481,
          "chillerElectricity": 505.9412470316153,
          "totalElectricity": 2068.813454096606,
          "totalGas": 57.83692930193687,
          "eui": 327.17698206131433
        },
        "write-up": {
          "fanGroup": "lab",
          "area": 9000,
          "roomElectricity": 152.293,
          "airFlow": 4793922,
          "fanShare": 0.048709486242965984,
          "fanElectricity": 80.40845086221842,
          "reheatFlow": 501.9,
          "mainHeatCoilFlow": 113.13432468571966,
          "heatingShare": 0.014665615080844765,
          "chwFlow": 2112.4,
          "mainCoolCoilFlow": 3535.725425886273,
          "coolingShare": 0.03306367539668919,
          "dhwDemand": 27,
          "dhwShare": 0.05603985056039851,
          "heatingElectricity": 23.791030083828968,
          "heatingGas": 28.65755121910505,
          "chwPumpElectricity": 2.1108181010000346,
          "chillerElectricity": 117.2942481253152,
          "totalElectricity": 375.89754717236264,
          "totalGas": 28.65755121910505,
          "eui": 44.950566487940854
        },
        "vivarium": {
          "fanGroup": "vivarium",
          "area": 4620,
          "roomElectricity": 612.582,
          "airFlow": 6070680,
          "fanShare": 1,
          "fanElectricity": 1148.939,
          "reheatFlow": 4733.7,
          "mainHeatCoilFlow": 376,
          "heatingShare": 0.12184180682417194,
          "chwFlow": 0,
          "mainCoolCoilFlow": 22072.6,
          "coolingShare": 0.12921123851396152,
          "dhwDemand": 28.8,
          "dhwShare": 0.059775840597758416,
          "heatingElectricity": 197.6556779679901,
          "heatingGas": 36.66852035270214,
          "chwPumpElectricity": 8.248974677969818,
          "chillerElectricity": 458.38022812047984,
          "totalElectricity": 2425.80588076644,
          "totalGas": 36.66852035270214,
          "eui": 533.0031171253555
        }
      },
      "repairs": [
        {
          "code": "fan-allocation",
          "detail": "The sheet assigned fan energy that did not add up: write-up from general to lab, and the fan allocation rederived from airflow. The rederivation reproduces every other case in this dataset exactly.",
          "euiBefore": 131.4512048421939,
          "euiAfter": 131.28179130434785
        }
      ],
      "dataQuality": []
    },
    {
      "id": "climate-5b",
      "kind": "climate",
      "label": "Denver, 5B",
      "locationId": "denver-5b",
      "provenance": {
        "kind": "simulated",
        "tool": "IES:VE",
        "completed": "2019-08-30",
        "workbook": "STEM Lab Zoned EUI Tool_Climate Zones_SHARED.xlsx",
        "sheet": "5B - Denver"
      },
      "prototype": {
        "totalArea": 115000,
        "totalElectricity": 0,
        "totalGas": 0,
        "blendedEui": 133.07113913043477
      },
      "plant": {
        "chillers": 1966.136,
        "chwPumps": 37.216,
        "hhwPumps": 180.39,
        "labFans": 1712.058,
        "hrcHeating": 1274.477,
        "generalFans": 336.646,
        "vivariumFans": 2110.007,
        "specialLabFans": 212.053,
        "auditoriumFans": 58.289,
        "dhwBoilers": 496.345,
        "hhwBoilers": 991.708
      },
      "zones": {
        "auditorium": {
          "fanGroup": "auditorium",
          "area": 1600,
          "roomElectricity": 40.143,
          "airFlow": 1152938.5,
          "fanShare": 1,
          "fanElectricity": 58.289,
          "reheatFlow": 396.9,
          "mainHeatCoilFlow": 29.4,
          "heatingShare": 0.010992836476722417,
          "chwFlow": 0,
          "mainCoolCoilFlow": 1117.9,
          "coolingShare": 0.012471217692417534,
          "dhwDemand": 77,
          "dhwShare": 0.15981735159817353,
          "heatingElectricity": 15.993115026379716,
          "heatingGas": 90.22622725565287,
          "chwPumpElectricity": 0.464128837641011,
          "chillerElectricity": 24.52011006889904,
          "totalElectricity": 139.40935393291977,
          "totalGas": 90.22622725565287,
          "eui": 143.52223824285792
        },
        "atrium": {
          "fanGroup": "general",
          "area": 4770,
          "roomElectricity": 46.411,
          "airFlow": 6128033,
          "fanShare": 0.2947375173814478,
          "fanElectricity": 99.22220627639489,
          "reheatFlow": 253.9,
          "mainHeatCoilFlow": 34.7495532992727,
          "heatingShare": 0.0074432965951158276,
          "chwFlow": 501.6,
          "mainCoolCoilFlow": 1258.8239367361637,
          "coolingShare": 0.01963917179173394,
          "dhwDemand": 74.6,
          "dhwShare": 0.15483603154836031,
          "heatingElectricity": 10.82900658744638,
          "heatingGas": 84.23366685862003,
          "chwPumpElectricity": 0.7308914174011703,
          "chillerElectricity": 38.6132826699126,
          "totalElectricity": 195.80638695115505,
          "totalGas": 84.23366685862003,
          "eui": 58.70860666871595
        },
        "boh": {
          "fanGroup": "general",
          "area": 23040,
          "roomElectricity": 248.587,
          "airFlow": 753905,
          "fanShare": 0.036260262965532405,
          "fanElectricity": 12.206872486294623,
          "reheatFlow": 161.9,
          "mainHeatCoilFlow": 4.275085003636271,
          "heatingShare": 0.004285093914966975,
          "chwFlow": 117.9,
          "mainCoolCoilFlow": 154.8675831257889,
          "coolingShare": 0.003042976928702307,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 6.234241728786259,
          "heatingGas": 4.249561916224068,
          "chwPumpElectricity": 0.11324742937858506,
          "chillerElectricity": 5.982906486691039,
          "totalElectricity": 273.1242681311505,
          "totalGas": 4.249561916224068,
          "eui": 12.038794706917297
        },
        "cafe-kitchen": {
          "fanGroup": "general",
          "area": 300,
          "roomElectricity": 18.226,
          "airFlow": 935251.8,
          "fanShare": 0.04498242644230708,
          "fanElectricity": 15.14315393209691,
          "reheatFlow": 867.2,
          "mainHeatCoilFlow": 5.303428077548005,
          "heatingShare": 0.022498915107286476,
          "chwFlow": 0,
          "mainCoolCoilFlow": 192.11994333509352,
          "coolingShare": 0.002143277248758272,
          "dhwDemand": 9.7,
          "dhwShare": 0.02013283520132835,
          "heatingElectricity": 32.73292912539256,
          "heatingGas": 32.30518619122017,
          "chwPumpElectricity": 0.07976420608978786,
          "chillerElectricity": 4.213974556764594,
          "totalElectricity": 70.39582182034385,
          "totalGas": 32.30518619122017,
          "eui": 342.3366933718801
        },
        "computational": {
          "fanGroup": "general",
          "area": 6720,
          "roomElectricity": 101.855,
          "airFlow": 2009889.1,
          "fanShare": 0.09666882073677355,
          "fanElectricity": 32.54317182575187,
          "reheatFlow": 766.3,
          "mainHeatCoilFlow": 11.397253964865602,
          "heatingShare": 0.020054184239342795,
          "chwFlow": 1093.9,
          "mainCoolCoilFlow": 412.8725333667598,
          "coolingShare": 0.016809453686888208,
          "dhwDemand": 5.1,
          "dhwShare": 0.010585305105853052,
          "heatingElectricity": 29.176170861739937,
          "heatingGas": 25.141858206394797,
          "chwPumpElectricity": 0.6255806284112315,
          "chillerElectricity": 33.04967203412363,
          "totalElectricity": 197.24959535002665,
          "totalGas": 25.141858206394797,
          "eui": 33.093966303038904
        },
        "office": {
          "fanGroup": "general",
          "area": 10420,
          "roomElectricity": 157.935,
          "airFlow": 4335409.5,
          "fanShare": 0.2085184320746876,
          "fanElectricity": 70.19689608421528,
          "reheatFlow": 1897.8,
          "mainHeatCoilFlow": 24.58432314160567,
          "heatingShare": 0.049571795706569034,
          "chwFlow": 1669,
          "mainCoolCoilFlow": 890.5822233909907,
          "coolingShare": 0.028554528231103975,
          "dhwDemand": 7.9,
          "dhwShare": 0.016396845163968454,
          "heatingElectricity": 72.12036970422898,
          "heatingGas": 57.29923848948008,
          "chwPumpElectricity": 1.0626853226487656,
          "chillerElectricity": 56.14208591818984,
          "totalElectricity": 357.45703702928284,
          "totalGas": 57.29923848948008,
          "eui": 39.803865212933104
        },
        "restroom": {
          "fanGroup": "general",
          "area": 1000,
          "roomElectricity": 6.042,
          "airFlow": 402994.7,
          "fanShare": 0.019382672612220164,
          "fanElectricity": 6.525099204213469,
          "reheatFlow": 312.1,
          "mainHeatCoilFlow": 2.2852171009807574,
          "heatingShare": 0.008106932400398682,
          "chwFlow": 0,
          "mainCoolCoilFlow": 82.78339472679232,
          "coolingShare": 0.0009235260192818292,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 11.79450842057083,
          "heatingGas": 8.039709716934576,
          "chwPumpElectricity": 0.034369944333592556,
          "chillerElectricity": 1.8157777534466986,
          "totalElectricity": 26.211755322564592,
          "totalGas": 8.039709716934576,
          "eui": 34.251465039499166
        },
        "classroom": {
          "fanGroup": "general",
          "area": 7500,
          "roomElectricity": 133.669,
          "airFlow": 5337155,
          "fanShare": 0.2566989790329101,
          "fanElectricity": 86.41668449551307,
          "reheatFlow": 427,
          "mainHeatCoilFlow": 30.264809627980103,
          "heatingShare": 0.011791314282899349,
          "chwFlow": 282.2,
          "mainCoolCoilFlow": 1096.3613394495592,
          "coolingShare": 0.015379138175709954,
          "dhwDemand": 28.2,
          "dhwShare": 0.05853051058530511,
          "heatingElectricity": 17.154794036818927,
          "heatingGas": 40.74486698132881,
          "chwPumpElectricity": 0.5723500063472217,
          "chillerElectricity": 30.237477216237664,
          "totalElectricity": 268.05030575491685,
          "totalGas": 40.74486698132881,
          "eui": 41.17268969816609
        },
        "corridor": {
          "fanGroup": "general",
          "area": 5790,
          "roomElectricity": 49.653,
          "airFlow": 888854.8,
          "fanShare": 0.04275088875412116,
          "fanElectricity": 14.391915695519874,
          "reheatFlow": 227.4,
          "mainHeatCoilFlow": 5.040329784110885,
          "heatingShare": 0.00599385065895417,
          "chwFlow": 29.9,
          "mainCoolCoilFlow": 182.58904586885149,
          "coolingShare": 0.002370513595388265,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 8.720255526640678,
          "heatingGas": 5.944149649290122,
          "chwPumpElectricity": 0.08822103396596967,
          "chillerElectricity": 4.660752118382302,
          "totalElectricity": 77.51414437450882,
          "totalGas": 5.944149649290122,
          "eui": 14.414213130189799
        },
        "mri-lab": {
          "fanGroup": "special-lab",
          "area": 2550,
          "roomElectricity": 184.56,
          "airFlow": 1562999.1,
          "fanShare": 0.3913685384434927,
          "fanElectricity": 82.99087268255795,
          "reheatFlow": 535.6,
          "mainHeatCoilFlow": 27.200113421822742,
          "heatingShare": 0.014512713150192183,
          "chwFlow": 2.5,
          "mainCoolCoilFlow": 823.3219943235755,
          "coolingShare": 0.00921281498022695,
          "dhwDemand": 9.6,
          "dhwShare": 0.019925280199252802,
          "heatingElectricity": 21.114067442680653,
          "heatingGas": 24.282186933248923,
          "chwPumpElectricity": 0.34286412230412616,
          "chillerElectricity": 18.113647193963494,
          "totalElectricity": 307.1214514415062,
          "totalGas": 24.282186933248923,
          "eui": 129.96221112735498
        },
        "nmr-lab": {
          "fanGroup": "special-lab",
          "area": 1800,
          "roomElectricity": 313.741,
          "airFlow": 2430676.8,
          "fanShare": 0.6086314615565074,
          "fanElectricity": 129.06212731744205,
          "reheatFlow": 32,
          "mainHeatCoilFlow": 42.299886578177265,
          "heatingShare": 0.0019159430058478197,
          "chwFlow": 409.7,
          "mainCoolCoilFlow": 1280.3780056764244,
          "coolingShare": 0.018854397285944687,
          "dhwDemand": 6.7,
          "dhwShare": 0.013906185139061854,
          "heatingElectricity": 2.7874422530888,
          "heatingGas": 8.802321469290986,
          "chwPumpElectricity": 0.7016852493937175,
          "chillerElectricity": 37.070309262198144,
          "totalElectricity": 483.36256408212273,
          "totalGas": 8.802321469290986,
          "eui": 273.42493641745205
        },
        "core-lab": {
          "fanGroup": "lab",
          "area": 2750,
          "roomElectricity": 443.434,
          "airFlow": 6970446.5,
          "fanShare": 0.0692947755771982,
          "fanElectricity": 118.63667488514679,
          "reheatFlow": 1885,
          "mainHeatCoilFlow": 46.42749963672279,
          "heatingShare": 0.04980498867030575,
          "chwFlow": 4663.2,
          "mainCoolCoilFlow": 1301.0509883272423,
          "coolingShare": 0.06653678544381919,
          "dhwDemand": 10.3,
          "dhwShare": 0.021378165213781657,
          "heatingElectricity": 72.45963445180172,
          "heatingGas": 60.00295111728603,
          "chwPumpElectricity": 2.476233007077175,
          "chillerElectricity": 130.8203691853689,
          "totalElectricity": 767.8269115293947,
          "totalGas": 60.00295111728603,
          "eui": 301.02904096242935
        },
        "instruction-lab": {
          "fanGroup": "lab",
          "area": 7140,
          "roomElectricity": 217.925,
          "airFlow": 18200050,
          "fanShare": 0.18093078832809148,
          "fanElectricity": 309.76400360341563,
          "reheatFlow": 6338,
          "mainHeatCoilFlow": 121.22362817982129,
          "heatingShare": 0.1665615508120161,
          "chwFlow": 6653.6,
          "mainCoolCoilFlow": 3397.084109332914,
          "coolingShare": 0.11212476025155417,
          "dhwDemand": 35.7,
          "dhwShare": 0.07409713574097138,
          "heatingElectricity": 242.32490374522544,
          "heatingGas": 201.9581652720353,
          "chwPumpElectricity": 4.17283507752184,
          "chillerElectricity": 220.4525276219497,
          "totalElectricity": 994.6392700481126,
          "totalGas": 201.9581652720353,
          "eui": 167.59067721570702
        },
        "open-lab-bio": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 11355455,
          "fanShare": 0.11288713080316637,
          "fanElectricity": 193.2693153886074,
          "reheatFlow": 2706.7,
          "mainHeatCoilFlow": 75.63437763812146,
          "heatingShare": 0.07174700172868662,
          "chwFlow": 4981.4,
          "mainCoolCoilFlow": 2119.5236131079305,
          "coolingShare": 0.07921742928374369,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 104.38234516400912,
          "heatingGas": 94.33132527901984,
          "chwPumpElectricity": 2.9481558482238053,
          "chillerElectricity": 155.75223954222267,
          "totalElectricity": 851.4160559430629,
          "totalGas": 94.33132527901984,
          "eui": 210.1660847160184
        },
        "open-lab-chem": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 13243885,
          "fanShare": 0.13166043794256532,
          "fanElectricity": 225.4103060630725,
          "reheatFlow": 3183,
          "mainHeatCoilFlow": 88.21249342151877,
          "heatingShare": 0.0843535163518512,
          "chwFlow": 5139.4,
          "mainCoolCoilFlow": 2472.0037186344293,
          "coolingShare": 0.0849123112263765,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 122.72314727426873,
          "heatingGas": 106.83330668292915,
          "chwPumpElectricity": 3.160096574600828,
          "chillerElectricity": 166.949151945383,
          "totalElectricity": 913.3067018573252,
          "totalGas": 106.83330668292915,
          "eui": 226.69777967561205
        },
        "open-lab-general": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 11526728,
          "fanShare": 0.11458979419746018,
          "fanElectricity": 196.1843738741153,
          "reheatFlow": 3075,
          "mainHeatCoilFlow": 76.77516211229832,
          "heatingShare": 0.08127363117170018,
          "chwFlow": 5401.9,
          "mainCoolCoilFlow": 2151.492139933833,
          "coolingShare": 0.08426513793121956,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 118.24232396187794,
          "heatingGas": 103.77895991069194,
          "chwPumpElectricity": 3.1360113732482673,
          "chillerElectricity": 165.6767212315363,
          "totalElectricity": 878.3034304407779,
          "totalGas": 103.77895991069194,
          "eui": 218.24053118921552
        },
        "support-lab-bio": {
          "fanGroup": "lab",
          "area": 3000,
          "roomElectricity": 483.746,
          "airFlow": 7590843,
          "fanShare": 0.07546227664565619,
          "fanElectricity": 129.19579442940883,
          "reheatFlow": 2312.7,
          "mainHeatCoilFlow": 50.559725352589645,
          "heatingShare": 0.060940482554128435,
          "chwFlow": 5391.9,
          "mainCoolCoilFlow": 1416.8495213881822,
          "coolingShare": 0.07595795464207507,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 88.66029703207718,
          "heatingGas": 83.6144137614571,
          "chwPumpElectricity": 2.8268512399594656,
          "chillerElectricity": 149.3436691081509,
          "totalElectricity": 853.7726118095964,
          "totalGas": 83.6144137614571,
          "eui": 312.4623418570178
        },
        "support-lab-chem": {
          "fanGroup": "lab",
          "area": 3000,
          "roomElectricity": 483.746,
          "airFlow": 8917088,
          "fanShare": 0.08864677632374442,
          "fanElectricity": 151.76842257927723,
          "reheatFlow": 2677.9,
          "mainHeatCoilFlow": 59.39334013690876,
          "heatingShare": 0.07058554557106816,
          "chwFlow": 5560.8,
          "mainCoolCoilFlow": 1664.3964135440956,
          "coolingShare": 0.08060380834044444,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 102.69258092834325,
          "heatingGas": 93.17949991586036,
          "chwPumpElectricity": 2.99975133119798,
          "chillerElectricity": 158.47804931524806,
          "totalElectricity": 899.6848041540666,
          "totalGas": 93.17949991586036,
          "eui": 330.95476802330893
        },
        "support-lab-general": {
          "fanGroup": "lab",
          "area": 6500,
          "roomElectricity": 1048.116,
          "airFlow": 17512536,
          "fanShare": 0.174096057104463,
          "fanElectricity": 298.0625473341527,
          "reheatFlow": 5092.7,
          "mainHeatCoilFlow": 116.6443582599902,
          "heatingShare": 0.13433138794578597,
          "chwFlow": 11835.9,
          "mainCoolCoilFlow": 3268.757929770555,
          "coolingShare": 0.16850655444285656,
          "dhwDemand": 48.7,
          "dhwShare": 0.10107928601079287,
          "heatingElectricity": 195.43430338652183,
          "heatingGas": 183.3877102919665,
          "chwPumpElectricity": 6.27113993014535,
          "chillerElectricity": 331.30680292606024,
          "totalElectricity": 1879.1907935768802,
          "totalGas": 183.3877102919665,
          "eui": 317.31976982597644
        },
        "write-up": {
          "fanGroup": "lab",
          "area": 9000,
          "roomElectricity": 152.293,
          "airFlow": 5274195.5,
          "fanShare": 0.052431963077654874,
          "fanElectricity": 89.76656184280365,
          "reheatFlow": 827.6,
          "mainHeatCoilFlow": 35.129415262028765,
          "heatingShare": 0.022246876344437796,
          "chwFlow": 2563.5,
          "mainCoolCoilFlow": 984.4415659608168,
          "coolingShare": 0.03958059900623858,
          "dhwDemand": 27,
          "dhwShare": 0.05603985056039851,
          "heatingElectricity": 32.36624624660319,
          "heatingGas": 49.87750487219072,
          "chwPumpElectricity": 1.4730315726161751,
          "chillerElectricity": 77.82084060772989,
          "totalElectricity": 353.7196802697529,
          "totalGas": 49.87750487219072,
          "eui": 44.84413168243819
        },
        "vivarium": {
          "fanGroup": "vivarium",
          "area": 4620,
          "roomElectricity": 612.582,
          "airFlow": 6080680,
          "fanShare": 1,
          "fanElectricity": 2110.007,
          "reheatFlow": 3866.6,
          "mainHeatCoilFlow": 49.7,
          "heatingShare": 0.10098814331172415,
          "chwFlow": 0,
          "mainCoolCoilFlow": 7071.9,
          "coolingShare": 0.0788936437955162,
          "dhwDemand": 28.8,
          "dhwShare": 0.059775840597758416,
          "heatingElectricity": 146.9243170954982,
          "heatingGas": 129.82018922887772,
          "chwPumpElectricity": 2.9361058474939306,
          "chillerElectricity": 155.11563323754103,
          "totalElectricity": 3027.5650561805332,
          "totalGas": 129.82018922887772,
          "eui": 683.4167197855868
        }
      },
      "repairs": [],
      "dataQuality": []
    },
    {
      "id": "ecm-1-plugs",
      "kind": "measure",
      "label": "Plug load reduction",
      "measureNumber": 1,
      "locationId": "boston-5a",
      "description": "Open lab receptacle load reduced from 8 to 4 W/sf.",
      "provenance": {
        "kind": "simulated",
        "tool": "IES:VE",
        "completed": "2019-08-30",
        "workbook": "STEM Lab Zoned EUI Tool_ECM_SHARED.xlsx",
        "sheet": "ECM 1 - Plugs"
      },
      "prototype": {
        "totalArea": 115000,
        "totalElectricity": 0,
        "totalGas": 0,
        "blendedEui": 129.45081739130435
      },
      "plant": {
        "chillers": 2489.539,
        "chwPumps": 47.681,
        "hhwPumps": 167.91,
        "labFans": 1689.818,
        "hrcHeating": 1631.598,
        "generalFans": 331.738,
        "vivariumFans": 1558.113,
        "specialLabFans": 216.839,
        "auditoriumFans": 60.313,
        "dhwBoilers": 496.345,
        "hhwBoilers": 764.925
      },
      "zones": {
        "auditorium": {
          "fanGroup": "auditorium",
          "area": 1600,
          "roomElectricity": 40.143,
          "airFlow": 1140669.8,
          "fanShare": 1,
          "fanElectricity": 60.313,
          "reheatFlow": 495.9,
          "mainHeatCoilFlow": 54.6,
          "heatingShare": 0.012992775497584359,
          "chwFlow": 0,
          "mainCoolCoilFlow": 2370.7,
          "coolingShare": 0.022384163112538324,
          "dhwDemand": 77,
          "dhwShare": 0.15981735159817353,
          "heatingElectricity": 23.380603450107035,
          "heatingGas": 89.26304217648516,
          "chwPumpElectricity": 1.0672992813689397,
          "chillerElectricity": 55.72624705102555,
          "totalElectricity": 180.63014978250155,
          "totalGas": 89.26304217648516,
          "eui": 168.6832449743667
        },
        "atrium": {
          "fanGroup": "general",
          "area": 4770,
          "roomElectricity": 46.411,
          "airFlow": 5986574,
          "fanShare": 0.30307760632837455,
          "fanElectricity": 100.54235896816232,
          "reheatFlow": 304.8,
          "mainHeatCoilFlow": 76.19371023095336,
          "heatingShare": 0.00899212669032241,
          "chwFlow": 363.7,
          "mainCoolCoilFlow": 1994.0384953162747,
          "coolingShare": 0.02226178051034301,
          "dhwDemand": 74.6,
          "dhwShare": 0.15483603154836031,
          "heatingElectricity": 16.1814039162487,
          "heatingGas": 83.73039258746577,
          "chwPumpElectricity": 1.061463956513665,
          "chillerElectricity": 55.421570789938826,
          "totalElectricity": 219.6177976308635,
          "totalGas": 83.73039258746577,
          "eui": 63.595008431515566
        },
        "boh": {
          "fanGroup": "general",
          "area": 23040,
          "roomElectricity": 248.587,
          "airFlow": 761356.1,
          "fanShare": 0.038544580648549,
          "fanElectricity": 12.786702095188348,
          "reheatFlow": 176.6,
          "mainHeatCoilFlow": 9.69010757504522,
          "heatingShare": 0.0043967766487618565,
          "chwFlow": 67.1,
          "mainCoolCoilFlow": 253.59635946099846,
          "coolingShare": 0.003028016880993889,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 7.912034753660151,
          "heatingGas": 3.3632043780541627,
          "chwPumpElectricity": 0.14437887290266962,
          "chillerElectricity": 7.538366117892647,
          "totalElectricity": 276.9684818396438,
          "totalGas": 3.3632043780541627,
          "eui": 12.167173880976474
        },
        "cafe-kitchen": {
          "fanGroup": "general",
          "area": 300,
          "roomElectricity": 18.226,
          "airFlow": 950406.3,
          "fanShare": 0.048115477473995485,
          "fanElectricity": 15.961732266268314,
          "reheatFlow": 878.6,
          "mainHeatCoilFlow": 12.096231036962465,
          "heatingShare": 0.021022009384936938,
          "chwFlow": 0,
          "mainCoolCoilFlow": 316.5661609446585,
          "coolingShare": 0.002989019522712826,
          "dhwDemand": 9.7,
          "dhwShare": 0.02013283520132835,
          "heatingElectricity": 37.8292740642691,
          "heatingGas": 26.073092616776208,
          "chwPumpElectricity": 0.14251943986247026,
          "chillerElectricity": 7.441280673554967,
          "totalElectricity": 79.60080644395485,
          "totalGas": 26.073092616776208,
          "eui": 352.24633020243687
        },
        "computational": {
          "fanGroup": "general",
          "area": 6720,
          "roomElectricity": 101.855,
          "airFlow": 1955750.8,
          "fanShare": 0.099012268292149,
          "fanElectricity": 32.84613185870092,
          "reheatFlow": 780.6,
          "mainHeatCoilFlow": 24.89168424864626,
          "heatingShare": 0.019011031096482778,
          "chwFlow": 983.9,
          "mainCoolCoilFlow": 651.4314167745359,
          "coolingShare": 0.015440808696224578,
          "dhwDemand": 5.1,
          "dhwShare": 0.010585305105853052,
          "heatingElectricity": 34.21050254636953,
          "heatingGas": 19.79597622424172,
          "chwPumpElectricity": 0.7362331994446841,
          "chillerElectricity": 38.440495440790244,
          "totalElectricity": 208.08836304530536,
          "totalGas": 19.79597622424172,
          "eui": 33.91136001034927
        },
        "office": {
          "fanGroup": "general",
          "area": 10420,
          "roomElectricity": 157.935,
          "airFlow": 3970628,
          "fanShare": 0.20101788265883314,
          "fanElectricity": 66.68527035747599,
          "reheatFlow": 1840.9,
          "mainHeatCoilFlow": 50.53589570043065,
          "heatingShare": 0.04464123880273948,
          "chwFlow": 1324.6,
          "mainCoolCoilFlow": 1322.556955377261,
          "coolingShare": 0.024994471284285207,
          "dhwDemand": 7.9,
          "dhwShare": 0.016396845163968454,
          "heatingElectricity": 80.33226635544011,
          "heatingGas": 42.28569170409541,
          "chwPumpElectricity": 1.191761385306003,
          "chillerElectricity": 62.224711046608114,
          "totalElectricity": 368.3690091448302,
          "totalGas": 42.28569170409541,
          "eui": 39.41024000469536
        },
        "restroom": {
          "fanGroup": "general",
          "area": 1000,
          "roomElectricity": 6.042,
          "airFlow": 400113.9,
          "fanShare": 0.020256253922646014,
          "fanElectricity": 6.719769163790743,
          "reheatFlow": 366.5,
          "mainHeatCoilFlow": 5.092422236153208,
          "heatingShare": 0.008770239634364964,
          "chwFlow": 0,
          "mainCoolCoilFlow": 133.27197143326492,
          "coolingShare": 0.0012583547251409923,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 15.782116383956827,
          "heatingGas": 6.70857555231662,
          "chwPumpElectricity": 0.05999961164944765,
          "chillerElectricity": 3.132723164072781,
          "totalElectricity": 31.736608323469802,
          "totalGas": 6.70857555231662,
          "eui": 38.44518387578642
        },
        "classroom": {
          "fanGroup": "general",
          "area": 7500,
          "roomElectricity": 133.669,
          "airFlow": 4853729.5,
          "fanShare": 0.24572597258889947,
          "fanElectricity": 81.51664269469633,
          "reheatFlow": 403.9,
          "mainHeatCoilFlow": 61.77550950884933,
          "heatingShare": 0.010990767211211063,
          "chwFlow": 198.8,
          "mainCoolCoilFlow": 1616.7048914541463,
          "coolingShare": 0.01714200768630396,
          "dhwDemand": 28.2,
          "dhwShare": 0.05853051058530511,
          "heatingElectricity": 19.777973522712,
          "heatingGas": 37.45843888549889,
          "chwPumpElectricity": 0.817348068490659,
          "chillerElectricity": 42.67569667335348,
          "totalElectricity": 278.4566609592525,
          "totalGas": 37.45843888549889,
          "eui": 42.12201331263351
        },
        "corridor": {
          "fanGroup": "general",
          "area": 5790,
          "roomElectricity": 49.653,
          "airFlow": 874052.2,
          "fanShare": 0.04424995808655329,
          "fanElectricity": 14.679392595717015,
          "reheatFlow": 263.4,
          "mainHeatCoilFlow": 11.124439462959497,
          "heatingShare": 0.006479263234409484,
          "chwFlow": 13,
          "mainCoolCoilFlow": 291.1337492388601,
          "coolingShare": 0.0028716326194754603,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 11.659486024425743,
          "heatingGas": 4.956150429580674,
          "chwPumpElectricity": 0.13692231492920942,
          "chillerElectricity": 7.149041399856318,
          "totalElectricity": 83.2778423349283,
          "totalGas": 4.956150429580674,
          "eui": 15.23903156554559
        },
        "mri-lab": {
          "fanGroup": "special-lab",
          "area": 2550,
          "roomElectricity": 184.56,
          "airFlow": 1942383,
          "fanShare": 0.4576821827955375,
          "fanElectricity": 99.24334683520156,
          "reheatFlow": 475.9,
          "mainHeatCoilFlow": 88.74457524405473,
          "heatingShare": 0.013326612537829033,
          "chwFlow": 16.3,
          "mainCoolCoilFlow": 1598.7754009413716,
          "coolingShare": 0.015249551277563545,
          "dhwDemand": 9.6,
          "dhwShare": 0.019925280199252802,
          "heatingElectricity": 23.981345874723647,
          "heatingGas": 20.083672295997005,
          "chwPumpElectricity": 0.7271138544655074,
          "chillerElectricity": 37.964352637994274,
          "totalElectricity": 346.476159202385,
          "totalGas": 20.083672295997005,
          "eui": 143.74895352877726
        },
        "nmr-lab": {
          "fanGroup": "special-lab",
          "area": 1800,
          "roomElectricity": 313.741,
          "airFlow": 2301572.9,
          "fanShare": 0.5423178172044624,
          "fanElectricity": 117.59565316479842,
          "reheatFlow": 37.2,
          "mainHeatCoilFlow": 105.15542475594526,
          "heatingShare": 0.003359840281048609,
          "chwFlow": 1095.7,
          "mainCoolCoilFlow": 1894.4245990586278,
          "coolingShare": 0.02823277375970877,
          "dhwDemand": 6.7,
          "dhwShare": 0.013906185139061854,
          "heatingElectricity": 6.046059464469221,
          "heatingGas": 9.472291289828764,
          "chwPumpElectricity": 1.3461668856366737,
          "chillerElectricity": 70.28659135297163,
          "totalElectricity": 509.01547086787593,
          "totalGas": 9.472291289828764,
          "eui": 288.04875675428036
        },
        "core-lab": {
          "fanGroup": "lab",
          "area": 2750,
          "roomElectricity": 443.434,
          "airFlow": 6962861.5,
          "fanShare": 0.06960121995982381,
          "fanElectricity": 117.61339431006955,
          "reheatFlow": 1715.3,
          "mainHeatCoilFlow": 87.86458007728159,
          "heatingShare": 0.04255787933540435,
          "chwFlow": 4230.6,
          "mainCoolCoilFlow": 2281.8551160168354,
          "coolingShare": 0.06149063887459635,
          "dhwDemand": 10.3,
          "dhwShare": 0.021378165213781657,
          "heatingElectricity": 76.58324432709482,
          "heatingGas": 43.16453126366863,
          "chwPumpElectricity": 2.931935152179628,
          "chillerElectricity": 153.08334361322372,
          "totalElectricity": 793.6459174025678,
          "totalGas": 43.16453126366863,
          "eui": 304.2947086059042
        },
        "instruction-lab": {
          "fanGroup": "lab",
          "area": 7140,
          "roomElectricity": 217.925,
          "airFlow": 17950582,
          "fanShare": 0.17943519430752056,
          "fanElectricity": 303.2128211743458,
          "reheatFlow": 6404.9,
          "mainHeatCoilFlow": 226.51898929381397,
          "heatingShare": 0.15651323916133025,
          "chwFlow": 5728.5,
          "mainCoolCoilFlow": 5882.729014813769,
          "coolingShare": 0.109633291519226,
          "dhwDemand": 35.7,
          "dhwShare": 0.07409713574097138,
          "heatingElectricity": 281.6468259767271,
          "heatingGas": 156.498632304833,
          "chwPumpElectricity": 5.2274249729282145,
          "chillerElectricity": 272.9363549354824,
          "totalElectricity": 1080.9484270594835,
          "totalGas": 156.498632304833,
          "eui": 173.3119130762348
        },
        "open-lab-bio": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 229.787,
          "airFlow": 11431892,
          "fanShare": 0.11427394177651676,
          "fanElectricity": 193.10216374491,
          "reheatFlow": 3308.3,
          "mainHeatCoilFlow": 144.25942409867477,
          "heatingShare": 0.08148652041668161,
          "chwFlow": 4080.1,
          "mainCoolCoilFlow": 3746.4368989605687,
          "coolingShare": 0.07389820667002711,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 146.6356453819819,
          "heatingGas": 85.51032631839767,
          "chwPumpElectricity": 3.5235403922335626,
          "chillerElectricity": 183.97246753509265,
          "totalElectricity": 757.0208170542182,
          "totalGas": 85.51032631839767,
          "eui": 187.22914297169243
        },
        "open-lab-chem": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 229.787,
          "airFlow": 13323951,
          "fanShare": 0.13318708756233547,
          "fanElectricity": 225.06193793041058,
          "reheatFlow": 4081.1,
          "mainHeatCoilFlow": 168.1353793386923,
          "heatingShare": 0.10028948468690344,
          "chwFlow": 4123.4,
          "mainCoolCoilFlow": 4366.498709604899,
          "coolingShare": 0.08016167272313017,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 180.47173000996023,
          "heatingGas": 99.89318376279711,
          "chwPumpElectricity": 3.8221887171115694,
          "chillerElectricity": 199.56561054946877,
          "totalElectricity": 838.7084672069511,
          "totalGas": 99.89318376279711,
          "eui": 208.57814465994406
        },
        "open-lab-general": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 229.787,
          "airFlow": 11498423,
          "fanShare": 0.11493899001353067,
          "fanElectricity": 194.22597422668437,
          "reheatFlow": 3878.8,
          "mainHeatCoilFlow": 145.0989809930811,
          "heatingShare": 0.09497114638510731,
          "chwFlow": 4257.4,
          "mainCoolCoilFlow": 3768.2403058965983,
          "coolingShare": 0.07577814218996559,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 170.9013376891717,
          "heatingGas": 95.8250538372957,
          "chwPumpElectricity": 3.613177597759749,
          "chillerElectricity": 188.65264032946476,
          "totalElectricity": 787.1801298430806,
          "totalGas": 95.8250538372957,
          "eui": 196.22337415119475
        },
        "support-lab-bio": {
          "fanGroup": "lab",
          "area": 3000,
          "roomElectricity": 483.746,
          "airFlow": 7577892.5,
          "fanShare": 0.07574911015024487,
          "fanElectricity": 128.00220981586648,
          "reheatFlow": 2262.5,
          "mainHeatCoilFlow": 95.62567665366913,
          "heatingShare": 0.05565594461734846,
          "chwFlow": 5114.1,
          "mainCoolCoilFlow": 2483.4118515427326,
          "coolingShare": 0.07173575084758746,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 100.1533175864755,
          "heatingGas": 65.75187312509277,
          "chwPumpElectricity": 3.4204323361638176,
          "chillerElectricity": 178.58894942935206,
          "totalElectricity": 893.9109091678579,
          "totalGas": 65.75187312509277,
          "eui": 319.8875940976502
        },
        "support-lab-chem": {
          "fanGroup": "lab",
          "area": 3000,
          "roomElectricity": 483.746,
          "airFlow": 8908205,
          "fanShare": 0.0890470011003669,
          "fanElectricity": 150.4732253054198,
          "reheatFlow": 2592,
          "mainHeatCoilFlow": 112.41293418910318,
          "heatingShare": 0.0638289375234921,
          "chwFlow": 5165.5,
          "mainCoolCoilFlow": 2919.3792169751982,
          "coolingShare": 0.07633747633101783,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 114.86068370502423,
          "heatingGas": 72.00359972382469,
          "chwPumpElectricity": 3.6398472089392606,
          "chillerElectricity": 190.0451244876458,
          "totalElectricity": 942.7648807070291,
          "totalGas": 72.00359972382469,
          "eui": 338.25616014361793
        },
        "support-lab-general": {
          "fanGroup": "lab",
          "area": 6500,
          "roomElectricity": 1048.116,
          "airFlow": 17427676,
          "fanShare": 0.1742081916557643,
          "fanElectricity": 294.3801380073603,
          "reheatFlow": 5313.7,
          "mainHeatCoilFlow": 219.92042114623686,
          "heatingShare": 0.13060324763088332,
          "chwFlow": 11758.5,
          "mainCoolCoilFlow": 5711.3633009767345,
          "coolingShare": 0.1649505503365295,
          "dhwDemand": 48.7,
          "dhwShare": 0.10107928601079287,
          "heatingElectricity": 235.02158893775558,
          "heatingGas": 150.0718874090804,
          "chwPumpElectricity": 7.865007190596063,
          "chillerElectricity": 410.65082813425335,
          "totalElectricity": 1996.0335622699654,
          "totalGas": 150.0718874090804,
          "eui": 330.1700691813917
        },
        "write-up": {
          "fanGroup": "lab",
          "area": 9000,
          "roomElectricity": 152.293,
          "airFlow": 4957877,
          "fanShare": 0.04955926347389667,
          "fanElectricity": 83.74613548493312,
          "reheatFlow": 644.8,
          "mainHeatCoilFlow": 62.56361420944716,
          "heatingShare": 0.016695034758552624,
          "chwFlow": 2188.7,
          "mainCoolCoilFlow": 1624.78558521266,
          "coolingShare": 0.03600695295343732,
          "dhwDemand": 27,
          "dhwShare": 0.05603985056039851,
          "heatingElectricity": 30.042848608293518,
          "heatingGas": 40.58554908908687,
          "chwPumpElectricity": 1.7168475237728447,
          "chillerElectricity": 89.6407136487474,
          "totalElectricity": 357.4395452657469,
          "totalGas": 40.58554908908687,
          "eui": 44.22501048387042
        },
        "vivarium": {
          "fanGroup": "vivarium",
          "area": 4620,
          "roomElectricity": 612.582,
          "airFlow": 6070680,
          "fanShare": 1,
          "fanElectricity": 1558.113,
          "reheatFlow": 4197.2,
          "mainHeatCoilFlow": 184.5,
          "heatingShare": 0.1034158844646056,
          "chwFlow": 0,
          "mainCoolCoilFlow": 9971.9,
          "coolingShare": 0.09415473747919219,
          "dhwDemand": 28.8,
          "dhwShare": 0.059775840597758416,
          "heatingElectricity": 186.0977114211335,
          "heatingGas": 108.77483502558285,
          "chwPumpElectricity": 4.489392037745363,
          "chillerElectricity": 234.40189098921067,
          "totalElectricity": 2595.6839944480894,
          "totalGas": 108.77483502558285,
          "eui": 585.3806990202754
        }
      },
      "repairs": [],
      "dataQuality": []
    },
    {
      "id": "ecm-2-ach",
      "kind": "measure",
      "label": "Air change rate reduction",
      "measureNumber": 2,
      "locationId": "boston-5a",
      "description": "Lab peak air change rate reduced from 6 to 4 ACH; vivarium reduced to 8 ACH.",
      "provenance": {
        "kind": "simulated",
        "tool": "IES:VE",
        "completed": "2019-08-30",
        "workbook": "STEM Lab Zoned EUI Tool_ECM_SHARED.xlsx",
        "sheet": "ECM 2 - ACH"
      },
      "prototype": {
        "totalArea": 115000,
        "totalElectricity": 0,
        "totalGas": 0,
        "blendedEui": 120.48627826086957
      },
      "plant": {
        "chillers": 2369.502,
        "chwPumps": 48.985,
        "hhwPumps": 160.708,
        "labFans": 991.239,
        "hrcHeating": 1388.422,
        "generalFans": 335.432,
        "vivariumFans": 1303.889,
        "specialLabFans": 205.03,
        "auditoriumFans": 59.911,
        "dhwBoilers": 496.345,
        "hhwBoilers": 568.603
      },
      "zones": {
        "auditorium": {
          "fanGroup": "auditorium",
          "area": 1600,
          "roomElectricity": 40.143,
          "airFlow": 1132175.9,
          "fanShare": 1,
          "fanElectricity": 59.911,
          "reheatFlow": 489.4,
          "mainHeatCoilFlow": 54,
          "heatingShare": 0.013957167881561846,
          "chwFlow": 0,
          "mainCoolCoilFlow": 2369.5,
          "coolingShare": 0.024823475181762943,
          "dhwDemand": 77,
          "dhwShare": 0.15981735159817353,
          "heatingElectricity": 21.621467480363904,
          "heatingGas": 87.26063090795515,
          "chwPumpElectricity": 1.2159779317786577,
          "chillerElectricity": 58.819274090137654,
          "totalElectricity": 181.71071950228023,
          "totalGas": 87.26063090795515,
          "eui": 168.1070940063971
        },
        "atrium": {
          "fanGroup": "general",
          "area": 4770,
          "roomElectricity": 46.411,
          "airFlow": 6000258,
          "fanShare": 0.3020058653963074,
          "fanElectricity": 101.30243144161419,
          "reheatFlow": 306.9,
          "mainHeatCoilFlow": 76.31688218564688,
          "heatingShare": 0.009842882516955797,
          "chwFlow": 356.1,
          "mainCoolCoilFlow": 2006.1343620680511,
          "coolingShare": 0.024747358539904573,
          "dhwDemand": 74.6,
          "dhwShare": 0.15483603154836031,
          "heatingElectricity": 15.247904593491734,
          "heatingGas": 82.44878260665952,
          "chwPumpElectricity": 1.2122493580772256,
          "chillerElectricity": 58.638915555020965,
          "totalElectricity": 222.8125009482041,
          "totalGas": 82.44878260665952,
          "eui": 63.99607621695254
        },
        "boh": {
          "fanGroup": "general",
          "area": 23040,
          "roomElectricity": 248.587,
          "airFlow": 765991.9,
          "fanShare": 0.03855401661829571,
          "fanElectricity": 12.932250902308168,
          "reheatFlow": 176.7,
          "mainHeatCoilFlow": 9.742599999443325,
          "heatingShare": 0.0047887572110178744,
          "chwFlow": 67.2,
          "mainCoolCoilFlow": 256.1027661903529,
          "coolingShare": 0.0033870007143792075,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 7.41840745830412,
          "heatingGas": 2.7229017164563962,
          "chwPumpElectricity": 0.16591222999386548,
          "chillerElectricity": 8.025504966722961,
          "totalElectricity": 277.1290755573291,
          "totalGas": 2.7229017164563962,
          "eui": 12.14635318028583
        },
        "cafe-kitchen": {
          "fanGroup": "general",
          "area": 300,
          "roomElectricity": 18.226,
          "airFlow": 946397.4,
          "fanShare": 0.04763421269482334,
          "fanElectricity": 15.978039232649984,
          "reheatFlow": 903.9,
          "mainHeatCoilFlow": 12.037165547981857,
          "heatingShare": 0.023525743077870975,
          "chwFlow": 0,
          "mainCoolCoilFlow": 316.419784667903,
          "coolingShare": 0.0033148928768611374,
          "dhwDemand": 9.7,
          "dhwShare": 0.02013283520132835,
          "heatingElectricity": 36.44443437422227,
          "heatingGas": 23.36964017930999,
          "chwPumpElectricity": 0.16238002757304282,
          "chillerElectricity": 7.854645301508219,
          "totalElectricity": 78.66549893595351,
          "totalGas": 23.36964017930999,
          "eui": 340.11713038421163
        },
        "computational": {
          "fanGroup": "general",
          "area": 6720,
          "roomElectricity": 101.855,
          "airFlow": 1943213.3,
          "fanShare": 0.09780609672385994,
          "fanElectricity": 32.80729463627779,
          "reheatFlow": 765,
          "mainHeatCoilFlow": 24.715600642119405,
          "heatingShare": 0.020283756379923648,
          "chwFlow": 988,
          "mainCoolCoilFlow": 649.6965587075844,
          "coolingShare": 0.0171569191307602,
          "dhwDemand": 5.1,
          "dhwShare": 0.010585305105853052,
          "heatingElectricity": 31.42217552083112,
          "heatingGas": 16.787367991658357,
          "chwPumpElectricity": 0.8404316836202884,
          "chillerElectricity": 40.653354194174554,
          "totalElectricity": 207.57825603490375,
          "totalGas": 16.787367991658357,
          "eui": 33.38774167061936
        },
        "office": {
          "fanGroup": "general",
          "area": 10420,
          "roomElectricity": 157.935,
          "airFlow": 4107419.8,
          "fanShare": 0.20673525559149755,
          "fanElectricity": 69.3456202535672,
          "reheatFlow": 1885.9,
          "mainHeatCoilFlow": 52.24199908797143,
          "heatingShare": 0.049780959255753966,
          "chwFlow": 1359.1,
          "mainCoolCoilFlow": 1373.2802823176407,
          "coolingShare": 0.028625099862945928,
          "dhwDemand": 7.9,
          "dhwShare": 0.016396845163968454,
          "heatingElectricity": 77.11717741186615,
          "heatingGas": 36.44409488860939,
          "chwPumpElectricity": 1.4022005167864062,
          "chillerElectricity": 67.8272313754501,
          "totalElectricity": 373.62722955766986,
          "totalGas": 36.44409488860939,
          "eui": 39.35425378563141
        },
        "restroom": {
          "fanGroup": "general",
          "area": 1000,
          "roomElectricity": 6.042,
          "airFlow": 400819,
          "fanShare": 0.0201740806749114,
          "fanElectricity": 6.767032228946881,
          "reheatFlow": 368.7,
          "mainHeatCoilFlow": 5.097990186550111,
          "heatingShare": 0.00960095933534061,
          "chwFlow": 0,
          "mainCoolCoilFlow": 134.01036569923397,
          "coolingShare": 0.0014039261392841994,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 14.873134135156201,
          "heatingGas": 5.459134280952677,
          "chwPumpElectricity": 0.06877132193283651,
          "chillerElectricity": 3.326605794886189,
          "totalElectricity": 31.07754348092211,
          "totalGas": 5.459134280952677,
          "eui": 36.536677761874785
        },
        "classroom": {
          "fanGroup": "general",
          "area": 7500,
          "roomElectricity": 133.669,
          "airFlow": 4867908,
          "fanShare": 0.24501225917445685,
          "fanElectricity": 82.18495211940642,
          "reheatFlow": 402.5,
          "mainHeatCoilFlow": 61.91459789338524,
          "heatingShare": 0.011928436712267237,
          "chwFlow": 207.2,
          "mainCoolCoilFlow": 1627.5429340181645,
          "coolingShare": 0.019221226287197652,
          "dhwDemand": 28.2,
          "dhwShare": 0.05853051058530511,
          "heatingElectricity": 18.478699164074545,
          "heatingGas": 35.833871176368554,
          "chwPumpElectricity": 0.941551769678377,
          "chillerElectricity": 45.54473412996741,
          "totalElectricity": 280.81893718312676,
          "totalGas": 35.833871176368554,
          "eui": 42.22037444793271
        },
        "corridor": {
          "fanGroup": "general",
          "area": 5790,
          "roomElectricity": 49.653,
          "airFlow": 836010.7,
          "fanShare": 0.04207821312584771,
          "fanElectricity": 14.11437918522935,
          "reheatFlow": 173.6,
          "mainHeatCoilFlow": 10.633164456901715,
          "heatingShare": 0.004732008107612017,
          "chwFlow": 13.5,
          "mainCoolCoilFlow": 279.5129463310686,
          "coolingShare": 0.003069676978765359,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 7.330495719745004,
          "heatingGas": 2.690634006012515,
          "chwPumpElectricity": 0.15036812680482112,
          "chillerElectricity": 7.273605740538476,
          "totalElectricity": 78.52184877231765,
          "totalGas": 2.690634006012515,
          "eui": 14.02633554029882
        },
        "mri-lab": {
          "fanGroup": "special-lab",
          "area": 2550,
          "roomElectricity": 184.56,
          "airFlow": 1942383,
          "fanShare": 0.4576821827955375,
          "fanElectricity": 93.83857793856906,
          "reheatFlow": 475.9,
          "mainHeatCoilFlow": 59.26984267202211,
          "heatingShare": 0.013745777216272457,
          "chwFlow": 16.3,
          "mainCoolCoilFlow": 1163.885790849052,
          "coolingShare": 0.012363921793209838,
          "dhwDemand": 9.6,
          "dhwShare": 0.019925280199252802,
          "heatingElectricity": 21.293995859044152,
          "heatingGas": 17.7057033630023,
          "chwPumpElectricity": 0.6056467090403839,
          "chillerElectricity": 29.296337416854296,
          "totalElectricity": 329.59455792350786,
          "totalGas": 17.7057033630023,
          "eui": 136.19618089667065
        },
        "nmr-lab": {
          "fanGroup": "special-lab",
          "area": 1800,
          "roomElectricity": 313.741,
          "airFlow": 2301572.9,
          "fanShare": 0.5423178172044624,
          "fanElectricity": 111.19142206143093,
          "reheatFlow": 37.2,
          "mainHeatCoilFlow": 70.23015732797788,
          "heatingShare": 0.002759331507856439,
          "chwFlow": 1095.7,
          "mainCoolCoilFlow": 1379.1142091509478,
          "coolingShare": 0.02592677320123775,
          "dhwDemand": 6.7,
          "dhwShare": 0.013906185139061854,
          "heatingElectricity": 4.274563218765646,
          "heatingGas": 8.471229636209351,
          "chwPumpElectricity": 1.270022985262631,
          "chillerElectricity": 61.433540953879245,
          "totalElectricity": 491.91054921933846,
          "totalGas": 8.471229636209351,
          "eui": 277.98987714197096
        },
        "core-lab": {
          "fanGroup": "lab",
          "area": 2750,
          "roomElectricity": 443.434,
          "airFlow": 5164478,
          "fanShare": 0.06680480770552921,
          "fanElectricity": 66.21953078522107,
          "reheatFlow": 2024,
          "mainHeatCoilFlow": 59.3427106848216,
          "heatingShare": 0.05351042320179644,
          "chwFlow": 4762.6,
          "mainCoolCoilFlow": 1471.1153509642293,
          "coolingShare": 0.0653059625679828,
          "dhwDemand": 10.3,
          "dhwShare": 0.021378165213781657,
          "heatingElectricity": 82.89460189459894,
          "heatingGas": 41.03713257684552,
          "chwPumpElectricity": 3.1990125763926374,
          "chillerElectricity": 154.74260891676036,
          "totalElectricity": 750.4897541729731,
          "totalGas": 41.03713257684552,
          "eui": 287.82795881811586
        },
        "instruction-lab": {
          "fanGroup": "lab",
          "area": 7140,
          "roomElectricity": 217.925,
          "airFlow": 13646995,
          "fanShare": 0.17652991778323357,
          "fanElectricity": 174.98333917353466,
          "reheatFlow": 6460.2,
          "mainHeatCoilFlow": 156.81152596684638,
          "heatingShare": 0.16995719680189364,
          "chwFlow": 5712,
          "mainCoolCoilFlow": 3887.3829724963643,
          "coolingShare": 0.10056553913399507,
          "dhwDemand": 35.7,
          "dhwShare": 0.07409713574097138,
          "heatingElectricity": 263.28579228171753,
          "heatingGas": 133.41591481249958,
          "chwPumpElectricity": 4.926202934478749,
          "chillerElectricity": 238.2902461090796,
          "totalElectricity": 899.4105804988105,
          "totalGas": 133.41591481249958,
          "eui": 144.65357077189216
        },
        "open-lab-bio": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 8449569,
          "fanShare": 0.10929891312144242,
          "fanElectricity": 108.34134534358547,
          "reheatFlow": 3249.2,
          "mainHeatCoilFlow": 97.0902245257773,
          "heatingShare": 0.08594908804588802,
          "chwFlow": 5250.7,
          "mainCoolCoilFlow": 2406.8822957385955,
          "coolingShare": 0.08022274913297081,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 133.14631076452653,
          "heatingGas": 72.05015899882356,
          "chwPumpElectricity": 3.929711366278575,
          "chillerElectricity": 190.0879645160726,
          "totalElectricity": 830.5693319904632,
          "totalGas": 72.05015899882356,
          "eui": 200.5821091087304
        },
        "open-lab-chem": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 10563247,
          "fanShare": 0.13664027314687144,
          "fanElectricity": 135.4431677138317,
          "reheatFlow": 3471.1,
          "mainHeatCoilFlow": 121.37755463636589,
          "heatingShare": 0.09227238193007457,
          "chwFlow": 5088.2,
          "mainCoolCoilFlow": 3008.9691189945706,
          "coolingShare": 0.08482797073977592,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 142.94191501933642,
          "heatingGas": 75.64560287125369,
          "chwPumpElectricity": 4.155298146687923,
          "chillerElectricity": 201.00004632384054,
          "totalElectricity": 878.6044272036966,
          "totalGas": 75.64560287125369,
          "eui": 212.05556223887783
        },
        "open-lab-general": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 8463417,
          "fanShare": 0.10947804312782568,
          "fanElectricity": 108.5189059919828,
          "reheatFlow": 3074.9,
          "mainHeatCoilFlow": 97.24934571044754,
          "heatingShare": 0.08147629915985882,
          "chwFlow": 5307.6,
          "mainCoolCoilFlow": 2410.826935522162,
          "coolingShare": 0.08086017281121967,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 126.21737931751211,
          "heatingGas": 69.5069178198607,
          "chwPumpElectricity": 3.9609355651575955,
          "chillerElectricity": 191.5983411965306,
          "totalElectricity": 825.3595620711832,
          "totalGas": 69.5069178198607,
          "eui": 198.85921775356533
        },
        "support-lab-bio": {
          "fanGroup": "lab",
          "area": 3000,
          "roomElectricity": 483.746,
          "airFlow": 5645186.5,
          "fanShare": 0.07302298481944342,
          "fanElectricity": 72.38323044944028,
          "reheatFlow": 2273.6,
          "mainHeatCoilFlow": 64.86631741511158,
          "heatingShare": 0.06006324434586015,
          "chwFlow": 5065.4,
          "mainCoolCoilFlow": 1608.0464510074453,
          "coolingShare": 0.06991269565452936,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 93.04577371350234,
          "heatingGas": 57.33139061345662,
          "chwPumpElectricity": 3.424673396637121,
          "chillerElectricity": 165.65827217879863,
          "totalElectricity": 818.2579497383783,
          "totalGas": 57.33139061345662,
          "eui": 291.86311345061165
        },
        "support-lab-chem": {
          "fanGroup": "lab",
          "area": 3000,
          "roomElectricity": 483.746,
          "airFlow": 7098984,
          "fanShare": 0.09182849864490246,
          "fanElectricity": 91.02398916827447,
          "reheatFlow": 2617.3,
          "mainHeatCoilFlow": 81.57125534626685,
          "heatingShare": 0.06932020464039275,
          "chwFlow": 5138.2,
          "mainCoolCoilFlow": 2022.1645515092614,
          "coolingShare": 0.07501377157069647,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 107.38600861457162,
          "heatingGas": 62.59492600780874,
          "chwPumpElectricity": 3.6745496003905664,
          "chillerElectricity": 177.74528176430843,
          "totalElectricity": 863.575829147545,
          "totalGas": 62.59492600780874,
          "eui": 308.7235850517846
        },
        "support-lab-general": {
          "fanGroup": "lab",
          "area": 6500,
          "roomElectricity": 1048.116,
          "airFlow": 12994522,
          "fanShare": 0.1680898908728566,
          "fanElectricity": 166.61725533891953,
          "reheatFlow": 4952.2,
          "mainHeatCoilFlow": 149.31425006235852,
          "heatingShare": 0.1310318197245131,
          "chwFlow": 11078.4,
          "mainCoolCoilFlow": 3701.5242959002626,
          "coolingShare": 0.1548381869371662,
          "dhwDemand": 48.7,
          "dhwShare": 0.10107928601079287,
          "heatingElectricity": 202.985322889835,
          "heatingGas": 124.6752840058443,
          "chwPumpElectricity": 7.584748587117086,
          "chillerElectricity": 366.8893936239892,
          "totalElectricity": 1792.1927204398608,
          "totalGas": 124.6752840058443,
          "eui": 294.9027699147239
        },
        "write-up": {
          "fanGroup": "lab",
          "area": 9000,
          "roomElectricity": 152.293,
          "airFlow": 5280582.5,
          "fanShare": 0.0683066707778952,
          "fanElectricity": 67.70823603521006,
          "reheatFlow": 712.9,
          "mainHeatCoilFlow": 60.67681565200431,
          "heatingShare": 0.01986923350264822,
          "chwFlow": 2247.7,
          "mainCoolCoilFlow": 1504.188027867108,
          "coolingShare": 0.03930571822937863,
          "dhwDemand": 27,
          "dhwShare": 0.05603985056039851,
          "heatingElectricity": 30.78002569595744,
          "heatingGas": 39.112805403707284,
          "chwPumpElectricity": 1.9253906074661122,
          "chillerElectricity": 93.13497795594913,
          "totalElectricity": 345.8416302945827,
          "totalGas": 39.112805403707284,
          "eui": 42.772715077587776
        },
        "vivarium": {
          "fanGroup": "vivarium",
          "area": 4620,
          "roomElectricity": 612.582,
          "airFlow": 4921652.5,
          "fanShare": 1,
          "fanElectricity": 1303.889,
          "reheatFlow": 2638.3,
          "mainHeatCoilFlow": 149.5,
          "heatingShare": 0.07160432944464136,
          "chwFlow": 0,
          "mainCoolCoilFlow": 8123.8,
          "coolingShare": 0.08510696251597628,
          "dhwDemand": 28.8,
          "dhwShare": 0.059775840597758416,
          "heatingElectricity": 110.92441487257727,
          "heatingGas": 70.38387613670581,
          "chwPumpElectricity": 4.168964558845098,
          "chillerElectricity": 201.66111789553082,
          "totalElectricity": 2233.2254973269532,
          "totalGas": 70.38387613670581,
          "eui": 498.6167475029565
        }
      },
      "repairs": [],
      "dataQuality": []
    },
    {
      "id": "ecm-3-writeup",
      "kind": "measure",
      "label": "Separate write-up space",
      "measureNumber": 3,
      "locationId": "boston-5a",
      "description": "Write-up space moved off the lab air handler onto the general one.",
      "provenance": {
        "kind": "simulated",
        "tool": "IES:VE",
        "completed": "2019-08-30",
        "workbook": "STEM Lab Zoned EUI Tool_ECM_SHARED.xlsx",
        "sheet": "ECM 3 - WriteUp"
      },
      "prototype": {
        "totalArea": 115000,
        "totalElectricity": 0,
        "totalGas": 0,
        "blendedEui": 128.90720869565217
      },
      "plant": {
        "chillers": 2470.077,
        "chwPumps": 46.839,
        "hhwPumps": 170.9,
        "labFans": 1341.791,
        "hrcHeating": 1562.779,
        "generalFans": 301.331,
        "vivariumFans": 1551.899,
        "specialLabFans": 216.839,
        "auditoriumFans": 59.755,
        "dhwBoilers": 496.345,
        "hhwBoilers": 677.918
      },
      "zones": {
        "auditorium": {
          "fanGroup": "auditorium",
          "area": 1600,
          "roomElectricity": 40.143,
          "airFlow": 1129495.1,
          "fanShare": 1,
          "fanElectricity": 59.755,
          "reheatFlow": 468.6,
          "mainHeatCoilFlow": 54.9,
          "heatingShare": 0.014487857835838135,
          "chwFlow": 0,
          "mainCoolCoilFlow": 2370.9,
          "coolingShare": 0.02293699100523987,
          "dhwDemand": 77,
          "dhwShare": 0.15981735159817353,
          "heatingElectricity": 25.117294884978023,
          "heatingGas": 89.14612298735116,
          "chwPumpElectricity": 1.0743457216944303,
          "chillerElectricity": 56.65613393124989,
          "totalElectricity": 182.74577453792233,
          "totalGas": 89.14612298735116,
          "eui": 169.93243595329594
        },
        "atrium": {
          "fanGroup": "general",
          "area": 4770,
          "roomElectricity": 46.411,
          "airFlow": 4787264,
          "fanShare": 0.24523398386132791,
          "fanElectricity": 73.89660159091781,
          "reheatFlow": 241.7,
          "mainHeatCoilFlow": 59.71447507023335,
          "heatingShare": 0.008341642912094209,
          "chwFlow": 563.6,
          "mainCoolCoilFlow": 1572.6364917059236,
          "coolingShare": 0.02066676671109028,
          "dhwDemand": 74.6,
          "dhwShare": 0.15483603154836031,
          "heatingElectricity": 14.461731142196577,
          "heatingGas": 82.50703995855199,
          "chwPumpElectricity": 0.9680106859807576,
          "chillerElectricity": 51.04850511742975,
          "totalElectricity": 186.7858485365249,
          "totalGas": 82.50703995855199,
          "eui": 56.45553217926141
        },
        "boh": {
          "fanGroup": "general",
          "area": 23040,
          "roomElectricity": 248.587,
          "airFlow": 570559.4,
          "fanShare": 0.02922766630198981,
          "fanElectricity": 8.807201914444892,
          "reheatFlow": 178.9,
          "mainHeatCoilFlow": 7.116936744534519,
          "heatingShare": 0.005148017067073373,
          "chwFlow": 72.6,
          "mainCoolCoilFlow": 187.43117846140026,
          "coolingShare": 0.0025156408121182086,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 8.9250090808267,
          "heatingGas": 3.489933434076247,
          "chwPumpElectricity": 0.11783009999880477,
          "chillerElectricity": 6.213826510274509,
          "totalElectricity": 272.6508676055449,
          "totalGas": 3.489933434076247,
          "eui": 11.985277822900223
        },
        "cafe-kitchen": {
          "fanGroup": "general",
          "area": 300,
          "roomElectricity": 18.226,
          "airFlow": 961950.2,
          "fanShare": 0.04927718208609368,
          "fanElectricity": 14.848742555184694,
          "reheatFlow": 896.3,
          "mainHeatCoilFlow": 11.99899383796381,
          "heatingShare": 0.02513716656190876,
          "chwFlow": 0,
          "mainCoolCoilFlow": 316.0047132817015,
          "coolingShare": 0.003057150139675141,
          "dhwDemand": 9.7,
          "dhwShare": 0.02013283520132835,
          "heatingElectricity": 43.57977778788342,
          "heatingGas": 27.033769769319385,
          "chwPumpElectricity": 0.14319385539224394,
          "chillerElectricity": 7.551396245558354,
          "totalElectricity": 84.34911044401872,
          "totalGas": 27.033769769319385,
          "eui": 371.27626737779366
        },
        "computational": {
          "fanGroup": "general",
          "area": 6720,
          "roomElectricity": 101.855,
          "airFlow": 1995524.5,
          "fanShare": 0.10222340423003295,
          "fanElectricity": 30.803080620040063,
          "reheatFlow": 721,
          "mainHeatCoilFlow": 24.891398930013025,
          "heatingShare": 0.02064253781981367,
          "chwFlow": 1123.6,
          "mainCoolCoilFlow": 655.5382466463553,
          "coolingShare": 0.01721206206942751,
          "dhwDemand": 5.1,
          "dhwShare": 0.010585305105853052,
          "heatingElectricity": 35.78753432491675,
          "heatingGas": 19.247911216497076,
          "chwPumpElectricity": 0.806195775269915,
          "chillerElectricity": 42.5151186402653,
          "totalElectricity": 211.76692936049204,
          "totalGas": 19.247911216497076,
          "eui": 34.37720841919481
        },
        "office": {
          "fanGroup": "general",
          "area": 10420,
          "roomElectricity": 157.935,
          "airFlow": 4333919.5,
          "fanShare": 0.22201080715817936,
          "fanElectricity": 66.89873853178135,
          "reheatFlow": 1789.9,
          "mainHeatCoilFlow": 54.05963154301668,
          "heatingShare": 0.05103156637405863,
          "chwFlow": 1610.2,
          "mainCoolCoilFlow": 1423.7109041439726,
          "coolingShare": 0.029351211404550784,
          "dhwDemand": 7.9,
          "dhwShare": 0.016396845163968454,
          "heatingElectricity": 88.4723549598116,
          "heatingGas": 42.733709526079004,
          "chwPumpElectricity": 1.3747813909777542,
          "chillerElectricity": 72.49975221251859,
          "totalElectricity": 387.1806270950893,
          "totalGas": 42.733709526079004,
          "eui": 41.25857357208909
        },
        "restroom": {
          "fanGroup": "general",
          "area": 1000,
          "roomElectricity": 6.042,
          "airFlow": 279305.5,
          "fanShare": 0.01430779678734662,
          "fanElectricity": 4.311382713727944,
          "reheatFlow": 231,
          "mainHeatCoilFlow": 3.483948517718902,
          "heatingShare": 0.006489341186075835,
          "chwFlow": 0,
          "mainCoolCoilFlow": 91.7530392378964,
          "coolingShare": 0.000887653901768548,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 11.250434538134769,
          "heatingGas": 4.399241198182158,
          "chwPumpElectricity": 0.04157682110493702,
          "chillerElectricity": 2.19257348671875,
          "totalElectricity": 23.837967559686398,
          "totalGas": 4.399241198182158,
          "eui": 28.237208757868554
        },
        "classroom": {
          "fanGroup": "general",
          "area": 7500,
          "roomElectricity": 133.669,
          "airFlow": 3989069.5,
          "fanShare": 0.20434540593222256,
          "fanElectricity": 61.57560551496256,
          "reheatFlow": 148.8,
          "mainHeatCoilFlow": 49.75810634449619,
          "heatingShare": 0.005495093824015838,
          "chwFlow": 564.1,
          "mainCoolCoilFlow": 1310.426219162157,
          "coolingShare": 0.018134881702310805,
          "dhwDemand": 28.2,
          "dhwShare": 0.05853051058530511,
          "heatingElectricity": 9.526728765725954,
          "heatingGas": 32.77654929145244,
          "chwPumpElectricity": 0.8494197240545358,
          "chillerElectricity": 44.794554190598774,
          "totalElectricity": 250.41530819534182,
          "totalGas": 32.77654929145244,
          "eui": 37.75891433157257
        },
        "corridor": {
          "fanGroup": "general",
          "area": 5790,
          "roomElectricity": 49.653,
          "airFlow": 683058,
          "fanShare": 0.03499055714252461,
          "fanElectricity": 10.543739574314083,
          "reheatFlow": 224.7,
          "mainHeatCoilFlow": 8.520200664204742,
          "heatingShare": 0.006454366975489284,
          "chwFlow": 15.3,
          "mainCoolCoilFlow": 224.38744484358182,
          "coolingShare": 0.0023188277727639985,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 11.189800483699287,
          "heatingGas": 4.375531551289745,
          "chwPumpElectricity": 0.10861157404849292,
          "chillerElectricity": 5.727683148465579,
          "totalElectricity": 77.22283478052745,
          "totalGas": 4.375531551289745,
          "eui": 14.092982095305214
        },
        "mri-lab": {
          "fanGroup": "special-lab",
          "area": 2550,
          "roomElectricity": 184.56,
          "airFlow": 1942383,
          "fanShare": 0.4576821827955375,
          "fanElectricity": 99.24334683520156,
          "reheatFlow": 475.9,
          "mainHeatCoilFlow": 88.74457524405473,
          "heatingShare": 0.015626533589136724,
          "chwFlow": 16.3,
          "mainCoolCoilFlow": 1598.7754009413716,
          "coolingShare": 0.015624855516544946,
          "dhwDemand": 9.6,
          "dhwShare": 0.019925280199252802,
          "heatingElectricity": 27.091393126280966,
          "heatingGas": 20.48332159817852,
          "chwPumpElectricity": 0.7318526075394487,
          "chillerElectricity": 38.594596239740795,
          "totalElectricity": 350.2211888087628,
          "totalGas": 20.48332159817852,
          "eui": 145.37431780664366
        },
        "nmr-lab": {
          "fanGroup": "special-lab",
          "area": 1800,
          "roomElectricity": 313.741,
          "airFlow": 2301572.9,
          "fanShare": 0.5423178172044624,
          "fanElectricity": 117.59565316479842,
          "reheatFlow": 37.2,
          "mainHeatCoilFlow": 105.15542475594526,
          "heatingShare": 0.0039396851117946274,
          "chwFlow": 1095.7,
          "mainCoolCoilFlow": 1894.4245990586278,
          "coolingShare": 0.028927605986399346,
          "dhwDemand": 6.7,
          "dhwShare": 0.013906185139061854,
          "heatingElectricity": 6.830149344930998,
          "heatingGas": 9.573048914465247,
          "chwPumpElectricity": 1.354940136796959,
          "chillerElectricity": 71.45341421206734,
          "totalElectricity": 510.9751568585937,
          "totalGas": 9.573048914465247,
          "eui": 289.1934476516994
        },
        "core-lab": {
          "fanGroup": "lab",
          "area": 2750,
          "roomElectricity": 443.434,
          "airFlow": 5380040,
          "fanShare": 0.07471007291482265,
          "fanElectricity": 100.2453034464528,
          "reheatFlow": 1774.6,
          "mainHeatCoilFlow": 107.5451499608872,
          "heatingShare": 0.0520883502560565,
          "chwFlow": 4170,
          "mainCoolCoilFlow": 2112.9652241915974,
          "coolingShare": 0.06078380228331754,
          "dhwDemand": 10.3,
          "dhwShare": 0.021378165213781657,
          "heatingElectricity": 90.30447898356978,
          "heatingGas": 45.92257564191977,
          "chwPumpElectricity": 2.8470525151483104,
          "chillerElectricity": 150.14067199257016,
          "totalElectricity": 786.9715069377411,
          "totalGas": 45.92257564191977,
          "eui": 302.87057548351305
        },
        "instruction-lab": {
          "fanGroup": "lab",
          "area": 7140,
          "roomElectricity": 217.925,
          "airFlow": 13895212,
          "fanShare": 0.19295624227457764,
          "fanElectricity": 258.9069492778478,
          "reheatFlow": 5419.1,
          "mainHeatCoilFlow": 277.7605107542545,
          "heatingShare": 0.15766056387852506,
          "chwFlow": 5625.8,
          "mainCoolCoilFlow": 5457.22703525806,
          "coolingShare": 0.1072214312786471,
          "dhwDemand": 35.7,
          "dhwShare": 0.07409713574097138,
          "heatingElectricity": 273.33280872435745,
          "heatingGas": 143.6586769827544,
          "chwPumpElectricity": 5.022144619660551,
          "chillerElectricity": 264.84519130846684,
          "totalElectricity": 1020.0320939303326,
          "totalGas": 143.6586769827544,
          "eui": 162.9819006881074
        },
        "open-lab-bio": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 7816509,
          "fanShare": 0.10854416646147008,
          "fanElectricity": 145.6435856605024,
          "reheatFlow": 2830.54,
          "mainHeatCoilFlow": 156.24932762128617,
          "heatingShare": 0.08265936803089927,
          "chwFlow": 5109.1,
          "mainCoolCoilFlow": 3069.867824696589,
          "coolingShare": 0.079126454691135,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 143.30481050844142,
          "heatingGas": 79.21552314543867,
          "chwPumpElectricity": 3.706204011278072,
          "chillerElectricity": 195.44843582411468,
          "totalElectricity": 883.1670360043365,
          "totalGas": 79.21552314543867,
          "eui": 213.86279092217225
        },
        "open-lab-chem": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 9825938,
          "fanShare": 0.13644815734390947,
          "fanElectricity": 183.08490949064162,
          "reheatFlow": 3032.3,
          "mainHeatCoilFlow": 196.41712249655768,
          "heatingShare": 0.08935471759859887,
          "chwFlow": 4357.1,
          "mainCoolCoilFlow": 3859.0540756319165,
          "coolingShare": 0.07948620866777771,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 154.9123974516213,
          "heatingGas": 83.75442113367444,
          "chwPumpElectricity": 3.72305452779004,
          "chillerElectricity": 196.33705584747838,
          "totalElectricity": 933.1214173175313,
          "totalGas": 83.75442113367444,
          "eui": 225.97240854471238
        },
        "open-lab-general": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 8830076,
          "fanShare": 0.12261909238656693,
          "fanElectricity": 164.52919459246402,
          "reheatFlow": 2262.8,
          "mainHeatCoilFlow": 176.5101834904631,
          "heatingShare": 0.06750788759488456,
          "chwFlow": 3476.4,
          "mainCoolCoilFlow": 3467.9376946953635,
          "coolingShare": 0.06718217185059501,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 117.03700705761187,
          "heatingGas": 68.94406183121646,
          "chwPumpElectricity": 3.1467457473100198,
          "chillerElectricity": 165.94513749820217,
          "totalElectricity": 845.7220848955881,
          "totalGas": 68.94406183121646,
          "eui": 203.25914371706767
        },
        "support-lab-bio": {
          "fanGroup": "lab",
          "area": 3000,
          "roomElectricity": 483.746,
          "airFlow": 5847294,
          "fanShare": 0.08119860839220619,
          "fanElectricity": 108.95156195318673,
          "reheatFlow": 2125.2,
          "mainHeatCoilFlow": 116.8853967805808,
          "heatingShare": 0.06204969337987734,
          "chwFlow": 4962.8,
          "mainCoolCoilFlow": 2296.475282270054,
          "coolingShare": 0.07022899820911398,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 107.57425036913237,
          "heatingGas": 65.24385372536719,
          "chwPumpElectricity": 3.2894560471166896,
          "chillerElectricity": 173.47103320937364,
          "totalElectricity": 877.0323015788094,
          "totalGas": 65.24385372536719,
          "eui": 314.09205176805887
        },
        "support-lab-chem": {
          "fanGroup": "lab",
          "area": 3000,
          "roomElectricity": 483.746,
          "airFlow": 6882794,
          "fanShare": 0.09557810752293736,
          "fanElectricity": 128.24584447130962,
          "reheatFlow": 2371.3,
          "mainHeatCoilFlow": 137.5846857792683,
          "heatingShare": 0.06943336132584808,
          "chwFlow": 4851.6,
          "mainCoolCoilFlow": 2703.159152585219,
          "coolingShare": 0.07308762188603515,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 120.37516043003498,
          "heatingGas": 70.24937513196379,
          "chwPumpElectricity": 3.4233511215200005,
          "chillerElectricity": 180.53205380539208,
          "totalElectricity": 916.3224098282567,
          "totalGas": 70.24937513196379,
          "eui": 328.8572616534068
        },
        "support-lab-general": {
          "fanGroup": "lab",
          "area": 6500,
          "roomElectricity": 1048.116,
          "airFlow": 13534381,
          "fanShare": 0.1879455527035097,
          "fanElectricity": 252.18365110759498,
          "reheatFlow": 4610.2,
          "mainHeatCoilFlow": 270.54762311670225,
          "heatingShare": 0.13507464698437377,
          "chwFlow": 10614.4,
          "mainCoolCoilFlow": 5315.513710671203,
          "coolingShare": 0.15411206187351328,
          "dhwDemand": 48.7,
          "dhwShare": 0.10107928601079287,
          "heatingElectricity": 234.17607890922216,
          "heatingGas": 141.7397327493797,
          "chwPumpElectricity": 7.218454866093489,
          "chillerElectricity": 380.6686594563421,
          "totalElectricity": 1922.3628443392527,
          "totalGas": 141.7397327493797,
          "eui": 317.55424262902034
        },
        "write-up": {
          "fanGroup": "general",
          "area": 9000,
          "roomElectricity": 152.293,
          "airFlow": 1920559,
          "fanShare": 0.09838319650028243,
          "fanElectricity": 29.645906984626606,
          "reheatFlow": 40,
          "mainHeatCoilFlow": 141.62261136215656,
          "heatingShare": 0.0050264041512676294,
          "chwFlow": 2553.2,
          "mainCoolCoilFlow": 2782.493240060288,
          "coolingShare": 0.05161953176177063,
          "dhwDemand": 27,
          "dhwShare": 0.05603985056039851,
          "heatingElectricity": 8.714171322565512,
          "heatingGas": 31.22258947582005,
          "chwPumpElectricity": 2.4178072481895745,
          "chillerElectricity": 127.50421815551913,
          "totalElectricity": 320.5751037109008,
          "totalGas": 31.22258947582005,
          "eui": 39.08863257630232
        },
        "vivarium": {
          "fanGroup": "vivarium",
          "area": 4620,
          "roomElectricity": 612.582,
          "airFlow": 6070680,
          "fanShare": 1,
          "fanElectricity": 1551.899,
          "reheatFlow": 4019.7,
          "mainHeatCoilFlow": 184.5,
          "heatingShare": 0.11635119754236997,
          "chwFlow": 0,
          "mainCoolCoilFlow": 9873.3,
          "coolingShare": 0.09551807047620514,
          "dhwDemand": 28.8,
          "dhwShare": 0.059775840597758416,
          "heatingElectricity": 201.71562780405844,
          "heatingGas": 108.54601073702277,
          "chwPumpElectricity": 4.473970903034973,
          "chillerElectricity": 235.93698896765338,
          "totalElectricity": 2606.607587674747,
          "totalGas": 108.54601073702277,
          "eui": 587.6955840718116
        }
      },
      "repairs": [],
      "dataQuality": []
    },
    {
      "id": "ecm-4-glazing",
      "kind": "measure",
      "label": "Glazing reduced",
      "measureNumber": 4,
      "locationId": "boston-5a",
      "description": "Office window-to-wall ratio reduced from 60% to under 40%.",
      "note": "The workbook Read Me states this measure the other way round. The 2019 presentation sets the baseline at 60% (slide 21) and names the measure \"Glazing Reduced to <40%\" (slide 29); the presentation governs.",
      "provenance": {
        "kind": "simulated",
        "tool": "IES:VE",
        "completed": "2019-08-30",
        "workbook": "STEM Lab Zoned EUI Tool_ECM_SHARED.xlsx",
        "sheet": "ECM 4 - Windows"
      },
      "prototype": {
        "totalArea": 115000,
        "totalElectricity": 0,
        "totalGas": 0,
        "blendedEui": 132.6575739130435
      },
      "plant": {
        "chillers": 2608.146,
        "chwPumps": 51.054,
        "hhwPumps": 156.054,
        "labFans": 1685.371,
        "hrcHeating": 1645.316,
        "generalFans": 322.049,
        "vivariumFans": 1566.452,
        "specialLabFans": 216.839,
        "auditoriumFans": 60.304,
        "dhwBoilers": 496.345,
        "hhwBoilers": 519.835
      },
      "zones": {
        "auditorium": {
          "fanGroup": "auditorium",
          "area": 1600,
          "roomElectricity": 40.143,
          "airFlow": 1140017.4,
          "fanShare": 1,
          "fanElectricity": 60.304,
          "reheatFlow": 488.8,
          "mainHeatCoilFlow": 54.6,
          "heatingShare": 0.013306006312639725,
          "chwFlow": 0,
          "mainCoolCoilFlow": 2373.3,
          "coolingShare": 0.021817790697033046,
          "dhwDemand": 77,
          "dhwShare": 0.15981735159817353,
          "heatingElectricity": 23.969040591399825,
          "heatingGas": 86.24147117052651,
          "chwPumpElectricity": 1.1138854862463252,
          "chillerElectricity": 56.90398353530396,
          "totalElectricity": 182.43390961295012,
          "totalGas": 86.24147117052651,
          "eui": 167.92211298967288
        },
        "atrium": {
          "fanGroup": "general",
          "area": 4770,
          "roomElectricity": 46.411,
          "airFlow": 5897421,
          "fanShare": 0.3170858824005913,
          "fanElectricity": 102.11719134122802,
          "reheatFlow": 244.3,
          "mainHeatCoilFlow": 78.92267612950718,
          "heatingShare": 0.007914617167772411,
          "chwFlow": 423.7,
          "mainCoolCoilFlow": 2097.206026197511,
          "coolingShare": 0.023174735619798,
          "dhwDemand": 74.6,
          "dhwShare": 0.15483603154836031,
          "heatingElectricity": 14.257153927510188,
          "heatingGas": 80.96638509427987,
          "chwPumpElectricity": 1.183162952333167,
          "chillerElectricity": 60.44309400783368,
          "totalElectricity": 224.41160222890505,
          "totalGas": 80.96638509427987,
          "eui": 64.02054241576204
        },
        "boh": {
          "fanGroup": "general",
          "area": 23040,
          "roomElectricity": 248.587,
          "airFlow": 406624.6,
          "fanShare": 0.021862932983212062,
          "fanElectricity": 7.040935704310461,
          "reheatFlow": 1,
          "mainHeatCoilFlow": 5.441684019521483,
          "heatingShare": 0.0001577347961497668,
          "chwFlow": 29.4,
          "mainCoolCoilFlow": 144.60143875096458,
          "coolingShare": 0.0015995984374715206,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 0.28413872974030546,
          "heatingGas": 0.08199606775651404,
          "chwPumpElectricity": 0.08166589862667102,
          "chillerElectricity": 4.171986266297597,
          "totalElectricity": 260.165726598975,
          "totalGas": 0.08199606775651404,
          "eui": 11.295474074076889
        },
        "cafe-kitchen": {
          "fanGroup": "general",
          "area": 300,
          "roomElectricity": 18.226,
          "airFlow": 944047.5,
          "fanShare": 0.050758481472761095,
          "fanElectricity": 16.346718199821236,
          "reheatFlow": 861.8,
          "mainHeatCoilFlow": 12.633786038570237,
          "heatingShare": 0.021411890829986513,
          "chwFlow": 0,
          "mainCoolCoilFlow": 335.71659646084186,
          "coolingShare": 0.003086248866600494,
          "dhwDemand": 9.7,
          "dhwShare": 0.02013283520132835,
          "heatingElectricity": 38.570737784412806,
          "heatingGas": 21.12348235760936,
          "chwPumpElectricity": 0.15756534963542163,
          "chillerElectricity": 8.049387636428612,
          "totalElectricity": 81.35040897029808,
          "totalGas": 21.12348235760936,
          "eui": 341.5796377596914
        },
        "computational": {
          "fanGroup": "general",
          "area": 6720,
          "roomElectricity": 101.855,
          "airFlow": 1945546.1,
          "fanShare": 0.10460592890850579,
          "fanElectricity": 33.68823479905538,
          "reheatFlow": 768.8,
          "mainHeatCoilFlow": 26.03641570532709,
          "heatingShare": 0.01946282363800334,
          "chwFlow": 987.1,
          "mainCoolCoilFlow": 691.8636138008573,
          "coolingShare": 0.015434743485375352,
          "dhwDemand": 5.1,
          "dhwShare": 0.010585305105853052,
          "heatingElectricity": 35.05974661679008,
          "heatingGas": 15.3714201886261,
          "chwPumpElectricity": 0.7880053939023532,
          "chillerElectricity": 40.25606448240779,
          "totalElectricity": 211.6470512921556,
          "totalGas": 15.3714201886261,
          "eui": 33.78251063702109
        },
        "office": {
          "fanGroup": "general",
          "area": 10420,
          "roomElectricity": 157.935,
          "airFlow": 3335620,
          "fanShare": 0.1793458549174394,
          "fanElectricity": 57.75815323030644,
          "reheatFlow": 1357.9,
          "mainHeatCoilFlow": 44.63918328895067,
          "heatingShare": 0.03434338466427556,
          "chwFlow": 1563.2,
          "mainCoolCoilFlow": 1186.1934844239443,
          "coolingShare": 0.02527522503979606,
          "dhwDemand": 7.9,
          "dhwShare": 0.016396845163968454,
          "heatingElectricity": 61.865142832686075,
          "heatingGas": 25.99138547986361,
          "chwPumpElectricity": 1.2904013391817482,
          "chillerElectricity": 65.92147708664395,
          "totalElectricity": 344.7701744888182,
          "totalGas": 25.99138547986361,
          "eui": 35.58172360543971
        },
        "restroom": {
          "fanGroup": "general",
          "area": 1000,
          "roomElectricity": 6.042,
          "airFlow": 395119.7,
          "fanShare": 0.021244350492928506,
          "fanElectricity": 6.841721831897132,
          "reheatFlow": 370,
          "mainHeatCoilFlow": 5.287718837689905,
          "heatingShare": 0.009189511880586058,
          "chwFlow": 0,
          "mainCoolCoilFlow": 140.51013416022914,
          "coolingShare": 0.0012917122563181698,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 16.55371101633131,
          "heatingGas": 4.777029908444454,
          "chwPumpElectricity": 0.06594707753406784,
          "chillerElectricity": 3.3689741544672094,
          "totalElectricity": 32.87235408022972,
          "totalGas": 4.777029908444454,
          "eui": 37.649383988674174
        },
        "classroom": {
          "fanGroup": "general",
          "area": 7500,
          "roomElectricity": 133.669,
          "airFlow": 4842035,
          "fanShare": 0.26034107800503764,
          "fanElectricity": 83.84258383044435,
          "reheatFlow": 385.4,
          "mainHeatCoilFlow": 64.79889431545386,
          "heatingShare": 0.011023830198205471,
          "chwFlow": 226.3,
          "mainCoolCoilFlow": 1721.895889925319,
          "coolingShare": 0.017909800768217517,
          "dhwDemand": 28.2,
          "dhwShare": 0.05853051058530511,
          "heatingElectricity": 19.857997004141392,
          "heatingGas": 34.78189904754741,
          "chwPumpElectricity": 0.9143669684205772,
          "chillerElectricity": 46.71137523442345,
          "totalElectricity": 284.9953230374298,
          "totalGas": 34.78189904754741,
          "eui": 42.63696294466363
        },
        "corridor": {
          "fanGroup": "general",
          "area": 5790,
          "roomElectricity": 49.653,
          "airFlow": 832399,
          "fanShare": 0.0447554908195243,
          "fanElectricity": 14.41346106293698,
          "reheatFlow": 197.6,
          "mainHeatCoilFlow": 11.139641664979598,
          "heatingShare": 0.005111319451034915,
          "chwFlow": 36.9,
          "mainCoolCoilFlow": 296.0128162803337,
          "coolingShare": 0.0030604736636599397,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 9.207377519510764,
          "heatingGas": 2.657042746828735,
          "chwPumpElectricity": 0.15624942242449458,
          "chillerElectricity": 7.982162143980018,
          "totalElectricity": 81.41225014885225,
          "totalGas": 2.657042746828735,
          "eui": 14.519739705644385
        },
        "mri-lab": {
          "fanGroup": "special-lab",
          "area": 2550,
          "roomElectricity": 184.56,
          "airFlow": 1942383,
          "fanShare": 0.4576821827955375,
          "fanElectricity": 99.24334683520156,
          "reheatFlow": 475.9,
          "mainHeatCoilFlow": 88.74457524405473,
          "heatingShare": 0.013826213254683785,
          "chwFlow": 16.3,
          "mainCoolCoilFlow": 1598.7754009413716,
          "coolingShare": 0.014847417965560852,
          "dhwDemand": 9.6,
          "dhwShare": 0.019925280199252802,
          "heatingElectricity": 24.906125770589732,
          "heatingGas": 17.077162767746678,
          "chwPumpElectricity": 0.7580200768137437,
          "chillerElectricity": 38.724233777205676,
          "totalElectricity": 348.1917264598107,
          "totalGas": 17.077162767746678,
          "eui": 143.24270165786564
        },
        "nmr-lab": {
          "fanGroup": "special-lab",
          "area": 1800,
          "roomElectricity": 313.741,
          "airFlow": 2301572.9,
          "fanShare": 0.5423178172044624,
          "fanElectricity": 117.59565316479842,
          "reheatFlow": 37.2,
          "mainHeatCoilFlow": 105.15542475594526,
          "heatingShare": 0.0034857971668036747,
          "chwFlow": 1095.7,
          "mainCoolCoilFlow": 1894.4245990586278,
          "coolingShare": 0.0274882706191004,
          "dhwDemand": 6.7,
          "dhwShare": 0.013906185139061854,
          "heatingElectricity": 6.279210442365136,
          "heatingGas": 8.714304833053044,
          "chwPumpElectricity": 1.403386168187552,
          "chillerElectricity": 71.69342306212424,
          "totalElectricity": 510.71267283747534,
          "totalGas": 8.714304833053044,
          "eui": 288.57054315029353
        },
        "core-lab": {
          "fanGroup": "lab",
          "area": 2750,
          "roomElectricity": 443.434,
          "airFlow": 6941079.5,
          "fanShare": 0.06889245368983399,
          "fanElectricity": 116.10934356768921,
          "reheatFlow": 2084.8,
          "mainHeatCoilFlow": 84.68949332091292,
          "heatingShare": 0.053123373009447236,
          "chwFlow": 4754.8,
          "mainCoolCoilFlow": 2225.3847068251243,
          "coolingShare": 0.06416896682262736,
          "dhwDemand": 10.3,
          "dhwShare": 0.021378165213781657,
          "heatingElectricity": 95.69485043802797,
          "heatingGas": 38.22633402140046,
          "chwPumpElectricity": 3.2760824321624176,
          "chillerElectricity": 167.3620341425683,
          "totalElectricity": 825.8763105804479,
          "totalGas": 38.22633402140046,
          "eui": 314.21914349158124
        },
        "instruction-lab": {
          "fanGroup": "lab",
          "area": 7140,
          "roomElectricity": 217.925,
          "airFlow": 18034416,
          "fanShare": 0.17899739789800723,
          "fanElectricity": 301.6770234927624,
          "reheatFlow": 6299.7,
          "mainHeatCoilFlow": 220.04150123602028,
          "heatingShare": 0.15964615673946572,
          "chwFlow": 5552,
          "mainCoolCoilFlow": 5782.027646120799,
          "coolingShare": 0.10419392530967415,
          "dhwDemand": 35.7,
          "dhwShare": 0.07409713574097138,
          "heatingElectricity": 287.58179736577137,
          "heatingGas": 119.76740272801261,
          "chwPumpElectricity": 5.319516662760105,
          "chillerElectricity": 271.7529695207254,
          "totalElectricity": 1084.2563070420192,
          "totalGas": 119.76740272801261,
          "eui": 168.63077167647506
        },
        "open-lab-bio": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 11543762,
          "fanShare": 0.11457556263279585,
          "fanElectricity": 193.10233056999778,
          "reheatFlow": 3273.8,
          "mainHeatCoilFlow": 140.84773914449593,
          "heatingShare": 0.08361303712274132,
          "chwFlow": 5166,
          "mainCoolCoilFlow": 3701.0541968333614,
          "coolingShare": 0.08151499286468576,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 150.61801668179254,
          "heatingGas": 66.64423284136774,
          "chwPumpElectricity": 4.161666445713667,
          "chillerElectricity": 212.60300258005873,
          "totalElectricity": 955.5490162775627,
          "totalGas": 66.64423284136774,
          "eui": 227.1540553597623
        },
        "open-lab-chem": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 13260947,
          "fanShare": 0.13161917783549992,
          "fanElectricity": 221.82714536779434,
          "reheatFlow": 3438.2,
          "mainHeatCoilFlow": 161.79945531318006,
          "heatingShare": 0.08815166631928,
          "chwFlow": 4555,
          "mainCoolCoilFlow": 4251.602168195669,
          "coolingShare": 0.08095925624983379,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 158.7937671575614,
          "heatingGas": 69.00357114975041,
          "chwPumpElectricity": 4.133293868579014,
          "chillerElectricity": 211.153560350979,
          "totalElectricity": 990.9717667449138,
          "totalGas": 69.00357114975041,
          "eui": 235.55007508770314
        },
        "open-lab-general": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 11585346,
          "fanShare": 0.11498829725055064,
          "fanElectricity": 193.7979415254578,
          "reheatFlow": 3529.5,
          "mainHeatCoilFlow": 141.3551138101019,
          "heatingShare": 0.08988667890530555,
          "chwFlow": 5226,
          "mainCoolCoilFlow": 3714.3864742764617,
          "coolingShare": 0.08218913784449881,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 161.91916677965028,
          "heatingGas": 69.90549141740702,
          "chwPumpElectricity": 4.1960842435130425,
          "chillerElectricity": 214.3612711125782,
          "totalElectricity": 969.3384636611993,
          "totalGas": 69.90549141740702,
          "eui": 230.9431011285792
        },
        "support-lab-bio": {
          "fanGroup": "lab",
          "area": 3000,
          "roomElectricity": 483.746,
          "airFlow": 7623431,
          "fanShare": 0.07566501249915734,
          "fanElectricity": 127.52361778071732,
          "reheatFlow": 2274,
          "mainHeatCoilFlow": 93.01499986521412,
          "heatingShare": 0.057960096669708236,
          "chwFlow": 5096,
          "mainCoolCoilFlow": 2444.1539332515304,
          "coolingShare": 0.06931677425487395,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 104.40757933791234,
          "heatingGas": 53.308936540965284,
          "chwPumpElectricity": 3.538898592808335,
          "chillerElectricity": 180.7882675057525,
          "totalElectricity": 900.0043632171904,
          "totalGas": 53.308936540965284,
          "eui": 317.7710999193852
        },
        "support-lab-chem": {
          "fanGroup": "lab",
          "area": 3000,
          "roomElectricity": 483.746,
          "airFlow": 8979200,
          "fanShare": 0.08912145728510347,
          "fanElectricity": 150.20271958605213,
          "reheatFlow": 2701,
          "mainHeatCoilFlow": 109.55700744057769,
          "heatingShare": 0.06882092249362927,
          "chwFlow": 5275.3,
          "mainCoolCoilFlow": 2878.8280496605976,
          "coolingShare": 0.0749610496373409,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 123.97194515234897,
          "heatingGas": 58.95477393314327,
          "chwPumpElectricity": 3.8270614281848028,
          "chillerElectricity": 195.50936176743215,
          "totalElectricity": 957.257087934018,
          "totalGas": 58.95477393314327,
          "eui": 338.73728728905377
        },
        "support-lab-general": {
          "fanGroup": "lab",
          "area": 6500,
          "roomElectricity": 1048.116,
          "airFlow": 17517574,
          "fanShare": 0.17386757428051933,
          "fanElectricity": 293.03136753273316,
          "reheatFlow": 5346.9,
          "mainHeatCoilFlow": 213.7354090630424,
          "heatingShare": 0.13616093090776743,
          "chwFlow": 11665.2,
          "mainCoolCoilFlow": 5616.32254468162,
          "coolingShare": 0.15886935566760266,
          "dhwDemand": 48.7,
          "dhwShare": 0.10107928601079287,
          "heatingElectricity": 245.27621610932502,
          "heatingGas": 120.95141573346629,
          "chwPumpElectricity": 8.110916084253786,
          "chillerElectricity": 414.3544745070352,
          "totalElectricity": 2008.8889742333472,
          "totalGas": 120.95141573346629,
          "eui": 327.6677523025867
        },
        "write-up": {
          "fanGroup": "lab",
          "area": 9000,
          "roomElectricity": 152.293,
          "airFlow": 5266636.5,
          "fanShare": 0.052273066628532254,
          "fanElectricity": 88.09951057679604,
          "reheatFlow": 686.5,
          "mainHeatCoilFlow": 64.2592808064547,
          "heatingShare": 0.018383525450282566,
          "chwFlow": 2357.5,
          "mainCoolCoilFlow": 1688.5402801548373,
          "coolingShare": 0.03719532296135473,
          "dhwDemand": 27,
          "dhwShare": 0.05603985056039851,
          "heatingElectricity": 33.11553124037551,
          "heatingGas": 37.37149957884864,
          "chwPumpElectricity": 1.8989700184690044,
          "chillerElectricity": 97.01083280036549,
          "totalElectricity": 372.41784463600607,
          "totalGas": 37.37149957884864,
          "eui": 45.53214935720609
        },
        "vivarium": {
          "fanGroup": "vivarium",
          "area": 4620,
          "roomElectricity": 612.582,
          "airFlow": 6070680,
          "fanShare": 1,
          "fanElectricity": 1566.452,
          "reheatFlow": 4102.3,
          "mainHeatCoilFlow": 186.6,
          "heatingShare": 0.10502048302223137,
          "chwFlow": 0,
          "mainCoolCoilFlow": 9969,
          "coolingShare": 0.09164520096857641,
          "dhwDemand": 28.8,
          "dhwShare": 0.059775840597758416,
          "heatingElectricity": 189.18074750175694,
          "heatingGas": 84.26276239335604,
          "chwPumpElectricity": 4.6788540902497004,
          "chillerElectricity": 239.0240643253887,
          "totalElectricity": 2611.9176659173954,
          "totalGas": 84.26276239335604,
          "eui": 583.5888372966995
        }
      },
      "repairs": [],
      "dataQuality": []
    },
    {
      "id": "ecm-5-cascade",
      "kind": "measure",
      "label": "Cascade air system",
      "measureNumber": 5,
      "locationId": "boston-5a",
      "description": "Office return air cascaded to serve the labs.",
      "note": "The Climate Zones workbook holds a hidden sheet of the same name with different figures. It feeds nothing and disagrees with the published results, so the measure workbook is treated as authoritative.",
      "provenance": {
        "kind": "simulated",
        "tool": "IES:VE",
        "completed": "2019-08-30",
        "workbook": "STEM Lab Zoned EUI Tool_ECM_SHARED.xlsx",
        "sheet": "ECM 5 - Cascade"
      },
      "prototype": {
        "totalArea": 115000,
        "totalElectricity": 0,
        "totalGas": 0,
        "blendedEui": 132.55611304347826
      },
      "plant": {
        "chillers": 2642.745,
        "chwPumps": 51.5,
        "hhwPumps": 173.272,
        "labFans": 1554.285,
        "hrcHeating": 1704.341,
        "generalFans": 196.475,
        "vivariumFans": 1551.276,
        "specialLabFans": 216.839,
        "auditoriumFans": 59.739,
        "dhwBoilers": 496.345,
        "hhwBoilers": 669.28
      },
      "zones": {
        "auditorium": {
          "fanGroup": "auditorium",
          "area": 1600,
          "roomElectricity": 40.143,
          "airFlow": 1128532,
          "fanShare": 1,
          "fanElectricity": 59.739,
          "reheatFlow": 484.2,
          "mainHeatCoilFlow": 53.9,
          "heatingShare": 0.012964796757957534,
          "chwFlow": 0,
          "mainCoolCoilFlow": 2360,
          "coolingShare": 0.021636488654595463,
          "dhwDemand": 77,
          "dhwShare": 0.15981735159817353,
          "heatingElectricity": 24.34287093509892,
          "heatingGas": 88.00162255316127,
          "chwPumpElectricity": 1.1142791657116664,
          "chillerElectricity": 57.17972220948889,
          "totalElectricity": 182.51887231029946,
          "totalGas": 88.00162255316127,
          "eui": 169.07530928966295
        },
        "atrium": {
          "fanGroup": "general",
          "area": 4770,
          "roomElectricity": 46.411,
          "airFlow": 6112888,
          "fanShare": 0.3096948525219061,
          "fanElectricity": 60.8472961492415,
          "reheatFlow": 287.7,
          "mainHeatCoilFlow": 193.43540488518255,
          "heatingShare": 0.011592311349923806,
          "chwFlow": 575.2,
          "mainCoolCoilFlow": 1992.4528031849352,
          "coolingShare": 0.02354025031569961,
          "dhwDemand": 74.6,
          "dhwShare": 0.15483603154836031,
          "heatingElectricity": 21.765874490664487,
          "heatingGas": 84.6105922191479,
          "chwPumpElectricity": 1.21232289125853,
          "chillerElectricity": 62.210878820563565,
          "totalElectricity": 192.44737235172806,
          "totalGas": 84.6105922191479,
          "eui": 58.083430727646956
        },
        "boh": {
          "fanGroup": "general",
          "area": 23040,
          "roomElectricity": 248.587,
          "airFlow": 765985,
          "fanShare": 0.03880679829386572,
          "fanElectricity": 7.624565694787267,
          "reheatFlow": 169.4,
          "mainHeatCoilFlow": 24.238726214348528,
          "heatingShare": 0.004665465024788724,
          "chwFlow": 72.4,
          "mainCoolCoilFlow": 249.6674175034145,
          "coolingShare": 0.00295271526475741,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 8.75993778158863,
          "heatingGas": 3.122502431790597,
          "chwPumpElectricity": 0.1520648361350066,
          "chillerElectricity": 7.8032735023613204,
          "totalElectricity": 272.9268418148722,
          "totalGas": 3.122502431790597,
          "eui": 11.981308344039185
        },
        "cafe-kitchen": {
          "fanGroup": "general",
          "area": 300,
          "roomElectricity": 18.226,
          "airFlow": 893295.5,
          "fanShare": 0.045256680333580844,
          "fanElectricity": 8.891806268540297,
          "reheatFlow": 830,
          "mainHeatCoilFlow": 28.267322536354595,
          "heatingShare": 0.020678798365880362,
          "chwFlow": 0,
          "mainCoolCoilFlow": 291.16337859412573,
          "coolingShare": 0.0026693869227057136,
          "dhwDemand": 9.7,
          "dhwShare": 0.02013283520132835,
          "heatingElectricity": 38.826780636155725,
          "heatingGas": 23.83273825831973,
          "chwPumpElectricity": 0.13747342651934424,
          "chillerElectricity": 7.054508943045911,
          "totalElectricity": 73.13656927426128,
          "totalGas": 23.83273825831973,
          "eui": 323.2310251086034
        },
        "computational": {
          "fanGroup": "general",
          "area": 6720,
          "roomElectricity": 101.855,
          "airFlow": 1940984.9,
          "fanShare": 0.0983353584022391,
          "fanElectricity": 19.320439542079928,
          "reheatFlow": 725.4,
          "mainHeatCoilFlow": 61.42026485803854,
          "heatingShare": 0.018957377474311067,
          "chwFlow": 1015.3,
          "mainCoolCoilFlow": 632.6503618166455,
          "coolingShare": 0.01510841496050099,
          "dhwDemand": 5.1,
          "dhwShare": 0.010585305105853052,
          "heatingElectricity": 35.59461839167362,
          "heatingGas": 17.941756858771544,
          "chwPumpElectricity": 0.778083370465801,
          "chillerElectricity": 39.92768809478919,
          "totalElectricity": 197.47582939900855,
          "totalGas": 17.941756858771544,
          "eui": 32.05618843121727
        },
        "office": {
          "fanGroup": "general",
          "area": 10420,
          "roomElectricity": 157.935,
          "airFlow": 4113289,
          "fanShare": 0.20838995090945206,
          "fanElectricity": 40.94341560493459,
          "reheatFlow": 1812.2,
          "mainHeatCoilFlow": 130.16036333804377,
          "heatingShare": 0.04679856409847665,
          "chwFlow": 1444.6,
          "mainCoolCoilFlow": 1340.697588171051,
          "coolingShare": 0.025535618502599597,
          "dhwDemand": 7.9,
          "dhwShare": 0.016396845163968454,
          "heatingElectricity": 87.86959233263303,
          "heatingGas": 39.45983509273837,
          "chwPumpElectricity": 1.3150843528838791,
          "chillerElectricity": 67.48412811965257,
          "totalElectricity": 355.54722041010405,
          "totalGas": 39.45983509273837,
          "eui": 37.908546593363
        },
        "restroom": {
          "fanGroup": "general",
          "area": 1000,
          "roomElectricity": 6.042,
          "airFlow": 39423.8,
          "fanShare": 0.0019973125512610605,
          "fanElectricity": 0.39242198350901686,
          "reheatFlow": 290.4,
          "mainHeatCoilFlow": 1.2475214195176585,
          "heatingShare": 0.007026855306013962,
          "chwFlow": 0,
          "mainCoolCoilFlow": 12.84991002979316,
          "coolingShare": 0.00011780802227635259,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 13.193714871690792,
          "heatingGas": 4.702933719209025,
          "chwPumpElectricity": 0.006067113147232159,
          "chillerElectricity": 0.3113365618307194,
          "totalElectricity": 19.94554053017776,
          "totalGas": 4.702933719209025,
          "eui": 24.648474249386787
        },
        "classroom": {
          "fanGroup": "general",
          "area": 7500,
          "roomElectricity": 133.669,
          "airFlow": 5030935,
          "fanShare": 0.2548802910951903,
          "fanElectricity": 50.07760519292751,
          "reheatFlow": 391.4,
          "mainHeatCoilFlow": 159.19822981805586,
          "heatingShare": 0.013265924818588157,
          "chwFlow": 339.7,
          "mainCoolCoilFlow": 1639.7978407900164,
          "coolingShare": 0.018148043463580257,
          "dhwDemand": 28.2,
          "dhwShare": 0.05853051058530511,
          "heatingElectricity": 24.908272896403762,
          "heatingGas": 37.92994443904795,
          "chwPumpElectricity": 0.9346242383743832,
          "chillerElectricity": 47.9606511231594,
          "totalElectricity": 257.5501534508651,
          "totalGas": 37.92994443904795,
          "eui": 39.39734638532174
        },
        "corridor": {
          "fanGroup": "general",
          "area": 5790,
          "roomElectricity": 49.653,
          "airFlow": 841621.8,
          "fanShare": 0.04263875589250468,
          "fanElectricity": 8.377449563979857,
          "reheatFlow": 230.1,
          "mainHeatCoilFlow": 26.632166930458425,
          "heatingShare": 0.00618561673570604,
          "chwFlow": 16.3,
          "mainCoolCoilFlow": 274.32069991001816,
          "coolingShare": 0.0026644116425397035,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 11.614194395979224,
          "heatingGas": 4.139909568873338,
          "chwPumpElectricity": 0.13721719959079473,
          "chillerElectricity": 7.041360546263588,
          "totalElectricity": 76.82322170581347,
          "totalGas": 4.139909568873338,
          "eui": 13.983269650204976
        },
        "mri-lab": {
          "fanGroup": "special-lab",
          "area": 2550,
          "roomElectricity": 184.56,
          "airFlow": 1942383,
          "fanShare": 0.4576821827955375,
          "fanElectricity": 99.24334683520156,
          "reheatFlow": 475.9,
          "mainHeatCoilFlow": 88.74457524405473,
          "heatingShare": 0.01360435264546075,
          "chwFlow": 16.3,
          "mainCoolCoilFlow": 1598.7754009413716,
          "coolingShare": 0.014807017198637374,
          "dhwDemand": 9.6,
          "dhwShare": 0.019925280199252802,
          "heatingElectricity": 25.54370938370149,
          "heatingGas": 18.9949343390521,
          "chwPumpElectricity": 0.7625613857298248,
          "chillerElectricity": 39.131170666612924,
          "totalElectricity": 349.24078827124583,
          "totalGas": 18.9949343390521,
          "eui": 144.40616572952862
        },
        "nmr-lab": {
          "fanGroup": "special-lab",
          "area": 1800,
          "roomElectricity": 313.741,
          "airFlow": 2301572.9,
          "fanShare": 0.5423178172044624,
          "fanElectricity": 117.59565316479842,
          "reheatFlow": 37.2,
          "mainHeatCoilFlow": 105.15542475594526,
          "heatingShare": 0.0034298627566503375,
          "chwFlow": 1095.7,
          "mainCoolCoilFlow": 1894.4245990586278,
          "coolingShare": 0.027413473289558815,
          "dhwDemand": 6.7,
          "dhwShare": 0.013906185139061854,
          "heatingElectricity": 6.43995490010251,
          "heatingGas": 9.197804008618593,
          "chwPumpElectricity": 1.4117938744122789,
          "chillerElectricity": 72.4468194686151,
          "totalElectricity": 511.63522140792827,
          "totalGas": 9.197804008618593,
          "eui": 289.3516807869705
        },
        "core-lab": {
          "fanGroup": "lab",
          "area": 2750,
          "roomElectricity": 443.434,
          "airFlow": 6789991,
          "fanShare": 0.0695012845804343,
          "fanElectricity": 108.02480410410033,
          "reheatFlow": 1989.3,
          "mainHeatCoilFlow": 146.2863037848981,
          "heatingShare": 0.05145408360462546,
          "chwFlow": 4883.5,
          "mainCoolCoilFlow": 2195.6359315658738,
          "coolingShare": 0.0649015441812136,
          "dhwDemand": 10.3,
          "dhwShare": 0.021378165213781657,
          "heatingElectricity": 96.61085627913161,
          "heatingGas": 45.048134487938185,
          "chwPumpElectricity": 3.3424295253325007,
          "chillerElectricity": 171.51823137718134,
          "totalElectricity": 822.9303212857458,
          "totalGas": 45.048134487938185,
          "eui": 315.6285293722487
        },
        "instruction-lab": {
          "fanGroup": "lab",
          "area": 7140,
          "roomElectricity": 217.925,
          "airFlow": 17716316,
          "fanShare": 0.1813414362453354,
          "fanElectricity": 281.8562742345812,
          "reheatFlow": 6295.2,
          "mainHeatCoilFlow": 381.68745500918203,
          "heatingShare": 0.1608706352535781,
          "chwFlow": 5875.8,
          "mainCoolCoilFlow": 5728.811714857265,
          "coolingShare": 0.1063911227582605,
          "dhwDemand": 35.7,
          "dhwShare": 0.07409713574097138,
          "heatingElectricity": 302.0527960703765,
          "heatingGas": 144.44524160186717,
          "chwPumpElectricity": 5.479142822050416,
          "chillerElectricity": 281.16460771377916,
          "totalElectricity": 1088.4778208407872,
          "totalGas": 144.44524160186717,
          "eui": 172.6783000619964
        },
        "open-lab-bio": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 11120749,
          "fanShare": 0.11383024528259021,
          "fanElectricity": 176.92464278905075,
          "reheatFlow": 3203,
          "mainHeatCoilFlow": 239.5899002707959,
          "heatingShare": 0.0829445797770083,
          "chwFlow": 5444,
          "mainCoolCoilFlow": 3596.045427795892,
          "coolingShare": 0.0828791696337006,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 155.73782126884785,
          "heatingGas": 78.69239804182361,
          "chwPumpElectricity": 4.268277236135581,
          "chillerElectricity": 219.02851115361406,
          "totalElectricity": 951.0232524476482,
          "totalGas": 78.69239804182361,
          "eui": 228.82570010877154
        },
        "open-lab-chem": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 12871177,
          "fanShare": 0.13174735217795436,
          "fanElectricity": 204.7729332799118,
          "reheatFlow": 3559.4,
          "mainHeatCoilFlow": 277.30182686415833,
          "heatingShare": 0.09244017730194795,
          "chwFlow": 5204,
          "mainCoolCoilFlow": 4162.070126859409,
          "coolingShare": 0.08586816527031317,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 173.56687862444238,
          "heatingGas": 85.04761155331522,
          "chwPumpElectricity": 4.422210511421128,
          "chillerElectricity": 226.92766442729376,
          "totalElectricity": 1004.7536868430691,
          "totalGas": 85.04761155331522,
          "eui": 242.17806631030763
        },
        "open-lab-general": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 11265286,
          "fanShare": 0.11530970338045843,
          "fanElectricity": 179.22414231869584,
          "reheatFlow": 3147.6,
          "mainHeatCoilFlow": 242.70386367518893,
          "heatingShare": 0.08168481795254968,
          "chwFlow": 5143.5,
          "mainCoolCoilFlow": 3642.7834324030764,
          "coolingShare": 0.08055267872934291,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 153.37247609034065,
          "heatingGas": 77.84926464794995,
          "chwPumpElectricity": 4.148462954561159,
          "chillerElectricity": 212.8801889485773,
          "totalElectricity": 944.689270312175,
          "totalGas": 77.84926464794995,
          "eui": 227.23078554669445
        },
        "support-lab-bio": {
          "fanGroup": "lab",
          "area": 3000,
          "roomElectricity": 483.746,
          "airFlow": 7399691,
          "fanShare": 0.07574207830294302,
          "fanElectricity": 117.7247761750898,
          "reheatFlow": 2249.5,
          "mainHeatCoilFlow": 159.42192641203448,
          "heatingShare": 0.058039738304626574,
          "chwFlow": 5246.9,
          "mainCoolCoilFlow": 2392.790718291764,
          "coolingShare": 0.0700407125215839,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 108.97616715736481,
          "heatingGas": 62.024085741187974,
          "chwPumpElectricity": 3.6070966948615713,
          "chillerElectricity": 185.09974281285326,
          "totalElectricity": 899.1537828401695,
          "totalGas": 62.024085741187974,
          "eui": 320.3926228604525
        },
        "support-lab-chem": {
          "fanGroup": "lab",
          "area": 3000,
          "roomElectricity": 483.746,
          "airFlow": 8778969,
          "fanShare": 0.08986015191946656,
          "fanElectricity": 139.6682862261481,
          "reheatFlow": 2588.3,
          "mainHeatCoilFlow": 189.13764776009322,
          "heatingShare": 0.06691862964339204,
          "chwFlow": 5349.9,
          "mainCoolCoilFlow": 2838.7990173334438,
          "coolingShare": 0.07507402262052205,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 125.64728896061825,
          "heatingGas": 67.96655013639692,
          "chwPumpElectricity": 3.8663121649568857,
          "chillerElectricity": 198.40149791027156,
          "totalElectricity": 951.3293852619947,
          "totalGas": 67.96655013639692,
          "eui": 339.7653117994639
        },
        "support-lab-general": {
          "fanGroup": "lab",
          "area": 6500,
          "roomElectricity": 1048.116,
          "airFlow": 17158742,
          "fanShare": 0.1756341960960258,
          "fanElectricity": 272.98559647911145,
          "reheatFlow": 4876,
          "mainHeatCoilFlow": 369.67485594291514,
          "heatingShare": 0.12638748999373361,
          "chwFlow": 11425.9,
          "mainCoolCoilFlow": 5548.512579128379,
          "coolingShare": 0.1556214767740397,
          "dhwDemand": 48.7,
          "dhwShare": 0.10107928601079287,
          "heatingElectricity": 237.30679424960414,
          "heatingGas": 134.75881751803303,
          "chwPumpElectricity": 8.014506053863045,
          "chillerElectricity": 411.26787963720955,
          "totalElectricity": 1977.690776419788,
          "totalGas": 134.75881751803303,
          "eui": 324.9922452212033
        },
        "write-up": {
          "fanGroup": "lab",
          "area": 9000,
          "roomElectricity": 152.293,
          "airFlow": 4594985.5,
          "fanShare": 0.04703355201479194,
          "fanElectricity": 73.1035443933109,
          "reheatFlow": 547.6,
          "mainHeatCoilFlow": 98.99622028073408,
          "heatingShare": 0.015578867460329411,
          "chwFlow": 2206.9,
          "mainCoolCoilFlow": 1485.8510517648965,
          "coolingShare": 0.033855155184642646,
          "dhwDemand": 27,
          "dhwShare": 0.05603985056039851,
          "heatingElectricity": 29.251084068791485,
          "heatingGas": 38.24172404025027,
          "chwPumpElectricity": 1.7435404920090962,
          "chillerElectricity": 89.47054208843842,
          "totalElectricity": 345.8617110425499,
          "totalGas": 38.24172404025027,
          "eui": 42.67815945364447
        },
        "vivarium": {
          "fanGroup": "vivarium",
          "area": 4620,
          "roomElectricity": 612.582,
          "airFlow": 6070680,
          "fanShare": 1,
          "fanElectricity": 1551.276,
          "reheatFlow": 4153.9,
          "mainHeatCoilFlow": 183.8,
          "heatingShare": 0.10451105537445157,
          "chwFlow": 0,
          "mainCoolCoilFlow": 9841,
          "coolingShare": 0.09022232408892963,
          "dhwDemand": 28.8,
          "dhwShare": 0.059775840597758416,
          "heatingElectricity": 196.23131621479013,
          "heatingGas": 99.61659874250735,
          "chwPumpElectricity": 4.6464496905798764,
          "chillerElectricity": 238.43459587439833,
          "totalElectricity": 2603.1703617797684,
          "totalGas": 99.61659874250735,
          "eui": 585.0188226238693
        }
      },
      "repairs": [],
      "dataQuality": []
    },
    {
      "id": "ecm-6-shading",
      "kind": "measure",
      "label": "External shading",
      "measureNumber": 6,
      "locationId": "boston-5a",
      "description": "External shading added to the office facade.",
      "note": "The sheet title duplicates ECM 4’s. Slide 29 of the 2019 presentation names this measure External Shading. The Climate Zones workbook holds a hidden sheet of the same name with different figures. It feeds nothing and disagrees with the published results, so the measure workbook is treated as authoritative.",
      "provenance": {
        "kind": "simulated",
        "tool": "IES:VE",
        "completed": "2019-08-30",
        "workbook": "STEM Lab Zoned EUI Tool_ECM_SHARED.xlsx",
        "sheet": "ECM 6 - Shade"
      },
      "prototype": {
        "totalArea": 115000,
        "totalElectricity": 0,
        "totalGas": 0,
        "blendedEui": 133.72804347826087
      },
      "plant": {
        "chillers": 2576.572,
        "chwPumps": 49.774,
        "hhwPumps": 163.873,
        "labFans": 1694.88,
        "hrcHeating": 1614.285,
        "generalFans": 336.748,
        "vivariumFans": 1553.805,
        "specialLabFans": 216.839,
        "auditoriumFans": 59.962,
        "dhwBoilers": 496.345,
        "hhwBoilers": 687.786
      },
      "zones": {
        "auditorium": {
          "fanGroup": "auditorium",
          "area": 1600,
          "roomElectricity": 40.143,
          "airFlow": 113540.8,
          "fanShare": 1,
          "fanElectricity": 59.962,
          "reheatFlow": 509.7,
          "mainHeatCoilFlow": 54.8,
          "heatingShare": 0.013572354232434681,
          "chwFlow": 0,
          "mainCoolCoilFlow": 2334.6,
          "coolingShare": 0.021365640177580265,
          "dhwDemand": 77,
          "dhwShare": 0.15981735159817353,
          "heatingElectricity": 24.13379025723759,
          "heatingGas": 88.65941860710475,
          "chwPumpElectricity": 1.06345337419888,
          "chillerElectricity": 55.05011024362834,
          "totalElectricity": 180.3523538750648,
          "totalGas": 88.65941860710475,
          "eui": 168.13235780135602
        },
        "atrium": {
          "fanGroup": "general",
          "area": 4770,
          "roomElectricity": 46.411,
          "airFlow": 5991680,
          "fanShare": 0.30181457571253223,
          "fanElectricity": 101.6354547420438,
          "reheatFlow": 315.6,
          "mainHeatCoilFlow": 75.72527704627434,
          "heatingShare": 0.009408689601731933,
          "chwFlow": 350.1,
          "mainCoolCoilFlow": 1987.931884388165,
          "coolingShare": 0.021397047873531857,
          "dhwDemand": 74.6,
          "dhwShare": 0.15483603154836031,
          "heatingElectricity": 16.730136684836452,
          "heatingGas": 83.3232550652877,
          "chwPumpElectricity": 1.0650166608571747,
          "chillerElectricity": 55.13103443360173,
          "totalElectricity": 220.97264252133917,
          "totalGas": 83.3232550652877,
          "eui": 63.793689221515066
        },
        "boh": {
          "fanGroup": "general",
          "area": 23040,
          "roomElectricity": 248.587,
          "airFlow": 761470.8,
          "fanShare": 0.03835701947024583,
          "fanElectricity": 12.916649592566342,
          "reheatFlow": 176.3,
          "mainHeatCoilFlow": 9.623776185084678,
          "heatingShare": 0.004470191940860712,
          "chwFlow": 67.1,
          "mainCoolCoilFlow": 252.64234444272117,
          "coolingShare": 0.002926197156214817,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 7.948707561177003,
          "heatingGas": 3.0745354342368256,
          "chwPumpElectricity": 0.1456485372534363,
          "chillerElectricity": 7.539557659182724,
          "totalElectricity": 277.1375633501795,
          "totalGas": 3.0745354342368256,
          "eui": 12.161983454184737
        },
        "cafe-kitchen": {
          "fanGroup": "general",
          "area": 300,
          "roomElectricity": 18.226,
          "airFlow": 948656.5,
          "fanShare": 0.04778598974652115,
          "fanElectricity": 16.091836475161504,
          "reheatFlow": 875.7,
          "mainHeatCoilFlow": 11.989504827402158,
          "heatingShare": 0.021342845718214414,
          "chwFlow": 0,
          "mainCoolCoilFlow": 314.74720006443624,
          "coolingShare": 0.0028804829193341953,
          "dhwDemand": 9.7,
          "dhwShare": 0.02013283520132835,
          "heatingElectricity": 37.95095185660871,
          "heatingGas": 24.67214257315114,
          "chwPumpElectricity": 0.14337315682694024,
          "chillerElectricity": 7.421771636434746,
          "totalElectricity": 79.8339331250319,
          "totalGas": 24.67214257315114,
          "eui": 348.3535856606102
        },
        "computational": {
          "fanGroup": "general",
          "area": 6720,
          "roomElectricity": 101.855,
          "airFlow": 1954006.1,
          "fanShare": 0.09842774013485364,
          "fanElectricity": 33.145344634931696,
          "reheatFlow": 776.6,
          "mainHeatCoilFlow": 24.69551999983478,
          "heatingShare": 0.019265662785297975,
          "chwFlow": 988.9,
          "mainCoolCoilFlow": 648.3041531722271,
          "coolingShare": 0.014983258302886064,
          "dhwDemand": 5.1,
          "dhwShare": 0.010585305105853052,
          "heatingElectricity": 34.25739240697988,
          "heatingGas": 18.504616407213586,
          "chwPumpElectricity": 0.745776698767851,
          "chillerElectricity": 38.605443811983754,
          "totalElectricity": 208.60895755266318,
          "totalGas": 18.504616407213586,
          "eui": 33.79666279164832
        },
        "office": {
          "fanGroup": "general",
          "area": 10420,
          "roomElectricity": 157.935,
          "airFlow": 4022461.8,
          "fanShare": 0.20262056743465418,
          "fanElectricity": 68.23207084248492,
          "reheatFlow": 1897.2,
          "mainHeatCoilFlow": 50.837500369354736,
          "heatingShare": 0.04683694422157571,
          "chwFlow": 1244.1,
          "mainCoolCoilFlow": 1334.5806294650934,
          "coolingShare": 0.02359940138012823,
          "dhwDemand": 7.9,
          "dhwShare": 0.016396845163968454,
          "heatingElectricity": 83.28348706314863,
          "heatingGas": 40.35228663129059,
          "chwPumpElectricity": 1.1746366042945025,
          "chillerElectricity": 60.80555681279976,
          "totalElectricity": 371.4307513227278,
          "totalGas": 40.35228663129059,
          "eui": 39.51852571535686
        },
        "restroom": {
          "fanGroup": "general",
          "area": 1000,
          "roomElectricity": 6.042,
          "airFlow": 400738,
          "fanShare": 0.02018608627995633,
          "fanElectricity": 6.797624182602735,
          "reheatFlow": 366.2,
          "mainHeatCoilFlow": 5.0646890476410436,
          "heatingShare": 0.008926370015499195,
          "chwFlow": 0,
          "mainCoolCoilFlow": 132.95767589156037,
          "coolingShare": 0.0012167933958478613,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 15.87249625402002,
          "heatingGas": 6.139432327480129,
          "chwPumpElectricity": 0.06056467448493145,
          "chillerElectricity": 3.1351557935265157,
          "totalElectricity": 31.9078409046342,
          "totalGas": 6.139432327480129,
          "eui": 38.04727323211433
        },
        "classroom": {
          "fanGroup": "general",
          "area": 7500,
          "roomElectricity": 133.669,
          "airFlow": 4891849,
          "fanShare": 0.246413581897694,
          "fanElectricity": 82.97928087688466,
          "reheatFlow": 400.8,
          "mainHeatCoilFlow": 61.82516769813142,
          "heatingShare": 0.011122963069687401,
          "chwFlow": 203.2,
          "mainCoolCoilFlow": 1623.0276985273513,
          "coolingShare": 0.016713151670121613,
          "dhwDemand": 28.2,
          "dhwShare": 0.05853051058530511,
          "heatingElectricity": 19.77838576606921,
          "heatingGas": 36.70154455431128,
          "chwPumpElectricity": 0.8318804112286332,
          "chillerElectricity": 43.06263862498859,
          "totalElectricity": 280.3211856791711,
          "totalGas": 36.70154455431128,
          "eui": 42.269697364464314
        },
        "corridor": {
          "fanGroup": "general",
          "area": 5790,
          "roomElectricity": 49.653,
          "airFlow": 881326.8,
          "fanShare": 0.04439443932354261,
          "fanElectricity": 14.949738653324326,
          "reheatFlow": 187.2,
          "mainHeatCoilFlow": 11.138564826276841,
          "heatingShare": 0.004768682479672168,
          "chwFlow": 9.5,
          "mainCoolCoilFlow": 292.40841404844576,
          "coolingShare": 0.0027629857539377242,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 8.479470900688904,
          "heatingGas": 3.2798330479638014,
          "chwPumpElectricity": 0.1375248529164963,
          "chillerElectricity": 7.1190317299948305,
          "totalElectricity": 80.33876613692456,
          "totalGas": 3.2798330479638014,
          "eui": 14.441899686509219
        },
        "mri-lab": {
          "fanGroup": "special-lab",
          "area": 2550,
          "roomElectricity": 184.56,
          "airFlow": 1942383,
          "fanShare": 0.4576821827955375,
          "fanElectricity": 99.24334683520156,
          "reheatFlow": 475.9,
          "mainHeatCoilFlow": 88.74457524405473,
          "heatingShare": 0.013575830275704037,
          "chwFlow": 16.3,
          "mainCoolCoilFlow": 1598.7754009413716,
          "coolingShare": 0.014780741829938543,
          "dhwDemand": 9.6,
          "dhwShare": 0.019925280199252802,
          "heatingElectricity": 24.13997121138534,
          "heatingGas": 19.227079202503507,
          "chwPumpElectricity": 0.7356966438433611,
          "chillerElectricity": 38.08364553824841,
          "totalElectricity": 346.76266022867867,
          "totalGas": 19.227079202503507,
          "eui": 143.5253880122283
        },
        "nmr-lab": {
          "fanGroup": "special-lab",
          "area": 1800,
          "roomElectricity": 313.741,
          "airFlow": 2301572.9,
          "fanShare": 0.5423178172044624,
          "fanElectricity": 117.59565316479842,
          "reheatFlow": 37.2,
          "mainHeatCoilFlow": 105.15542475594526,
          "heatingShare": 0.0034226718364860765,
          "chwFlow": 1095.7,
          "mainCoolCoilFlow": 1894.4245990586278,
          "coolingShare": 0.027364827494910517,
          "dhwDemand": 6.7,
          "dhwShare": 0.013906185139061854,
          "heatingElectricity": 6.08605130742241,
          "heatingGas": 9.256331234577068,
          "chwPumpElectricity": 1.362056923731676,
          "chillerElectricity": 70.50744830821658,
          "totalElectricity": 509.29220970416907,
          "totalGas": 9.256331234577068,
          "eui": 288.08252274374786
        },
        "core-lab": {
          "fanGroup": "lab",
          "area": 2750,
          "roomElectricity": 443.434,
          "airFlow": 6917314,
          "fanShare": 0.06879687851988976,
          "fanElectricity": 116.60245346579077,
          "reheatFlow": 2193.2,
          "mainHeatCoilFlow": 85.34252780392325,
          "heatingShare": 0.054783323863635054,
          "chwFlow": 4957.3,
          "mainCoolCoilFlow": 2240.487303693694,
          "coolingShare": 0.06587224090014354,
          "dhwDemand": 10.3,
          "dhwShare": 0.021378165213781657,
          "heatingElectricity": 97.4134055947136,
          "heatingGas": 48.290148599908555,
          "chwPumpElectricity": 3.2787249185637446,
          "chillerElectricity": 169.72457148056466,
          "totalElectricity": 830.4531554596329,
          "totalGas": 48.290148599908555,
          "eui": 319.54301965801506
        },
        "instruction-lab": {
          "fanGroup": "lab",
          "area": 7140,
          "roomElectricity": 217.925,
          "airFlow": 18155642,
          "fanShare": 0.18056885911563483,
          "fanElectricity": 306.04254793790716,
          "reheatFlow": 6344,
          "mainHeatCoilFlow": 223.995669732945,
          "heatingShare": 0.15791525921472557,
          "chwFlow": 5664.5,
          "mainCoolCoilFlow": 5880.531864161145,
          "coolingShare": 0.10565707043963236,
          "dhwDemand": 35.7,
          "dhwShare": 0.07409713574097138,
          "heatingElectricity": 280.79828149473803,
          "heatingGas": 145.38964731361168,
          "chwPumpElectricity": 5.258975024062261,
          "chillerElectricity": 272.23304929678443,
          "totalElectricity": 1082.2578537534919,
          "totalGas": 145.38964731361168,
          "eui": 171.9394259197624
        },
        "open-lab-bio": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 11359733,
          "fanShare": 0.11297942687282707,
          "fanElectricity": 191.48657101821715,
          "reheatFlow": 3396.6,
          "mainHeatCoilFlow": 140.15097903574198,
          "heatingShare": 0.08503460960032462,
          "chwFlow": 5420.8,
          "mainCoolCoilFlow": 3679.3671011392976,
          "coolingShare": 0.08328231638773062,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 151.20497133769405,
          "heatingGas": 81.66486368723636,
          "chwPumpElectricity": 4.145294015882904,
          "chillerElectricity": 214.58288449976786,
          "totalElectricity": 956.4837208715621,
          "totalGas": 81.66486368723636,
          "eui": 230.6996854575108
        },
        "open-lab-chem": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 13391433,
          "fanShare": 0.13318591425924037,
          "fanElectricity": 225.73414235970134,
          "reheatFlow": 3215.3,
          "mainHeatCoilFlow": 165.21712663858767,
          "heatingShare": 0.08127825674322615,
          "chwFlow": 4855.1,
          "mainCoolCoilFlow": 4337.425713906403,
          "coolingShare": 0.08412755792276122,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 144.52558245402153,
          "heatingGas": 79.08129678106404,
          "chwPumpElectricity": 4.187365068047517,
          "chillerElectricity": 216.76071017216472,
          "totalElectricity": 986.2718000539351,
          "totalGas": 79.08129678106404,
          "eui": 236.74513262999983
        },
        "open-lab-general": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 11503031,
          "fanShare": 0.11440461229857805,
          "fanElectricity": 193.902089292614,
          "reheatFlow": 3457.3,
          "mainHeatCoilFlow": 141.91892155638607,
          "heatingShare": 0.08653653527625298,
          "chwFlow": 5233.5,
          "mainCoolCoilFlow": 3725.780687344102,
          "coolingShare": 0.08199296128490452,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 153.87563249375145,
          "heatingGas": 82.69786714018042,
          "chwPumpElectricity": 4.081117654994838,
          "chillerElectricity": 211.260768243769,
          "totalElectricity": 958.1836076851293,
          "totalGas": 82.69786714018042,
          "eui": 231.3069944056244
        },
        "support-lab-bio": {
          "fanGroup": "lab",
          "area": 3000,
          "roomElectricity": 483.746,
          "airFlow": 7598067,
          "fanShare": 0.07556737953271794,
          "fanElectricity": 128.077640222413,
          "reheatFlow": 2267.9,
          "mainHeatCoilFlow": 93.74133431033661,
          "heatingShare": 0.05678128035291335,
          "chwFlow": 5137.6,
          "mainCoolCoilFlow": 2460.9801790281654,
          "coolingShare": 0.06954019102441926,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 100.9660879097757,
          "heatingGas": 62.232619377476354,
          "chwPumpElectricity": 3.4612934680494445,
          "chillerElectricity": 179.17530906816998,
          "totalElectricity": 895.4263306684081,
          "totalGas": 62.232619377476354,
          "eui": 319.2196500152948
        },
        "support-lab-chem": {
          "fanGroup": "lab",
          "area": 3000,
          "roomElectricity": 483.746,
          "airFlow": 8941984,
          "fanShare": 0.08893344829724341,
          "fanElectricity": 150.73152285003192,
          "reheatFlow": 2592.6,
          "mainHeatCoilFlow": 110.32194261273045,
          "heatingShare": 0.06498673882685643,
          "chwFlow": 5182.1,
          "mainCoolCoilFlow": 2896.268930661837,
          "coolingShare": 0.07393109046271938,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 115.5566895388854,
          "heatingGas": 67.87621883943578,
          "chwPumpElectricity": 3.6798460966913944,
          "chillerElectricity": 190.4887776157098,
          "totalElectricity": 944.2028361013186,
          "totalGas": 67.87621883943578,
          "eui": 337.3596849802514
        },
        "support-lab-general": {
          "fanGroup": "lab",
          "area": 6500,
          "roomElectricity": 1048.116,
          "airFlow": 17502614,
          "fanShare": 0.1740741000247382,
          "fanElectricity": 295.0347106499283,
          "reheatFlow": 5299.3,
          "mainHeatCoilFlow": 215.93892108068772,
          "heatingShare": 0.13260367814600169,
          "chwFlow": 11701.3,
          "mainCoolCoilFlow": 5669.018993275641,
          "coolingShare": 0.1589685536623471,
          "dhwDemand": 48.7,
          "dhwShare": 0.10107928601079287,
          "heatingElectricity": 235.79029112473808,
          "heatingGas": 141.3731515923529,
          "chwPumpElectricity": 7.912500789989665,
          "chillerElectricity": 409.59392424690105,
          "totalElectricity": 1996.447426811557,
          "totalGas": 141.3731515923529,
          "eui": 328.8954736006016
        },
        "write-up": {
          "fanGroup": "lab",
          "area": 9000,
          "roomElectricity": 152.293,
          "airFlow": 5177098.5,
          "fanShare": 0.051489381079130356,
          "fanElectricity": 87.26832220339647,
          "reheatFlow": 715.3,
          "mainHeatCoilFlow": 63.87257722866121,
          "heatingShare": 0.018733757708319674,
          "chwFlow": 2294.9,
          "mainCoolCoilFlow": 1676.8392267897145,
          "coolingShare": 0.0363483042914289,
          "dhwDemand": 27,
          "dhwShare": 0.05603985056039851,
          "heatingElectricity": 33.311581139110295,
          "heatingGas": 40.69991590557535,
          "chwPumpElectricity": 1.809200497801582,
          "chillerElectricity": 93.65402308477555,
          "totalElectricity": 368.3361269250839,
          "totalGas": 40.69991590557535,
          "eui": 45.448449203406575
        },
        "vivarium": {
          "fanGroup": "vivarium",
          "area": 4620,
          "roomElectricity": 612.582,
          "airFlow": 6070680,
          "fanShare": 1,
          "fanElectricity": 1553.805,
          "reheatFlow": 4167.8,
          "mainHeatCoilFlow": 184.1,
          "heatingShare": 0.10463335409058015,
          "chwFlow": 0,
          "mainCoolCoilFlow": 9865.8,
          "coolingShare": 0.09028918566948144,
          "dhwDemand": 28.8,
          "dhwShare": 0.059775840597758416,
          "heatingElectricity": 186.05463564299782,
          "heatingGas": 101.63479567803816,
          "chwPumpElectricity": 4.494053927512769,
          "chillerElectricity": 232.63658769878714,
          "totalElectricity": 2589.572277269298,
          "totalGas": 101.63479567803816,
          "eui": 582.5123534518044
        }
      },
      "repairs": [],
      "dataQuality": []
    },
    {
      "id": "recm-1-no-turndown",
      "kind": "reverse-measure",
      "label": "Night turndown removed",
      "locationId": "boston-5a",
      "description": "Unoccupied setback removed — labs held at 6 ACH overnight instead of 2.",
      "note": "A reverse measure. It raises energy use, and is included to show what the baseline control is worth.",
      "provenance": {
        "kind": "simulated",
        "tool": "IES:VE",
        "completed": "2019-08-30",
        "workbook": "STEM Lab Zoned EUI Tool_ECM_SHARED.xlsx",
        "sheet": "No Night Turndown"
      },
      "prototype": {
        "totalArea": 115000,
        "totalElectricity": 0,
        "totalGas": 0,
        "blendedEui": 144.41169565217393
      },
      "plant": {
        "chillers": 3181.628,
        "chwPumps": 61.866,
        "hhwPumps": 115.515,
        "labFans": 2695.278,
        "hrcHeating": 1814.558,
        "generalFans": 326.775,
        "vivariumFans": 1558.343,
        "specialLabFans": 262.267,
        "auditoriumFans": 59.733,
        "dhwBoilers": 496.345,
        "hhwBoilers": 107.181
      },
      "zones": {
        "auditorium": {
          "fanGroup": "auditorium",
          "area": 1600,
          "roomElectricity": 40.143,
          "airFlow": 1127843.5,
          "fanShare": 1,
          "fanElectricity": 59.733,
          "reheatFlow": 479.3,
          "mainHeatCoilFlow": 54.1,
          "heatingShare": 0.011206070690263702,
          "chwFlow": 0,
          "mainCoolCoilFlow": 2357,
          "coolingShare": 0.015860273480371147,
          "dhwDemand": 77,
          "dhwShare": 0.15981735159817353,
          "heatingElectricity": 21.628534475369335,
          "heatingGas": 80.5256212416486,
          "chwPumpElectricity": 0.9812116791366413,
          "chillerElectricity": 50.461490192806295,
          "totalElectricity": 172.94723634731227,
          "totalGas": 80.5256212416486,
          "eui": 158.42053599310054
        },
        "atrium": {
          "fanGroup": "general",
          "area": 4770,
          "roomElectricity": 46.411,
          "airFlow": 5939377.5,
          "fanShare": 0.3040820520661364,
          "fanElectricity": 99.36641256391172,
          "reheatFlow": 269.1,
          "mainHeatCoilFlow": 76.81112635190605,
          "heatingShare": 0.007267162606764528,
          "chwFlow": 433.5,
          "mainCoolCoilFlow": 2030.1125960039399,
          "coolingShare": 0.016577670565256514,
          "dhwDemand": 74.6,
          "dhwShare": 0.15483603154836031,
          "heatingElectricity": 14.026154333925835,
          "heatingGas": 77.63099183422653,
          "chwPumpElectricity": 1.0255941671901596,
          "chillerElectricity": 52.743980845195956,
          "totalElectricity": 213.57314191022368,
          "totalGas": 77.63099183422653,
          "eui": 61.049084642442395
        },
        "boh": {
          "fanGroup": "general",
          "area": 23040,
          "roomElectricity": 248.587,
          "airFlow": 764101.8,
          "fanShare": 0.03912020128901195,
          "fanElectricity": 12.783503776216879,
          "reheatFlow": 177.4,
          "mainHeatCoilFlow": 9.881762845604417,
          "heatingShare": 0.003934556943091573,
          "chwFlow": 67.1,
          "mainCoolCoilFlow": 261.17428784570154,
          "coolingShare": 0.002208960535344465,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 7.593982122823582,
          "heatingGas": 0.4217097477174979,
          "chwPumpElectricity": 0.1366595524796207,
          "chillerElectricity": 7.02809069014694,
          "totalElectricity": 276.12923614166704,
          "totalGas": 0.4217097477174979,
          "eui": 12.003079248671204
        },
        "cafe-kitchen": {
          "fanGroup": "general",
          "area": 300,
          "roomElectricity": 18.226,
          "airFlow": 936617.4,
          "fanShare": 0.04795259115839148,
          "fanElectricity": 15.669707975783377,
          "reheatFlow": 891.5,
          "mainHeatCoilFlow": 12.112824526609689,
          "heatingShare": 0.018983781755294412,
          "chwFlow": 0,
          "mainCoolCoilFlow": 320.1410890916532,
          "coolingShare": 0.002154232170257736,
          "dhwDemand": 9.7,
          "dhwShare": 0.02013283520132835,
          "heatingElectricity": 36.640084603786356,
          "heatingGas": 12.027532800317532,
          "chwPumpElectricity": 0.1332737274451651,
          "chillerElectricity": 6.853965391392781,
          "totalElectricity": 77.52303169840768,
          "totalGas": 12.027532800317532,
          "eui": 298.50188166241736
        },
        "computational": {
          "fanGroup": "general",
          "area": 6720,
          "roomElectricity": 101.855,
          "airFlow": 1935637.4,
          "fanShare": 0.09910004754672705,
          "fanElectricity": 32.38341803708173,
          "reheatFlow": 756.7,
          "mainHeatCoilFlow": 25.03267201030325,
          "heatingShare": 0.016423231315028475,
          "chwFlow": 985.7,
          "mainCoolCoilFlow": 661.6117374314591,
          "coolingShare": 0.011084774994946242,
          "dhwDemand": 5.1,
          "dhwShare": 0.010585305105853052,
          "heatingElectricity": 31.698035333890957,
          "heatingGas": 7.0142216183407,
          "chwPumpElectricity": 0.6857706898373442,
          "chillerElectricity": 35.26763049762082,
          "totalElectricity": 201.88985455843084,
          "totalGas": 7.0142216183407,
          "eui": 31.086916097733862
        },
        "office": {
          "fanGroup": "general",
          "area": 10420,
          "roomElectricity": 157.935,
          "airFlow": 3949233,
          "fanShare": 0.20219137017764977,
          "fanElectricity": 66.07108498980149,
          "reheatFlow": 1456.9,
          "mainHeatCoilFlow": 51.07354010687433,
          "heatingShare": 0.031680648836679495,
          "chwFlow": 1759,
          "mainCoolCoilFlow": 1349.8700255800254,
          "coolingShare": 0.020919613415624795,
          "dhwDemand": 7.9,
          "dhwShare": 0.016396845163968454,
          "heatingElectricity": 61.1459649421565,
          "heatingGas": 11.534055735874068,
          "chwPumpElectricity": 1.2942128035710436,
          "chillerElectricity": 66.55842779232749,
          "totalElectricity": 353.00469052785655,
          "totalGas": 11.534055735874068,
          "eui": 34.984524593448235
        },
        "restroom": {
          "fanGroup": "general",
          "area": 1000,
          "roomElectricity": 6.042,
          "airFlow": 398627,
          "fanShare": 0.02040875768023968,
          "fanElectricity": 6.669071790960321,
          "reheatFlow": 369.3,
          "mainHeatCoilFlow": 5.155252190028543,
          "heatingShare": 0.007866839194566896,
          "chwFlow": 0,
          "mainCoolCoilFlow": 136.25294802481613,
          "coolingShare": 0.0009168472711838691,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 15.183573924775313,
          "heatingGas": 0.8431756917128744,
          "chwPumpElectricity": 0.05672167327906125,
          "chillerElectricity": 2.9170669497221913,
          "totalElectricity": 30.868434338736883,
          "totalGas": 0.8431756917128744,
          "eui": 31.71161003044976
        },
        "classroom": {
          "fanGroup": "general",
          "area": 7500,
          "roomElectricity": 133.669,
          "airFlow": 4796223,
          "fanShare": 0.24555525086708177,
          "fanElectricity": 80.24131710209063,
          "reheatFlow": 383,
          "mainHeatCoilFlow": 62.027256369024855,
          "heatingShare": 0.009349469242529808,
          "chwFlow": 229.4,
          "mainCoolCoilFlow": 1639.3759658388112,
          "coolingShare": 0.012575009712239404,
          "dhwDemand": 28.2,
          "dhwShare": 0.05853051058530511,
          "heatingElectricity": 18.045158149337233,
          "heatingGas": 30.053411739346856,
          "chwPumpElectricity": 0.777965550857403,
          "chillerElectricity": 40.00900300073283,
          "totalElectricity": 272.7424438030181,
          "totalGas": 30.053411739346856,
          "eui": 40.372780738981994
        },
        "corridor": {
          "fanGroup": "general",
          "area": 5790,
          "roomElectricity": 49.653,
          "airFlow": 812337,
          "fanShare": 0.041589729214761825,
          "fanElectricity": 13.590483764153795,
          "reheatFlow": 191.6,
          "mainHeatCoilFlow": 10.505565599648836,
          "heatingShare": 0.00424598660480951,
          "chwFlow": 37.6,
          "mainCoolCoilFlow": 277.6613501835929,
          "coolingShare": 0.0021213963647445226,
          "dhwDemand": 0,
          "dhwShare": 0,
          "heatingElectricity": 8.195064104304505,
          "heatingGas": 0.4550890902900881,
          "chwPumpElectricity": 0.13124230750128463,
          "chillerElectricity": 6.749494073169386,
          "totalElectricity": 78.31928424912897,
          "totalGas": 0.4550890902900881,
          "eui": 13.605245827188094
        },
        "mri-lab": {
          "fanGroup": "special-lab",
          "area": 2550,
          "roomElectricity": 184.56,
          "airFlow": 1981700,
          "fanShare": 0.3836860865806232,
          "fanElectricity": 100.62819886924031,
          "reheatFlow": 1902.1,
          "mainHeatCoilFlow": 12.23958616192188,
          "heatingShare": 0.04021789412767277,
          "chwFlow": 1682.7,
          "mainCoolCoilFlow": 193.9916853751631,
          "coolingShare": 0.01262827465778054,
          "dhwDemand": 9.6,
          "dhwShare": 0.019925280199252802,
          "heatingElectricity": 77.62347157267978,
          "heatingGas": 14.200407310996226,
          "chwPumpElectricity": 0.7812608399782509,
          "chillerElectricity": 40.178472242884986,
          "totalElectricity": 403.7714035247833,
          "totalGas": 14.200407310996226,
          "eui": 163.91051405324689
        },
        "nmr-lab": {
          "fanGroup": "special-lab",
          "area": 1800,
          "roomElectricity": 313.741,
          "airFlow": 3183199.3,
          "fanShare": 0.6163139134193768,
          "fanElectricity": 161.6388011307597,
          "reheatFlow": 3812.5,
          "mainHeatCoilFlow": 19.66041383807812,
          "heatingShare": 0.08050892481046064,
          "chwFlow": 11323,
          "mainCoolCoilFlow": 311.6083146248369,
          "coolingShare": 0.0782893804441875,
          "dhwDemand": 6.7,
          "dhwShare": 0.013906185139061854,
          "heatingElectricity": 155.3881020357002,
          "heatingGas": 15.531292532957636,
          "chwPumpElectricity": 4.843450810560103,
          "chillerElectricity": 249.08768492387938,
          "totalElectricity": 884.6990389008994,
          "totalGas": 15.531292532957636,
          "eui": 500.1279619076983
        },
        "core-lab": {
          "fanGroup": "lab",
          "area": 2750,
          "roomElectricity": 443.434,
          "airFlow": 10796567,
          "fanShare": 0.07212942856677493,
          "fanElectricity": 194.40886196859998,
          "reheatFlow": 1918,
          "mainHeatCoilFlow": 126.76747070610693,
          "heatingShare": 0.04295802178830962,
          "chwFlow": 10780.9,
          "mainCoolCoilFlow": 3793.2866483266935,
          "coolingShare": 0.09806982859415998,
          "dhwDemand": 10.3,
          "dhwShare": 0.021378165213781657,
          "heatingElectricity": 82.91211798702811,
          "heatingGas": 15.215229146327271,
          "chwPumpElectricity": 6.067188015806302,
          "chillerElectricity": 312.02171261038006,
          "totalElectricity": 1038.8438805818146,
          "totalGas": 15.215229146327271,
          "eui": 383.29422171932436
        },
        "instruction-lab": {
          "fanGroup": "lab",
          "area": 7140,
          "roomElectricity": 217.925,
          "airFlow": 26283808,
          "fanShare": 0.17559619197461818,
          "fanElectricity": 473.28055311296487,
          "reheatFlow": 6405,
          "mainHeatCoilFlow": 308.61030739539143,
          "heatingShare": 0.14104460384618633,
          "chwFlow": 5867,
          "mainCoolCoilFlow": 9234.60373594517,
          "coolingShare": 0.10161882275956088,
          "dhwDemand": 35.7,
          "dhwShare": 0.07409713574097138,
          "heatingElectricity": 272.2263816792204,
          "heatingGas": 51.89504452419054,
          "chwPumpElectricity": 6.286750088842994,
          "chillerElectricity": 323.3132918188562,
          "totalElectricity": 1293.0319766998844,
          "totalGas": 51.89504452419054,
          "eui": 188.3651290229797
        },
        "open-lab-bio": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 17659698,
          "fanShare": 0.11798045854777896,
          "fanElectricity": 317.99013435374053,
          "reheatFlow": 3403,
          "mainHeatCoilFlow": 207.3506558977215,
          "heatingShare": 0.0758489776277274,
          "chwFlow": 5188,
          "mainCoolCoilFlow": 6204.592315027696,
          "coolingShare": 0.07666085267998043,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 146.39406379688072,
          "heatingGas": 31.30881895978495,
          "chwPumpElectricity": 4.74270031189967,
          "chillerElectricity": 243.9063153905008,
          "totalElectricity": 1108.0972138530217,
          "totalGas": 31.30881895978495,
          "eui": 253.20134062506813
        },
        "open-lab-chem": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 20481716,
          "fanShare": 0.13683372419649426,
          "fanElectricity": 368.8049264848786,
          "reheatFlow": 3801,
          "mainHeatCoilFlow": 240.48527027533865,
          "heatingShare": 0.08490657973821701,
          "chwFlow": 5179,
          "mainCoolCoilFlow": 7196.0855554936325,
          "coolingShare": 0.08327205823212545,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 163.87589707507973,
          "heatingGas": 32.27962181158934,
          "chwPumpElectricity": 5.151709154588674,
          "chillerElectricity": 264.9407120889609,
          "totalElectricity": 1197.837244803508,
          "totalGas": 32.27962181158934,
          "eui": 273.3593036922438
        },
        "open-lab-general": {
          "fanGroup": "lab",
          "area": 4500,
          "roomElectricity": 395.064,
          "airFlow": 17710432,
          "fanShare": 0.11831940095687128,
          "fanElectricity": 318.9036783722341,
          "reheatFlow": 4071,
          "mainHeatCoilFlow": 207.94634718170127,
          "heatingShare": 0.08989534166922347,
          "chwFlow": 6531,
          "mainCoolCoilFlow": 6222.417296321861,
          "coolingShare": 0.085817855803547,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 173.50457178154315,
          "heatingGas": 32.814322304116544,
          "chwPumpElectricity": 5.309207467142239,
          "chillerElectricity": 273.04049292452765,
          "totalElectricity": 1165.8219505454472,
          "totalGas": 32.814322304116544,
          "eui": 266.3636161887919
        },
        "support-lab-bio": {
          "fanGroup": "lab",
          "area": 3000,
          "roomElectricity": 483.746,
          "airFlow": 11661022,
          "fanShare": 0.07790465741235997,
          "fanElectricity": 209.97470922107073,
          "reheatFlow": 2323,
          "mainHeatCoilFlow": 136.91743540222265,
          "heatingShare": 0.05167980628670697,
          "chwFlow": 5036,
          "mainCoolCoilFlow": 4097.005933316011,
          "coolingShare": 0.06145607628351474,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 99.7457987592034,
          "heatingGas": 28.71834300628304,
          "chwPumpElectricity": 3.8020416153559227,
          "chillerElectricity": 195.53037307376644,
          "totalElectricity": 992.7989226693965,
          "totalGas": 28.71834300628304,
          "eui": 340.5057552252265
        },
        "support-lab-chem": {
          "fanGroup": "lab",
          "area": 3000,
          "roomElectricity": 483.746,
          "airFlow": 13350642,
          "fanShare": 0.0891926274768253,
          "fanElectricity": 240.39892660048272,
          "reheatFlow": 2646,
          "mainHeatCoilFlow": 156.75604279052047,
          "heatingShare": 0.05888241909087801,
          "chwFlow": 5038,
          "mainCoolCoilFlow": 4690.640279006242,
          "coolingShare": 0.06546410497123176,
          "dhwDemand": 22.5,
          "dhwShare": 0.04669987546699876,
          "heatingElectricity": 113.64736726198821,
          "heatingGas": 29.4903262492469,
          "chwPumpElectricity": 4.050002318150224,
          "chillerElectricity": 208.28242937141016,
          "totalElectricity": 1050.1247255520314,
          "totalGas": 29.4903262492469,
          "eui": 359.8716839337594
        },
        "support-lab-general": {
          "fanGroup": "lab",
          "area": 6500,
          "roomElectricity": 1048.116,
          "airFlow": 26924170,
          "fanShare": 0.1798743060395684,
          "fanElectricity": 484.8112598337158,
          "reheatFlow": 5198.5,
          "mainHeatCoilFlow": 316.12909286454146,
          "heatingShare": 0.1158554995223563,
          "chwFlow": 5048.6,
          "mainCoolCoilFlow": 9459.589754620902,
          "coolingShare": 0.09762573492295556,
          "dhwDemand": 48.7,
          "dhwShare": 0.10107928601079287,
          "heatingElectricity": 223.6095715296128,
          "heatingGas": 62.58770650933266,
          "chwPumpElectricity": 6.039713716743569,
          "chillerElectricity": 310.6087717514533,
          "totalElectricity": 2073.1853168315256,
          "totalGas": 62.58770650933266,
          "eui": 328.58046512936284
        },
        "write-up": {
          "fanGroup": "lab",
          "area": 9000,
          "roomElectricity": 152.293,
          "airFlow": 4815191,
          "fanShare": 0.032169204828708754,
          "fanElectricity": 86.70495005231247,
          "reheatFlow": 674.1,
          "mainHeatCoilFlow": 56.53737748645563,
          "heatingShare": 0.01534978271665187,
          "chwFlow": 11295,
          "mainCoolCoilFlow": 1691.7784819417934,
          "coolingShare": 0.0873881452492983,
          "dhwDemand": 27,
          "dhwShare": 0.05603985056039851,
          "heatingElectricity": 29.626201177276428,
          "heatingGas": 29.460304687754466,
          "chwPumpElectricity": 5.406354993993089,
          "chillerElectricity": 278.0365697932345,
          "totalElectricity": 552.0670760168165,
          "totalGas": 29.460304687754466,
          "eui": 64.614153411619
        },
        "vivarium": {
          "fanGroup": "vivarium",
          "area": 4620,
          "roomElectricity": 612.582,
          "airFlow": 6070680,
          "fanShare": 1,
          "fanElectricity": 1558.343,
          "reheatFlow": 4191,
          "mainHeatCoilFlow": 183.1,
          "heatingShare": 0.0918944015865813,
          "chwFlow": 0,
          "mainCoolCoilFlow": 10000,
          "coolingShare": 0.06729008689168921,
          "dhwDemand": 28.8,
          "dhwShare": 0.059775840597758416,
          "heatingElectricity": 177.36290335341772,
          "heatingGas": 39.51877345794577,
          "chwPumpElectricity": 4.162968515641245,
          "chillerElectricity": 214.09202457703137,
          "totalElectricity": 2566.5428964460903,
          "totalGas": 39.51877345794577,
          "eui": 564.0826125333411
        }
      },
      "repairs": [],
      "dataQuality": []
    }
  ],
  "validation": {
    "note": "Residuals as published were computed against the baseline intensities held on this sheet, which predate the final 5A revision. Recomputing against the shipped baseline moves every residual — see docs/extraction.md.",
    "workbookBaselineEui": {
      "auditorium": 162.87381828765322,
      "atrium": 62.59613821027334,
      "boh": 12.050544870445671,
      "cafe-kitchen": 309.64800138553477,
      "computational": 31.946692382666367,
      "office": 37.29769903894643,
      "restroom": 32.80683207668785,
      "classroom": 41.404930372946225,
      "corridor": 14.173543692934473,
      "mri-lab": 179.79962177630287,
      "nmr-lab": 547.9511570311623,
      "core-lab": 304.00303311631427,
      "instruction-lab": 159.92738326449478,
      "open-lab-bio": 217.6518304144319,
      "open-lab-chem": 229.93706016458353,
      "open-lab-general": 220.47863413817822,
      "support-lab-bio": 307.9343380902162,
      "support-lab-chem": 324.596679228651,
      "support-lab-general": 312.4663513271976,
      "write-up": 43.99419699017213,
      "vivarium": 613.8844127936103
    },
    "projects": [
      {
        "name": "Boston Lab 1",
        "designedEui": 90.7,
        "workbookEstimatedEui": 86.32068769685327,
        "programme": {
          "auditorium": 3665,
          "atrium": 11874,
          "boh": 54944,
          "cafe-kitchen": 858,
          "office": 30639,
          "restroom": 4783,
          "classroom": 8892,
          "corridor": 28708,
          "open-lab-general": 20664,
          "support-lab-general": 29318,
          "write-up": 30326
        },
        "totalArea": 224671
      },
      {
        "name": "Boston Lab 2",
        "designedEui": 134.4,
        "workbookEstimatedEui": 96.62327336700896,
        "programme": {
          "atrium": 1342,
          "boh": 26800,
          "computational": 212,
          "office": 17474,
          "restroom": 3625,
          "classroom": 1760,
          "corridor": 36430,
          "open-lab-bio": 10993,
          "open-lab-general": 10015,
          "support-lab-bio": 3783,
          "support-lab-general": 11997,
          "write-up": 24257,
          "vivarium": 3889
        },
        "totalArea": 152577
      },
      {
        "name": "Western Mass Lab 1",
        "designedEui": 130.6,
        "workbookEstimatedEui": 89.74468045251116,
        "programme": {
          "boh": 13823,
          "office": 316,
          "restroom": 1653,
          "classroom": 3255,
          "corridor": 18036,
          "instruction-lab": 3014,
          "open-lab-general": 15790,
          "support-lab-general": 1927
        },
        "totalArea": 57814
      },
      {
        "name": "RI Lab 1",
        "designedEui": 64.8,
        "workbookEstimatedEui": 58.87760080524709,
        "programme": {
          "boh": 12558,
          "office": 5367,
          "restroom": 1446,
          "classroom": 5636,
          "corridor": 12626,
          "instruction-lab": 3013,
          "open-lab-general": 6807
        },
        "totalArea": 47453
      },
      {
        "name": "Maine Lab 1",
        "designedEui": 50,
        "workbookEstimatedEui": 54.25256310206461,
        "programme": {
          "boh": 5240,
          "office": 4038,
          "restroom": 703,
          "classroom": 5779,
          "corridor": 8675,
          "open-lab-general": 1979,
          "support-lab-general": 1540
        },
        "totalArea": 27954
      }
    ]
  }
}
